import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AfterViewChecked, Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { BaseResponseDTO } from 'src/app/core/models/app.models';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { ApiService } from 'src/app/shared/services/api.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { environment } from 'src/environments/environment'; 
import { ChangePassword, ConfirmEmail, DocumenDto, DocumentModel, VendorDto, VendorModel, UpdateVendorRequestDTO, ContactPersonDTO, SubsidiaryDTO } from 'src/app/modules/authentication/components/models/autentication-dto.models';
import { UserService } from 'src/app/shared/services/user.service';
import { lastValueFrom, of } from 'rxjs';
import { debounceTime, switchMap, filter } from 'rxjs/operators';
import en from 'src/assets/i18n/en';
import { FormValidationService } from 'src/app/shared/services/form-validation.service';
import { User } from 'src/app/shared/models/app.models';
import { GUID, Utils } from 'src/app/shared/helpers/utils.helper';
import { FileUploadComponent } from 'src/app/shared/components/file-upload/file-upload.component';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { DocumentProcessTypes, IconType, VendorStatus, VendorType } from 'src/app/modules/authentication/components/models/authentication-actions.enum';
import { countryCodes } from 'src/app/shared/data/countries';
import { ToastService } from 'src/app/shared/services/toast.service';
import { VendorService } from 'src/app/shared/services/vendor.service';

@Component({
  selector: 'app-vendor-application',
  templateUrl: './vendor-application.component.html',
  styleUrls: ['./vendor-application.component.scss']
})

export class VendorApplicationComponent  implements OnInit  {

  @ViewChildren('fileUpload') fileUploadComponents!: QueryList<FileUploadComponent>;
  @ViewChild('bankCertificateUpload') bankCertificateUploadComponent!: FileUploadComponent;
  
  // Helper to find the Document file upload component (Company Bank Details)
  private get documentFileUploadComponent(): FileUploadComponent | undefined {
    return this.fileUploadComponents.find((component) => {
      return component.label?.includes('Company Bank Details');
    });
  }

  showOtherBank: boolean = false;
  uploadPromises: Promise<void>[] = [];  // To track all file upload promises
  vendorType = VendorType;
  countryCodes = countryCodes;
  returnUrl;
  translations = en;
  invalidSubmit= false;
  email: string | null;
  AppConstants = AppConstants;
  user : User | null;
  vendor : VendorModel;
  nextButtonDisabled: boolean = true; 
  isBackAction = false;
  TempDocumentsArray : DocumentModel[] = [];
  // Bank documents ('Document' / 'bankCertificate') are NOT uploaded via the Documents API.
  // They are held here and sent with base64 content inside BankAccount.Documents of the UpdateVendor payload.
  BankTempDocumentsArray : DocumentModel[] = [];
   Countries: any[] = [];
   Currencies: any[] = [];
   MethodsOfPayment: any[] = [];
   Categories: any[] = [];
   SubCategories: any[] = [];
   SubSubCategories: any[] = []; // Third level categories
   TermsOfPayment: any[] = [];
   PreQualificationValuesMaster: any[] = [];
   DocumentsMaster: any[] = [];
   Banks: any[] = [];
   isViewMode = false;
   isAbleTBankApplication = true;
   isPageLoading = true; // Track page loading state
   private yearInterval: any = null;

  GeneralFormTab: FormGroup;
  bankAccountForm : FormGroup;
  businessCategoryForm: FormGroup;
  companyOwnershipForm: FormGroup;
  financialDetailsForm: FormGroup;
  capabilityExperienceForm: FormGroup;
  OtherDocuments: FormGroup;
  supportingDocumentsForm: FormGroup;
  warehousingStorageForm: FormGroup;
  taxLegalForm: FormGroup;
  attachmentsForm: FormGroup; // Individual - ATTACHMENTS step
  otherInformationForm: FormGroup;
  personalInformationForm: FormGroup;
  businessInformationForm: FormGroup;
  confirmCheckboxControl: FormControl; // Declare here

  hasSubsidiaries: boolean = false;

  selectedCompanyType: string = '';
  
  companyTypes: string[] = [
    'Limited Liability',
    'Public Shareholding Company',
    'Partnership',
    'Joint Venture',
    'Representative Office',
    'Branch',
    'Sole Trader',
    'Other'
  ];

  private normalizeCompanyTypeForForm(companyType: any): { selected: string; other: string } {
    let rawValue = '';

    if (Array.isArray(companyType)) {
      rawValue = companyType[0] || '';
    } else if (typeof companyType === 'string') {
      try {
        const parsed = JSON.parse(companyType);
        rawValue = Array.isArray(parsed) ? (parsed[0] || '') : String(parsed || '');
      } catch {
        rawValue = companyType;
      }
    } else if (companyType != null) {
      rawValue = String(companyType);
    }

    const trimmedValue = rawValue.trim();
    if (!trimmedValue) {
      return { selected: '', other: '' };
    }

    const matchedType = this.companyTypes.find(type =>
      type.toLocaleLowerCase() === trimmedValue.toLocaleLowerCase()
    );

    return matchedType
      ? { selected: matchedType, other: '' }
      : { selected: 'Other', other: trimmedValue };
  }

  natureOfBusinessOptions: string[] = [
    'Manufacturing',
    'Trading',
    'Services',
    'Construction',
    'Consulting',
    'Retail',
    'Wholesale',
    'Import/Export',
    'Technology',
    'Healthcare',
    'Education',
    'Real Estate',
    'Transportation',
    'Hospitality',
    'Other'
  ];

  // Capability & Experience selections
  selectedProductCategories: string[] = []; // Stores categoryId values
  selectedWorksCategories: string[] = []; // Stores subCategoryId values
  selectedSubSubCategories: string[] = []; // Stores subSubCategoryId values
  availableSubCategories: any[] = []; // Filtered SubCategories based on selected Categories
  
  // Validation flags for Categories and SubCategories
  categoriesValidationError: string = '';
  subCategoriesValidationError: string = '';
  
  // Tree structure for Categories and SubCategories
  categoryTree: any[] = []; // Tree structure with categories and their subcategories
  expandedCategories: Set<string> = new Set(); // Track which categories are expanded
  expandedSubCategories: Set<string> = new Set(); // Track which subcategories are expanded
  
  accountInfoForm: FormGroup;

  _VendorApplicationForm : FormGroup;
  isOrganization = false;
  isRegisteredInQNBN = false;

  defaultCountryCode = '+974';

  currentTab: number = 0;
  steps: { title: string }[] = [];

  // Initialize steps array - Banking Details only shown when status is Draft
  private initializeSteps(): void {
    const baseSteps: { title: string }[] = [];

    // Add Personal Information step if vendor type is Individual
    if (this.vendor?.vendorType === VendorType.Individual) {
      baseSteps.push({ title: 'PERSONAL INFORMATION' });
      baseSteps.push({ title: 'BUSINESS INFORMATION' });
      // Add Banking Details as step 3 for Individual
      if (this.isAbleTBankApplication) {
        baseSteps.push({ title: 'Banking Details' });
      }

      // Add TAX & LEGAL as step 4 for Individual
      baseSteps.push({ title: 'TAX & LEGAL' });
      // Add ATTACHMENTS as step 5 for Individual
      baseSteps.push({ title: 'Supporting Documents' });
    }

    // Only add Supplier Information and company-related steps if vendor type is NOT Individual
    if (this.vendor?.vendorType !== VendorType.Individual) {
      baseSteps.push(
        { title: 'Supplier Information' },
        { title: 'Company Ownership' },
        { title: 'Financial Details' },
        { title: 'Capability & Experience' },
        { title: 'Supporting Documents' },
        // { title: 'Compliance & Ethics' }, // Hidden for now
        { title: 'Warehousing & Storage' }
      );
    }

    // Only add Banking Details if vendor status is Draft (for Organization)
    const allowedStatuses = [VendorStatus.Draft, VendorStatus.ChangeRequested, 'Changerequested'].map(s => s.toString().toLocaleLowerCase())

    const isDraft = allowedStatuses.includes(this.vendor?.Status?.toString().toLocaleLowerCase() ?? '');
    if (isDraft && this.vendor?.vendorType !== VendorType.Individual) {
      baseSteps.push({ title: 'Banking Details' });
    }
    
    baseSteps.push({ title: 'Other' });
    this.steps = baseSteps;
  }

  allFiles : DocumenDto[] = [];

  public get VendorApplicationForm(): FormGroup {
    return this._VendorApplicationForm;
  }
  //#endregion
  //#region setters
  public set VendorApplicationForm(value: FormGroup) {
    this._VendorApplicationForm = value;
  }


  constructor(
    private _router: Router,
    private _activeRoute : ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _http: HttpClient,
    private _dialogService: DialogService,
    private _loaderService: LoaderService,
    private _userService: UserService,
    private formValidationService: FormValidationService,
    private notificationService: NotificationService,
    private toastService: ToastService,
    private vendorService: VendorService
  ) { }


 

  onCompanyTypeChange(): void {
    if (this.isViewMode) return;
    const selectedType = this.GeneralFormTab.get('companyType')?.value || '';
    this.selectedCompanyType = selectedType;
    
    // Update validator for the main company otherCompanyType field based on "Other" selection
    const isOtherSelected = selectedType === 'Other';
    
    // Update validator for GeneralFormTab otherCompanyType
    const generalOtherCompanyTypeControl = this.GeneralFormTab.get('otherCompanyType');
    if (generalOtherCompanyTypeControl) {
      if (isOtherSelected) {
        generalOtherCompanyTypeControl.setValidators(Validators.required);
      } else {
        generalOtherCompanyTypeControl.clearValidators();
        generalOtherCompanyTypeControl.setValue('');
      }
      generalOtherCompanyTypeControl.updateValueAndValidity();
    }
  }

  isCompanyTypeSelected(companyType: string): boolean {
    return this.selectedCompanyType === companyType;
  }

  toggleCompanyTypeSelectionForSubsidiary(index: number, companyType: string): void {
    if (this.isViewMode) return;
    const subsidiariesArray = this.GeneralFormTab.get('subsidiaries') as FormArray;
    if (!subsidiariesArray || index < 0 || index >= subsidiariesArray.length) return;
    
    const subsidiary = subsidiariesArray.at(index) as FormGroup;
    const companyTypeControl = subsidiary.get('companyType');
    if (!companyTypeControl) return;
    
    const currentSelection = companyTypeControl.value || [];
    const newSelection = this.toggleSelection(currentSelection, companyType);
    companyTypeControl.setValue(newSelection);
    
    // Update validators for otherCompanyType based on "Other" selection
    const isOtherSelected = newSelection.includes('Other');
    const otherCompanyTypeControl = subsidiary.get('otherCompanyType');
    if (otherCompanyTypeControl) {
      if (isOtherSelected) {
        otherCompanyTypeControl.setValidators(Validators.required);
      } else {
        otherCompanyTypeControl.clearValidators();
      }
      otherCompanyTypeControl.updateValueAndValidity();
    }
  }

  isCompanyTypeSelectedForSubsidiary(index: number, companyType: string): boolean {
    const subsidiariesArray = this.GeneralFormTab.get('subsidiaries') as FormArray;
    if (!subsidiariesArray || index < 0 || index >= subsidiariesArray.length) return false;
    
    const subsidiary = subsidiariesArray.at(index) as FormGroup;
    const companyTypeControl = subsidiary.get('companyType');
    if (!companyTypeControl) return false;
    
    const currentSelection = companyTypeControl.value || [];
    return currentSelection.includes(companyType);
  }

  private toggleSelection(selectionArray: string[], value: string): string[] {
    const index = selectionArray.indexOf(value);
    if (index === -1) {
      return [...selectionArray, value]; // Add
    } else {
      return selectionArray.filter(item => item !== value); // Remove
    }
  }

  // Helper: Extract category ID from various formats
  private getCategoryId(category: string | any): string {
    if (typeof category === 'string') return category;
    return category?.categoryId || category?.categoryID || category?.CategoryID || category;
  }

  // Helper: Extract subcategory ID from various formats
  private getSubCategoryId(subCategory: string | any): string {
    if (typeof subCategory === 'string') return subCategory;
    return subCategory?.subCategoryId || subCategory?.subCategoryID || subCategory?.SubCategoryID || subCategory?.id || subCategory;
  }

  // Helper: Find parent category ID for a subcategory
  private findParentCategoryId(subCategory: string | any): string | null {
    // Check if categoryId is directly provided
    if (typeof subCategory === 'object' && subCategory?.categoryId) {
      return this.getCategoryId(subCategory);
    }

    const subCategoryId = this.getSubCategoryId(subCategory);

    // Handle "Other" case
    if (subCategoryId === 'Other') {
      const selectedCategory = this.categoryTree.find(cat => 
        this.isProductCategorySelected(cat) && cat.subCategories?.length > 0
      );
      return selectedCategory ? this.getCategoryId(selectedCategory) : null;
    }

    // Find in SubCategories array
    const sub = this.SubCategories.find(s => this.getSubCategoryId(s) === subCategoryId);
    if (sub) {
      return sub.categoryId || sub.categoryID || sub.CategoryID || null;
    }

    // Find in categoryTree
    const categoryInTree = this.categoryTree.find(cat => 
      cat.subCategories?.some(s => this.getSubCategoryId(s) === subCategoryId)
    );
    return categoryInTree ? this.getCategoryId(categoryInTree) : null;
  }

  // Helper: Check if category has any selected subcategories
  private hasSelectedSubCategories(categoryId: string): boolean {
    const subCategories = this.SubCategories.filter(s => 
      (s.categoryId || s.categoryID || s.CategoryID) === categoryId
    );
    const subCategoryIds = subCategories.map(s => this.getSubCategoryId(s));
    
    return this.selectedWorksCategories.some(subId => 
      subCategoryIds.includes(subId) || 
      (subId === 'Other' && this.isProductCategorySelected(categoryId))
    );
  }

  // Helper: Auto-select and expand parent category
  private autoSelectParentCategory(categoryId: string): void {
    if (this.selectedProductCategories.includes(categoryId)) return;

    this.selectedProductCategories = [...this.selectedProductCategories, categoryId];
    this.availableSubCategories = this.getFilteredSubCategories();

    const categoryInTree = this.categoryTree.find(cat => this.getCategoryId(cat) === categoryId);
    if (categoryInTree?.subCategories?.length && !this.expandedCategories.has(categoryId)) {
      this.toggleCategoryExpand(categoryId);
    }
  }

  // Helper: Auto-deselect parent category if no subcategories selected
  private autoDeselectParentCategory(categoryId: string): void {
    const subCategories = this.SubCategories.filter(s => 
      (s.categoryId || s.categoryID || s.CategoryID) === categoryId
    );

    if (!this.hasSelectedSubCategories(categoryId) && 
        this.selectedProductCategories.includes(categoryId) &&
        subCategories.length > 0) {
      this.selectedProductCategories = this.selectedProductCategories.filter(id => id !== categoryId);
      this.availableSubCategories = this.getFilteredSubCategories();
    }
  }

  // Helper: Update "Other" field validator (no longer needed - fields removed)
  private updateOtherFieldValidator(): void {
    // Categories and SubCategories fields removed - using tree structure only
  }

  // Helper: Remove all child selections for a category
  private removeCategoryChildren(categoryId: string): void {
    const categoryInTree = this.categoryTree.find(cat => this.getCategoryId(cat) === categoryId);
    if (!categoryInTree?.subCategories) return;

    const subCategoryIds = categoryInTree.subCategories.map((sub: any) => this.getSubCategoryId(sub));
    this.selectedWorksCategories = this.selectedWorksCategories.filter(id => !subCategoryIds.includes(id));

    const subSubCategoryIds = categoryInTree.subCategories
      .flatMap((sub: any) => sub.subSubCategories || [])
      .map((subSub: any) => this.getSubSubCategoryId(subSub));
    this.selectedSubSubCategories = this.selectedSubSubCategories.filter(id => !subSubCategoryIds.includes(id));
  }

  // Helper: Remove all subsubcategories for a subcategory
  private removeSubCategoryChildren(subCategoryId: string): void {
    const categoryInTree = this.categoryTree.find(cat => 
      cat.subCategories?.some((sub: any) => this.getSubCategoryId(sub) === subCategoryId)
    );
    const subCategoryInTree = categoryInTree?.subCategories?.find((sub: any) => 
      this.getSubCategoryId(sub) === subCategoryId
    );
    if (!subCategoryInTree?.subSubCategories) return;

    const subSubCategoryIds = subCategoryInTree.subSubCategories.map((subSub: any) => 
      this.getSubSubCategoryId(subSub)
    );
    this.selectedSubSubCategories = this.selectedSubSubCategories.filter(id => 
      !subSubCategoryIds.includes(id)
    );
  }

  // Helper: Clear unavailable selections
  private clearUnavailableSelections(): void {
    const selectedLeafCategoryIds = this.categoryTree
      .filter(category =>
        this.selectedProductCategories.includes(this.getCategoryId(category)) &&
        (!category.subCategories || category.subCategories.length === 0)
      )
      .map(category => this.getCategoryId(category));

    const selectedLeafSubCategoryIds = this.categoryTree
      .flatMap(category => category.subCategories || [])
      .filter(subCategory =>
        this.selectedWorksCategories.includes(this.getSubCategoryId(subCategory)) &&
        (!subCategory.subSubCategories || subCategory.subSubCategories.length === 0)
      )
      .map(subCategory => this.getSubCategoryId(subCategory));

    const selectedLeafIds = [...selectedLeafCategoryIds, ...selectedLeafSubCategoryIds];

    if (this.availableSubCategories.length > 0) {
      const availableIds = this.availableSubCategories.map(s => this.getSubCategoryId(s));
      this.selectedWorksCategories = this.selectedWorksCategories.filter(id => availableIds.includes(id));

      const availableSubSubIds = this.SubSubCategories
        .filter(subSub => availableIds.includes(subSub.subCategoryId || subSub.subCategoryID || subSub.SubCategoryID || ''))
        .map(s => this.getSubSubCategoryId(s));
      this.selectedSubSubCategories = this.selectedSubSubCategories.filter(id =>
        availableSubSubIds.includes(id) || selectedLeafIds.includes(id)
      );
    } else {
      this.selectedWorksCategories = [];
      this.selectedSubSubCategories = this.selectedSubSubCategories.filter(id =>
        selectedLeafCategoryIds.includes(id)
      );
    }
  }

  // Helper: Update category other field validator (no longer needed - fields removed)
  private updateCategoryOtherValidator(): void {
    // Categories and SubCategories fields removed - using tree structure only
  }




  
  get documentFormControl(): FormControl {
    return this.bankAccountForm.get('Document') as FormControl;
  }

  get bankCertificateFormControl(): FormControl {
    return this.bankAccountForm.get('bankCertificate') as FormControl;
  }

  public get contacts() {
    return  this.GeneralFormTab ? this.GeneralFormTab.controls["contacts"] as FormArray: this._formBuilder.array([]);
  }

  public set contacts(value: any) {
    (this.GeneralFormTab.get('contacts') as FormArray).patchValue(value);
  }

  public get subsidiaries() {
    return this.GeneralFormTab ? this.GeneralFormTab.controls["subsidiaries"] as FormArray : this._formBuilder.array([]);
  }

  public set subsidiaries(value: any) {
    (this.GeneralFormTab.get('subsidiaries') as FormArray).patchValue(value);
  }

  public get primaryContacts(): FormArray {
    return this.GeneralFormTab ? (this.GeneralFormTab.get('primaryContacts') as FormArray) : this._formBuilder.array([]);
  }

  public getPrimaryContactForm(index: number): FormGroup {
    const arr = this.GeneralFormTab?.get('primaryContacts') as FormArray;
    return arr?.at(index) as FormGroup;
  }

  /** @deprecated Use primaryContacts and getPrimaryContactForm(i) for multi-contact support */
  public get primaryContactForm(): FormGroup {
    return this.getPrimaryContactForm(0);
  }

  public get mainOfficeForm(): FormGroup {
    return this.GeneralFormTab?.get('mainOffice') as FormGroup;
  }

  public get personalInformationFormGroup(): FormGroup {
    return this.personalInformationForm;
  }

  public get attachmentsFormGroup(): FormGroup {
    return this.attachmentsForm;
  }

  public get taxLegalFormGroup(): FormGroup {
    return this.taxLegalForm;
  }

  public getAttachmentControl(controlName: string): FormControl {
    console.log('Retrievings attachment control:', controlName, this.attachmentsForm);
    return this.attachmentsForm?.get(controlName) as FormControl;
  }





  public get partners(): FormArray {
    if (!this.companyOwnershipForm) {
      return this._formBuilder.array([]);
    }
    const partnersControl = this.companyOwnershipForm.get('partners');
    return partnersControl ? partnersControl as FormArray : this._formBuilder.array([]);
  }

  public get seniorManagement(): FormArray {
    if (!this.companyOwnershipForm) {
      return this._formBuilder.array([]);
    }
    const seniorManagementControl = this.companyOwnershipForm.get('seniorManagement');
    return seniorManagementControl ? seniorManagementControl as FormArray : this._formBuilder.array([]);
  } 

  public get annualTurnovers(): FormArray {
    if (!this.financialDetailsForm) {
      return this._formBuilder.array([]);
    }
    const annualTurnoversControl = this.financialDetailsForm.get('annualTurnovers');
    return annualTurnoversControl ? annualTurnoversControl as FormArray : this._formBuilder.array([]);
  }

  public get authorizedRepresentatives(): FormArray {
    if (!this.capabilityExperienceForm) {
      return this._formBuilder.array([]);
    }
    const authorizedRepresentativesControl = this.capabilityExperienceForm.get('authorizedRepresentatives');
    return authorizedRepresentativesControl ? authorizedRepresentativesControl as FormArray : this._formBuilder.array([]);
  }

  public deleteContact(index: number) {
    if (index !== 0) { // assuming the persistent contact is at index 0
      this.contacts.removeAt(index);
    }
  }


  

  public isTabOneValid() {
    if (!this.GeneralFormTab) {
      return false;
    }
    const formValid = this.GeneralFormTab.valid;
    // Check primaryContacts FormArray (Supplier Information tab)
    const primaryContactsArray = this.GeneralFormTab.get('primaryContacts') as FormArray;
    const primaryContactsValid = primaryContactsArray ? primaryContactsArray.valid : true;
    // Legacy: check contacts FormArray if it exists
    const contactsArray = this.GeneralFormTab.get('contacts') as FormArray;
    const contactsValid = contactsArray ? contactsArray.valid : true;
    return formValid && primaryContactsValid && contactsValid;
  }



  


  async ngOnInit(): Promise<void> {


   // this._dialogService.showDialog("test","hi",IconType.Success); 
    
    this.user = this._userService.user;

    const params = this._activeRoute.snapshot.queryParams;
    this.returnUrl = params['returnUrl'];
    this.isViewMode = params['viewMode'] === 'true' || this.user?.ContactType === 'Secondary';

    this._activeRoute.queryParams.subscribe(queryParams => {
      this.returnUrl = queryParams['returnUrl'];
      this.isViewMode = queryParams['viewMode'] === 'true' || this.user?.ContactType === 'Secondary';
    });

    // Initialize financialDetailsForm early to ensure it's available
    // Initialize YR 1-3 as default
    const defaultYears: FormGroup[] = [];
    for (let i = 1; i <= 3; i++) {
      defaultYears.push(this._formBuilder.group({
        yearNumber: [i],
        value: ['', [Validators.required, this.validNumberValidator(), this.positiveNumberValidator(), this.maxCharacterLengthValidator(16)]]
      }));
    }
    
    this.financialDetailsForm = this._formBuilder.group({
      currency: [''],
      authorizedCapital: [''],
      creditRating: [''],
      netProfit: [''],
      totalAssets: [''],
      currentRatio: [''],
      latestAnnualTurnover: [''],
      currentYear: [2025],
      annualTurnovers: this._formBuilder.array(defaultYears)
    });

    // Initialize capabilityExperienceForm early to ensure it's available
    this.capabilityExperienceForm = this._formBuilder.group({
      coreProductsServices: [''],
      previousExperience: [''],
      SubSubCategories: [[]],
      additionalInformation: [''],
      contractsProjectsDetails: ['', Validators.required],
      isAuthorizedRepresentative: [null],
      authorizedRepresentatives: this._formBuilder.array([])
    });

    // Add listener to automatically add one representative when "Yes" is selected for the first time
    // and clear all representatives when "No" is selected
    this.capabilityExperienceForm.get('isAuthorizedRepresentative')?.valueChanges.subscribe(value => {
      if (value === true && this.authorizedRepresentatives.length === 0) {
        this.addAuthorizedRepresentative();
      } else if (value === false) {
        // Clear all authorized representatives when "No" is selected
        while (this.authorizedRepresentatives.length > 0) {
          this.authorizedRepresentatives.removeAt(0);
        }
      }
    });

    // Initialize OtherDocuments early to ensure it's available
    // Documents will be added dynamically from DocumentsMaster
    this.OtherDocuments = this._formBuilder.group({});

    // Initialize Supporting Documents Form - will be populated dynamically from DocumentsMaster
    this.supportingDocumentsForm = this._formBuilder.group({});

    // Initialize Warehousing & Storage Form
    this.warehousingStorageForm = this._formBuilder.group({
      warehousingStorageDetails: [''],
      transportFreightForwardingDetails: ['']
    });

    // Initialize Other Information Form
    this.otherInformationForm = this._formBuilder.group({
      otherInformation: [(this.vendor as any)?.otherInformation || '']
    });

    // Don't initialize steps here - will be initialized after vendor data is loaded in initialize()
    await this.initialize();


    if (this.DocumentsMaster && this.DocumentsMaster.length > 0) {
      this.initializeFormControls();
    }
    // this.updateSelectedSubCategoryCount();
    // this.updateSelectedCategoryCount();


  }

  private removeDuplicates<T>(array: T[], key: keyof T): T[] {
    const seen = new Set();
    return array.filter(item => {
      const value = item[key];
      if (seen.has(value)) {
        return false; // Skip duplicates
      }
      seen.add(value);
      return true;
    });
  }

  

  private async loadLookupsAndProcessData() {
    const apiService = new ApiService(this._http);
  
    try {
      // Wait for the lookups to load
      await apiService.loadAllLookups();



      // Assign the lookups to their respective properties
      this.Countries = apiService.countries || [];
      this.Categories = apiService.categories || [];
      // Currencies are loaded from local storage (allLookups_v2_anon) in ApiService
      this.Currencies = apiService.currencies || [];
      this.MethodsOfPayment = apiService.methodsOfPayment || [];
      this.SubCategories = apiService.subCategories || [];
      this.TermsOfPayment = apiService.termsOfPayment || [];
      this.DocumentsMaster = apiService.documentsMaster || [];
      this.Banks = apiService.banks || [];
      
      // Load SubSubCategories and CategoryTree from API service
      this.SubSubCategories = (apiService as any).subSubCategories || [];
      
      // Use categoryTree from API if available, otherwise build it
      if ((apiService as any).categoryTree && (apiService as any).categoryTree.length > 0) {
        this.categoryTree = (apiService as any).categoryTree;
        
        // Extract Categories, SubCategories, and SubSubCategories from the tree structure
        // This ensures buildCategoryTree() can work properly later
        const extractedCategories: any[] = [];
        const extractedSubCategories: any[] = [];
        const extractedSubSubCategories: any[] = [];
        
        this.categoryTree.forEach((category: any) => {
          // Extract category
          extractedCategories.push({
            categoryId: category.categoryId || category.categoryID || category.CategoryID || '',
            description: category.description || category.Description || category.name || category.Name || ''
          });
          
          // Extract subcategories
          if (category.subCategories && category.subCategories.length > 0) {
            category.subCategories.forEach((subCategory: any) => {
              extractedSubCategories.push({
                subCategoryId: subCategory.subCategoryId || subCategory.subCategoryID || subCategory.SubCategoryID || '',
                description: subCategory.description || subCategory.Description || subCategory.name || subCategory.Name || '',
                categoryId: category.categoryId || category.categoryID || category.CategoryID || ''
              });
              
              // Extract subsubcategories
              if (subCategory.subSubCategories && subCategory.subSubCategories.length > 0) {
                subCategory.subSubCategories.forEach((subSubCategory: any) => {
                  extractedSubSubCategories.push({
                    subSubCategoryId: subSubCategory.subSubCategoryId || subSubCategory.subSubCategoryID || subSubCategory.SubSubCategoryID || '',
                    description: subSubCategory.description || subSubCategory.Description || subSubCategory.name || subSubCategory.Name || '',
                    subCategoryId: subCategory.subCategoryId || subCategory.subCategoryID || subCategory.SubCategoryID || ''
                  });
                });
              }
            });
          }
        });
        
        // Merge extracted data with existing arrays (if any)
        if (extractedCategories.length > 0) {
          this.Categories = [...this.Categories, ...extractedCategories];
        }
        if (extractedSubCategories.length > 0) {
          this.SubCategories = [...this.SubCategories, ...extractedSubCategories];
        }
        if (extractedSubSubCategories.length > 0) {
          this.SubSubCategories = [...this.SubSubCategories, ...extractedSubSubCategories];
        }
      }
  
      // Normalize categories to ensure they have categoryId and description
      if (this.Categories && this.Categories.length > 0) {
        this.Categories = this.Categories.map((cat: any) => ({
          categoryId: cat.categoryId || cat.categoryID || cat.CategoryID || cat.id || '',
          description: cat.description || cat.Description || cat.name || cat.Name || ''
        })).filter((cat: any) => cat.categoryId && cat.description);
      }
  
      // Normalize subcategories to ensure they have subCategoryId and description
      if (this.SubCategories && this.SubCategories.length > 0) {
        this.SubCategories = this.SubCategories.map((sub: any) => ({
          subCategoryId: sub.subCategoryId || sub.subCategoryID || sub.SubCategoryID || sub.id || '',
          description: sub.description || sub.Description || sub.name || sub.Name || '',
          categoryId: sub.categoryId || sub.categoryID || sub.CategoryID || ''
        })).filter((sub: any) => sub.subCategoryId && sub.description);
      }
  
      this.Categories = this.removeDuplicates(this.Categories, 'categoryId');
      this.SubCategories = this.removeDuplicates(this.SubCategories, 'subCategoryId');

      // Normalize SubSubCategories
      if (this.SubSubCategories && this.SubSubCategories.length > 0) {
        this.SubSubCategories = this.SubSubCategories.map((subSub: any) => ({
          subSubCategoryId: subSub.subSubCategoryId || subSub.subSubCategoryID || subSub.SubSubCategoryID || subSub.id || '',
          description: subSub.description || subSub.Description || subSub.name || subSub.Name || '',
          subCategoryId: subSub.subCategoryId || subSub.subCategoryID || subSub.SubCategoryID || ''
        }));
      }
      
      this.SubSubCategories = this.removeDuplicates(this.SubSubCategories, 'subSubCategoryId');

      // Build tree structure only if not already loaded from API
      if (!this.categoryTree || this.categoryTree.length === 0) {
        this.buildCategoryTree();
      }


      // Deduplicate DocumentsMaster before processing
      const uniqueDocs = new Map();
      this.DocumentsMaster.forEach(doc => {
        const key = `${doc.documentName}-${doc.parmDocumentFor}`;
        if (!uniqueDocs.has(key)) {
          uniqueDocs.set(key, doc);
        }
      });
      this.DocumentsMaster = Array.from(uniqueDocs.values());

      // Process the DocumentsMaster
      this.DocumentsMaster = this.DocumentsMaster.map(doc => {
        const parts = doc.parmDocumentFor.split(' '); // Split parmDocumentFor by space
        return {
          ...doc,
          entityType: parts[0],  // First part as entityType (e.g., Vendor, Investor)
          locationType: parts[1] // Second part as locationType (e.g., Foreign, Local)
        };
      });
  
      
      // Filter the DocumentsMaster based on vendorType and localOrForeign
      this.DocumentsMaster = this.DocumentsMaster.filter(doc =>
        doc.entityType.toLocaleLowerCase() === this.vendor.vendorType?.toLocaleLowerCase() &&
        doc.locationType.toLocaleLowerCase() === this.vendor.localOrForeign?.toLocaleLowerCase()
      );
  
      // Process PreQualificationValuesMaster
      this.PreQualificationValuesMaster = apiService.preQualifications.filter(criteria =>
        criteria.values && criteria.values.length > 0
      );
  
    } catch (error) {
      // Handle errors in case the lookups fail to load
    }
  }

  

private async initialize() {
  // Initialize vendor with defaults if it is missing
  if (!this.vendor) {
    this.vendor = {} as VendorModel;
  }

  if (this.user?.Id) {
    await this.GetProfile();
  }

  // If vendor was not loaded after GetProfile, use default values
  if (!this.vendor || !this.vendor.VendorID) {
    this.vendor = {
      VendorID: 'VENDOR001',
      vendorType: 'Organization',
      localOrForeign: 'Local',
      vendorName: '',
      Email: '',
      Status: VendorStatus.Draft,
      PhonePrimary: '',
      PhoneSecondary: '',
      StreetPrimary: '',
      CityPrimary: '',
      CountryRegionIdPrimary: 'QA',
      NumberofBranches: 0,
      contactPerson: [],
      Category: [],
      SubCategory: [],
      Attachments: []
    } as VendorModel;
  }

  const allowedStatuses = [VendorStatus.Draft, VendorStatus.ChangeRequested, 'Changerequested'].map(s => s.toString().toLocaleLowerCase())

  // For Individual, always allow bank application. For others, only when status is Draft
  this.isAbleTBankApplication = this.vendor?.vendorType === VendorType.Individual 
  || allowedStatuses.includes(this.vendor?.Status?.toString().toLocaleLowerCase() ?? '');

  console.log('Vendor data after initialization:', this.isAbleTBankApplication, this.steps, this.bankAccountForm);  
  // Initialize steps array based on vendor status (Banking Details only for Draft)
  this.initializeSteps();

  await this.loadLookupsAndProcessData();

  // initializeForm will be called after GetProfile completes and vendor data is loaded
  // Only call it here if vendor data is already available (e.g., from a previous load)
  if (this.vendor && this.vendor.VendorID) {
    await this.initializeForm();
  }

  // Mark page as loaded after all initialization is complete
  this.isPageLoading = false;
}

ngAfterViewInit() {
  if (this.isViewMode || this.isAbleToSubmitVendorFormApplication() || this.user?.ContactType === 'Secondary') {
    this.isViewMode = true;
    setTimeout(() => {
      this.disableAllForms();
      // Ensure all selected items are expanded in view mode so they're visible
      if (this.categoryTree && this.categoryTree.length > 0) {
        this.expandAllSelectedItemsInViewMode();
      }
    }, 200);
  }
  
  this.fileUploadComponents.changes.subscribe(() => {
    this.loadAttachments();
  });




}

private formatDateToInput(date: any): string | null {
  // Parse the date if it's not already a Date object
  const parsedDate = date instanceof Date ? date : new Date(date);

  // Ensure the date is valid
  if (isNaN(parsedDate.getTime())) {
    return null; // Invalid date
  }

  // Format the date as YYYY-MM-DD for the input field
  const year = parsedDate.getFullYear();
  const month = ('0' + (parsedDate.getMonth() + 1)).slice(-2); // Months are zero-based
  const day = ('0' + parsedDate.getDate()).slice(-2);

  return `${year}-${month}-${day}`;
}



  async loadAttachments(): Promise<void> {
   this._loaderService.showLoader();
    // if(this.isBackAction) {
    //   return;
    // }
    
    // Check if we have authorized representative attachments and ensure the section is visible
    if (this.vendor.Attachments && this.vendor.Attachments.length > 0) {
      const hasAuthorizedRepAttachments = this.vendor.Attachments.some(att => 
        att.AttachmentFor && att.AttachmentFor.startsWith('authorizedRepFile_')
      );
      
      if (hasAuthorizedRepAttachments) {
        // Ensure the form exists
        if (!this.capabilityExperienceForm) {
          return;
        }
        
        const isAuthorizedRepControl = this.capabilityExperienceForm.get('isAuthorizedRepresentative');
        if (!isAuthorizedRepControl) {
          return;
        }
        
        const isAuthorizedRep = isAuthorizedRepControl.value;
        
        // Check if value is false, null, or undefined
        if (isAuthorizedRep !== true) {
          isAuthorizedRepControl.setValue(true, { emitEvent: true });
          
          // Also ensure we have at least one authorized representative entry
          if (this.authorizedRepresentatives.length === 0) {
            this.addAuthorizedRepresentative();
          }
          
          // Trigger change detection to render the section, then load attachments
          setTimeout(() => {
            this.loadAuthorizedRepAttachments();
          }, 200);
        } else {
          // Already true, just load the attachments
          setTimeout(() => {
            this.loadAuthorizedRepAttachments();
          }, 100);
        }
      }
    }
    
    if (this.vendor.Attachments && this.vendor.Attachments.length > 0) {
      for (const attachment of this.vendor.Attachments) {
        const fileUploadComponent = this.findFileUploadComponent(attachment.AttachmentFor!); // Match based on AttachmentFor

        // Get expiry date (handle both lowercase and uppercase property names)
        const expiryDate = attachment.DocumentExpiryDate || (attachment as any).documentExpiryDate;

        // Load expiry date for Compliance & Ethics (OtherDocuments)
        if (this.OtherDocuments.get(attachment.AttachmentFor + "Date") && expiryDate) {
          const formattedExpiryDate = this.formatDateToInput(expiryDate);
          if (formattedExpiryDate) {
            this.OtherDocuments.get(attachment.AttachmentFor + "Date")?.setValue(formattedExpiryDate);
          }
        }

        // Load expiry date for Supporting Documents (supportingDocumentsForm)
        if (this.supportingDocumentsForm && attachment.AttachmentFor && this.isSupportingPerFileExpiryDocument(attachment.AttachmentFor)) {
          this.ensureSupportingPerFileExpiryControl(attachment.AttachmentFor, attachment.Name, expiryDate);
        } else if (this.supportingDocumentsForm && this.supportingDocumentsForm.get(attachment.AttachmentFor + "Date") && expiryDate) {
          const formattedExpiryDate = this.formatDateToInput(expiryDate);
          if (formattedExpiryDate) {
            this.supportingDocumentsForm.get(attachment.AttachmentFor + "Date")?.setValue(formattedExpiryDate);
          }
        }

        if (fileUploadComponent) {
          const fileContent = attachment.FileContent;
          const mimeType = attachment.MimeType || 'application/pdf';
          const blob = await this.getBlobFromFileContent(fileContent, mimeType);
          if (blob) {
            fileUploadComponent.pushFileToUploadedFiles(attachment.Name!, blob, mimeType);
            if (attachment.AttachmentFor && attachment.AttachmentFor.startsWith('authorizedRepFile_')) {
              const indexMatch = attachment.AttachmentFor.match(/authorizedRepFile_(\d+)/);
              if (indexMatch) {
                const index = parseInt(indexMatch[1], 10);
                const representative = this.authorizedRepresentatives.at(index) as FormGroup;
                if (representative) {
                  const fileControl = representative.get('productsRepresentedFile');
                  if (fileControl) {
                    fileControl.setValue(attachment.FilePath || attachment.Name || '');
                  }
                }
              }
            }
          }
        } else {
          if (attachment.AttachmentFor && attachment.AttachmentFor.startsWith('authorizedRepFile_')) {
            setTimeout(() => {
              this.loadAuthorizedRepAttachment(attachment);
            }, 500);
          }
        }
      }
    }

    var bankDoc = this.vendor.BankAccount?.Documents;
    if (bankDoc && bankDoc.length > 0) {
      for (const doc of bankDoc) {
        const DocfileUploadComponent = this.findFileUploadComponent(doc.AttachmentFor!);
        if (!DocfileUploadComponent) continue;
        const mimeType = doc.MimeType || 'application/pdf';
        const blob = await this.getBlobFromFileContent(doc.FileContent, mimeType);
        if (blob) {
          DocfileUploadComponent.pushFileToUploadedFiles(doc.Name!, blob, mimeType);
        }
      }
    }
    this._loaderService.hideLoader();
  }

  // Helper method to load all authorized representative attachments
  private async loadAuthorizedRepAttachments(): Promise<void> {
    if (!this.vendor.Attachments || this.vendor.Attachments.length === 0) {
      return;
    }
    
    const authorizedRepAttachments = this.vendor.Attachments.filter(att => 
      att.AttachmentFor && att.AttachmentFor.startsWith('authorizedRepFile_')
    );
    
    for (const attachment of authorizedRepAttachments) {
      await this.loadAuthorizedRepAttachment(attachment);
    }
  }

  // Helper method to load authorized representative attachments with retry
  private async loadAuthorizedRepAttachment(attachment: any): Promise<void> {
    // Try to find the component, with multiple retries if needed
    let fileUploadComponent = this.findFileUploadComponent(attachment.AttachmentFor!);
    let retryCount = 0;
    const maxRetries = 5;
    
    // If component not found, wait a bit and retry (components might not be rendered yet)
    while (!fileUploadComponent && retryCount < maxRetries) {
      await new Promise(resolve => setTimeout(resolve, 200));
      fileUploadComponent = this.findFileUploadComponent(attachment.AttachmentFor!);
      retryCount++;
    }
    
    if (fileUploadComponent) {
      const fileContent = attachment.FileContent;
      const mimeType = attachment.MimeType || 'application/pdf';
      const blob = await this.getBlobFromFileContent(fileContent, mimeType);

      if (blob) {
        fileUploadComponent.pushFileToUploadedFiles(attachment.Name!, blob, mimeType);
        
        // Set form control value
        const indexMatch = attachment.AttachmentFor.match(/authorizedRepFile_(\d+)/);
        if (indexMatch) {
          const index = parseInt(indexMatch[1], 10);
          if (this.authorizedRepresentatives && this.authorizedRepresentatives.length > index) {
            const representative = this.authorizedRepresentatives.at(index) as FormGroup;
            if (representative) {
              const fileControl = representative.get('productsRepresentedFile');
              if (fileControl) {
                fileControl.setValue(attachment.FilePath || attachment.Name || '');
              }
            }
          }
        }
      }
    }
  }



  //#region  documents handlers 


  
  handleFileRemove(documentName: string, removedFileName?: string): void {
    // Bank documents: new (not yet uploaded) files are removed locally only;
    // already-uploaded files (blob URL / FilePath) are also removed from the backend.
    if (this.isBankDocument(documentName)) {
      const tempIndex = this.BankTempDocumentsArray.findIndex(doc => doc.AttachmentFor === documentName && (!removedFileName || doc.Name === removedFileName));
      if (tempIndex > -1) {
        this.BankTempDocumentsArray.splice(tempIndex, 1);
        return;
      }

      const existingDocs = this.vendor.BankAccount?.Documents;
      const existingIndex = existingDocs?.findIndex(doc => doc.AttachmentFor === documentName && (!removedFileName || doc.Name === removedFileName)) ?? -1;
      if (existingDocs && existingIndex > -1) {
        const docToRemove = existingDocs[existingIndex];
        const isUploaded = !!docToRemove.FilePath || String(docToRemove.FileContent || '').startsWith('http');
        if (isUploaded) {
          this.removeBankDocumentFromBackend(existingDocs, existingIndex);
        } else {
          existingDocs.splice(existingIndex, 1);
        }
      }
      return;
    }

    const attachmentIndex = this.vendor.Attachments?.findIndex(att => att.AttachmentFor === documentName && (!removedFileName || att.Name === removedFileName));


    if (attachmentIndex !== undefined && attachmentIndex > -1) {
      const attachmentToRemove = this.vendor.Attachments?.[attachmentIndex];
      this.removeSupportingPerFileExpiryControl(documentName, attachmentToRemove?.Name || removedFileName);

      this.RemoveFilesFromBackend(attachmentIndex);

    }
  }
  



  handleFileUpload(event: { name: string, file: File, fileType: string }, documentName?: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const reader = new FileReader();
  
      // Ensure Attachments array is initialized
      if (!this.vendor.Attachments) {
        this.vendor.Attachments = [];
      }
  
      // Read the file as a Data URL (which includes the Base64 string with MIME type)
      reader.readAsDataURL(event.file as Blob);
  
      reader.onload = () => {
        const base64String = reader.result as string; // This contains 'data:image/png;base64,...'
  
        // Safely handle the documentName check and convert to lowercase
        // Bank certificates can be identified by 'bankCertificate' or 'Document' (case-insensitive)
        const documentNameLower = documentName?.toString().toLowerCase();
        const isVendorBank = documentNameLower === 'document' || documentNameLower === 'bankcertificate';

        // Push the document to TempDocumentsArray
        // Keep AttachmentFor as the original documentName (e.g., 'bankCertificate')
        this.TempDocumentsArray.push({
          AttachmentFor: documentName,
          Name: event.name,
          FileContent: base64String,  // Base64 string with MIME type
          MimeType: event.fileType,
          ProcessName: isVendorBank
            ? DocumentProcessTypes.VendorBank.toString()
            : DocumentProcessTypes.Vendor.toString(),
          AttachmentId: '0'
        });
  
        resolve(); // Resolve the promise when the file has been processed
      };
  
      reader.onerror = (error) => {
        reject(error); // Reject the promise on error
      };
    });
  }
  
  
  onFileUpload(event: { name: string, file: File, fileType: string }, documentName?: string): void {
    // Track the promise for this upload
    const uploadPromise = this.handleFileUpload(event, documentName);
    // Add the promise to uploadPromises array
    this.uploadPromises.push(uploadPromise);
  }
  

  private isBankDocument(attachmentFor?: string | null): boolean {
    const name = attachmentFor?.toString().toLowerCase();
    return name === 'document' || name === 'bankcertificate';
  }

  // Removes an already-uploaded bank document from the backend (RemoveDocument API),
  // then drops it from the local BankAccount.Documents array on success.
  private removeBankDocumentFromBackend(documents: DocumentModel[], index: number): void {
    const documentToRemove = { ...documents[index], FileContent: '' };
    const apiService = this.createApiService();

    this._loaderService.showLoader();

    this.fireDeletePostDocuments(apiService, documentToRemove)
      .then((result: any) => {
        const response: BaseResponseDTO = result;
        if (response?.isSuccess) {
          documents.splice(index, 1);
          this.toastService.success('Attachments were successfully removed');
        } else {
          this.toastService.error(response?.errorMessageEn || 'Something went wrong');
        }
      })
      .catch(() => {
        this.toastService.error('Something went wrong');
      })
      .finally(() => {
        this._loaderService.hideLoader();
      });
  }

  async onAllFilesUploaded(): Promise<void> {
    try {
      this._loaderService.showLoader();

      // Wait for all file upload promises to resolve before proceeding
      await Promise.all(this.uploadPromises);

      // Bank documents must not go through the UploadDocumnets API (causes issues).
      // Keep them locally; they are sent inside BankAccount.Documents of the UpdateVendor payload on submit.
      const bankDocuments = this.TempDocumentsArray.filter(doc => this.isBankDocument(doc.AttachmentFor));
      if (bankDocuments.length > 0) {
        this.BankTempDocumentsArray.push(...bankDocuments);
        this.TempDocumentsArray = this.TempDocumentsArray.filter(doc => !this.isBankDocument(doc.AttachmentFor));
      }

      if (this.TempDocumentsArray.length === 0) {
        this.uploadPromises = [];
        this._loaderService.hideLoader();
        return;
      }

      // Call the backend to upload the files
      const uploadedDocuments = await this.uploadFileToBackend();
  
      // Map returned document info to vendor.Attachments
      uploadedDocuments.forEach((uploadedDocument: any) => {
        const attachment: DocumentModel = {
          AttachmentFor: uploadedDocument.attachmentFor,
          Name: uploadedDocument.name,
          FilePath: uploadedDocument.filePath,  // Use the filePath from backend
          MimeType: uploadedDocument.mimeType,
          FileContent: uploadedDocument.fileContent
        };
        this.vendor.Attachments!.push(attachment);
        this.ensureSupportingPerFileExpiryControl(attachment.AttachmentFor || '', attachment.Name);
      });
  
      // Clear TempDocumentsArray and reset uploadPromises
      this.TempDocumentsArray = [];
      this.uploadPromises = [];
      this.toastService.success('File uploaded successfully!');
      this._loaderService.hideLoader();

    } catch (error) {
      // Handle errors during file upload
      this.TempDocumentsArray = [];
      this.uploadPromises = [];
      this.toastService.error('Error uploading the file.');
      this._loaderService.hideLoader();

    }
  }


  
    // Find the corresponding file upload component by matching AttachmentFor
    findFileUploadComponent(attachmentFor: string): FileUploadComponent | undefined {
      // Special handling for bank documents
      if (attachmentFor === 'bankCertificate' && this.bankCertificateUploadComponent) {
        return this.bankCertificateUploadComponent;
      }
      
      // For 'Document' AttachmentFor, find the component with label containing "Company Bank Details"
      if (attachmentFor === 'Document') {
        return this.documentFileUploadComponent;
      }
      
      // Special handling for authorized representative files (authorizedRepFile_0, authorizedRepFile_1, etc.)
      if (attachmentFor && attachmentFor.startsWith('authorizedRepFile_')) {
        const indexMatch = attachmentFor.match(/authorizedRepFile_(\d+)/);
        if (indexMatch) {
          const index = parseInt(indexMatch[1], 10);
          // Ensure the authorized representative section is visible
          const isAuthorizedRep = this.capabilityExperienceForm?.get('isAuthorizedRepresentative')?.value;
          if (!isAuthorizedRep) {
            return undefined;
          }
          
          // Ensure the authorized representative at this index exists
          if (!this.authorizedRepresentatives || this.authorizedRepresentatives.length <= index) {
            return undefined;
          }
          
          const representative = this.authorizedRepresentatives.at(index) as FormGroup;
          if (!representative) {
            return undefined;
          }
          
          let fileControl = representative.get('productsRepresentedFile');
          if (!fileControl) {
            // Try to add the missing control if it doesn't exist
            representative.addControl('productsRepresentedFile', this._formBuilder.control('', Validators.required));
            fileControl = representative.get('productsRepresentedFile');
            if (!fileControl) {
              return undefined;
            }
          }
          
          // Method 1: Try to find by form control reference
          // The FileUploadComponent has @Input() formControl, so we can access it directly
          let foundComponent: FileUploadComponent | undefined;
          
          // Get all file upload components and check each one
          const allComponents = this.fileUploadComponents.toArray();
          
          // Method 1: Match by form control reference
          // The FileUploadComponent has @Input() formControl, so we can access it directly
          for (const component of allComponents) {
            // Try to access the form control directly (it's an @Input)
            const componentControl = (component as any).formControl;
            
            // Check direct reference match
            if (componentControl === fileControl) {
              foundComponent = component;
              break;
            }
            
            // Also check if the component's formControl is the same instance
            // by comparing their parent form group and control name
            if (componentControl) {
              // Check if both controls belong to the same form group at the same index
              const componentControlParent = (componentControl as any)._parent;
              const fileControlParent = (fileControl as any)._parent;
              
              if (componentControlParent === fileControlParent) {
                // They're in the same form group, check if they're the same control
                if (componentControl === fileControl) {
                  foundComponent = component;
                  break;
                }
              }
            }
          }
          
          // Method 2: Try by inputId
          if (!foundComponent) {
            const expectedInputId = `authorized-rep-file-${index}`;
            for (const component of allComponents) {
              const inputId = (component as any).inputId;
              if (inputId === expectedInputId) {
                foundComponent = component;
                break;
              }
            }
          }
          
          // Method 3: Try by matching the component's position in the QueryList
          // If we have exactly the same number of authorized reps as components with "Upload File" label
          if (!foundComponent) {
            const uploadFileComponents = allComponents.filter(c => (c as any).label === 'Upload File');
            if (uploadFileComponents.length > index && this.authorizedRepresentatives.length === uploadFileComponents.length) {
              // Assume they're in the same order
              foundComponent = uploadFileComponents[index];
            }
          }
          
          return foundComponent;
        }
      }
      
      // Default: match by label
      return this.fileUploadComponents.find((component) => {
        return component.label === attachmentFor;
      });
    }


  // Convert base64 string to Blob
  base64ToBlob(base64: string, contentType: string = ''): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }

  /** Get a Blob from FileContent (Azure blob SAS URL or base64). Used when API returns URL instead of base64. */
  async getBlobFromFileContent(fileContent: string | null | undefined, mimeType: string): Promise<Blob | null> {
    if (!fileContent) return null;
    if (typeof fileContent === 'string' && (fileContent.startsWith('http://') || fileContent.startsWith('https://'))) {
      try {
        const response = await fetch(fileContent, { method: 'GET' });
        if (!response.ok) return null;
        return await response.blob();
      } catch {
        return null;
      }
    }
    const base64String = fileContent.includes('base64,') ? fileContent.split(',')[1] : fileContent;
    if (!base64String) return null;
    try {
      return this.base64ToBlob(base64String, mimeType);
    } catch {
      return null;
    }
  }


  //#endregion



private async initializeFormControls() {
  if (!this.OtherDocuments) {
    // Initialize empty form - all documents will be added dynamically from DocumentsMaster
    this.OtherDocuments = this._formBuilder.group({});
  }

  // Initialize supportingDocumentsForm if not already initialized
  if (!this.supportingDocumentsForm) {
    this.supportingDocumentsForm = this._formBuilder.group({});
  }

  // Dynamically add form controls based on DocumentsMaster to OtherDocuments (for Compliance & Ethics tab)
  this.DocumentsMaster.forEach(document => {
    // Skip if control already exists
    if (this.OtherDocuments.get(document.documentName)) {
      return;
    }

    // Create the main document control
    const documentControl = new FormControl('');
    this.OtherDocuments.addControl(document.documentName, documentControl);

    // Check if expiration date is present and add expiration date control
    if (document.expirationDate) {
      const expirationDateControl = new FormControl(
        '',
        document.expirationDateMandatory
          ? [Validators.required, Utils.noPastDatesValidator()]
          : Utils.noPastDatesValidator()
      );

      // Disable if in view mode
      if (this.isViewMode) {
        expirationDateControl.disable();
      }

      this.OtherDocuments.addControl(document.documentName + 'Date', expirationDateControl);
    }
    
    // Disable file upload if in view mode
    if (this.isViewMode) {
      documentControl.disable();
    }

    // Also add to supportingDocumentsForm for Supporting Documents tab
    if (!this.supportingDocumentsForm.get(document.documentName)) {
      const supportingDocumentControl = new FormControl('');
      this.supportingDocumentsForm.addControl(document.documentName, supportingDocumentControl);
      
      if (document.expirationDate && !this.isSupportingPerFileExpiryDocument(document.documentName)) {
        const supportingExpirationDateControl = new FormControl(
          '',
          document.expirationDateMandatory 
            ? [Validators.required, Utils.noPastDatesValidator()] 
            : Utils.noPastDatesValidator()
        );
        
        if (this.isViewMode) {
          supportingExpirationDateControl.disable();
        }
        
        this.supportingDocumentsForm.addControl(document.documentName + 'Date', supportingExpirationDateControl);
      }
      
      if (this.isViewMode) {
        supportingDocumentControl.disable();
      }
    }
  });




  

  

}


getOtherDocumentControlNames(): string[] {
  return Object.keys(this.OtherDocuments.controls);
}
  
  CheckBoxAgreement() {

    const isLastStep = this.isLastTab();
    const isCheckboxChecked = this.confirmCheckboxControl.value;
    this.nextButtonDisabled = !(isLastStep && !isCheckboxChecked);
  }


  isLastTab(): boolean {
    return this.currentTab === this.steps.length - 1;
  }
  
  isSubmitDisabled(): boolean {
    const isLastStep = this.isLastTab();
    return isLastStep ? this.nextButtonDisabled : false;
  }


  getDocumentFormControl(documentName: string): FormControl  {
    const control = this.OtherDocuments?.get(documentName) as FormControl;
    if (!control) {
    }
    return control;
  }

  getSupportingDocumentControl(controlName: string): FormControl {
    return this.supportingDocumentsForm?.get(controlName) as FormControl || new FormControl('');
  }

  public isSupportingPerFileExpiryDocument(documentName: string): boolean {
    const document = this.DocumentsMaster?.find(doc => doc.documentName === documentName);
    return !!document?.allowMultipleDocs && !!document?.expirationDate;
  }

  public shouldShowSupportingPerFileExpiry(document: any): boolean {
    return !!document?.allowMultipleDocs && !!document?.expirationDate;
  }

  private isSupportingPerFileExpiryEnabled(documentName: string): boolean {
    return this.isSupportingPerFileExpiryDocument(documentName);
  }

  public isSupportingPerFileExpiryMandatory(documentName: string): boolean {
    const document = this.DocumentsMaster?.find(doc => doc.documentName === documentName);
    return !!document?.allowMultipleDocs && !!document?.expirationDate && !!document?.expirationDateMandatory;
  }

  public getSupportingPerFileExpiryControl(documentName: string, fileName?: string | null): FormControl {
    this.ensureSupportingPerFileExpiryControl(documentName, fileName);
    const controlName = this.getSupportingPerFileExpiryControlName(documentName, fileName);
    return this.supportingDocumentsForm?.get(controlName) as FormControl || new FormControl('');
  }

  public getSupportingPerFileAttachments(documentName: string, createExpiryControls: boolean = false): DocumentModel[] {
    if (!this.isSupportingPerFileExpiryDocument(documentName)) {
      return [];
    }

    const attachments = (this.vendor.Attachments || []).filter(attachment => attachment.AttachmentFor === documentName);
    if (createExpiryControls) {
      this.removeStaleSupportingPerFileExpiryControls(documentName, attachments);
      attachments.forEach(attachment => this.ensureSupportingPerFileExpiryControl(documentName, attachment.Name, undefined, true));
    }

    return attachments;
  }

  public getSupportingPerFileExpiryControlName(documentName: string, fileName?: string | null): string {
    return `${documentName}Date__${this.getSafeFileControlKey(fileName || '')}`;
  }

  private getSafeFileControlKey(fileName: string): string {
    return encodeURIComponent(fileName || '').replace(/[^a-zA-Z0-9_-]/g, '_');
  }

  private ensureSupportingPerFileExpiryControl(documentName: string, fileName?: string | null, expiryDate?: any, forceEnabled: boolean = false): void {
    if (!this.supportingDocumentsForm || (!forceEnabled && !this.isSupportingPerFileExpiryEnabled(documentName)) || !fileName) {
      return;
    }

    const controlName = this.getSupportingPerFileExpiryControlName(documentName, fileName);
    let control = this.supportingDocumentsForm.get(controlName) as FormControl;

    if (!control) {
      control = new FormControl('', this.isSupportingPerFileExpiryMandatory(documentName) ? [Validators.required, Utils.noPastDatesValidator()] : Utils.noPastDatesValidator());
      if (this.isViewMode) {
        control.disable();
      }
      this.supportingDocumentsForm.addControl(controlName, control);
    }

    control.setValidators(this.isSupportingPerFileExpiryMandatory(documentName) ? [Validators.required, Utils.noPastDatesValidator()] : Utils.noPastDatesValidator());
    control.updateValueAndValidity({ emitEvent: false });

    if (expiryDate) {
      const formattedExpiryDate = this.formatDateToInput(expiryDate);
      if (formattedExpiryDate) {
        control.setValue(formattedExpiryDate);
      }
    }
  }

  private removeStaleSupportingPerFileExpiryControls(documentName: string, activeAttachments: DocumentModel[]): void {
    if (!this.supportingDocumentsForm || !this.isSupportingPerFileExpiryDocument(documentName)) {
      return;
    }

    const controlPrefix = `${documentName}Date__`;
    const activeControlNames = new Set(
      activeAttachments
        .map(attachment => this.getSupportingPerFileExpiryControlName(documentName, attachment.Name))
        .filter(controlName => !!controlName)
    );

    Object.keys(this.supportingDocumentsForm.controls)
      .filter(controlName => controlName.startsWith(controlPrefix) && !activeControlNames.has(controlName))
      .forEach(controlName => this.supportingDocumentsForm.removeControl(controlName));
  }

  private removeSupportingPerFileExpiryControl(documentName: string, fileName?: string | null): void {
    if (!this.supportingDocumentsForm || !this.isSupportingPerFileExpiryEnabled(documentName) || !fileName) {
      return;
    }

    const controlName = this.getSupportingPerFileExpiryControlName(documentName, fileName);
    if (this.supportingDocumentsForm.get(controlName)) {
      this.supportingDocumentsForm.removeControl(controlName);
    }
  }
  getComplianceFileControl(controlName: string): FormControl {
    return this.OtherDocuments?.get(controlName) as FormControl;
  }


  private addPersistentContact() {
    this.contacts.push(this._formBuilder.group({
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      title: [null, Validators.required],
      email: [null, Validators.required],
      landlindeNumber: [null, Validators.required], // Note the correct spelling here
      mobileNumber: [null, Validators.required],
    }));
  }


  
   mapToVendorModel(data: any): VendorModel {
    // Helper function to parse companyType (might be JSON string or array)
    const parseCompanyType = (companyType: any): string[] => {
      if (!companyType) return [];
      if (Array.isArray(companyType)) return companyType;
      if (typeof companyType === 'string') {
        try {
          const parsed = JSON.parse(companyType);
          return Array.isArray(parsed) ? parsed : [];
        } catch {
          return [companyType];
        }
      }
      return [];
    };

    // Helper function to parse subsidiaries (handle null)
    const parseSubsidiaries = (subsidiaries: any): any[] => {
      if (!subsidiaries) return [];
      if (Array.isArray(subsidiaries)) return subsidiaries;
      return [];
    };

    // Helper function to parse partners (handle null)
    const parsePartners = (partners: any): any[] => {
      if (!partners) return [];
      if (Array.isArray(partners)) return partners;
      return [];
    };

    // Helper function to parse authorizedRepresentatives (handle null)
    const parseAuthorizedRepresentatives = (authReps: any): any[] => {
      if (!authReps) return [];
      if (Array.isArray(authReps)) return authReps;
      return [];
    };

    // Helper function to parse annualTurnovers (handle null)
    const parseAnnualTurnovers = (turnovers: any): any[] => {
      if (!turnovers) return [];
      if (Array.isArray(turnovers)) return turnovers;
      return [];
    };

    // Determine vendorName - check multiple sources
    let vendorName = data.vendorName;
    if (!vendorName && data.name) {
      vendorName = data.name;
    }
    if (!vendorName && data.vendorType === "Individual" && data.firstName && data.lastName) {
      vendorName = `${data.firstName} ${data.lastName}`;
    }

    return {
      financeEmail : data.financeEmail,
      ERPVendorID : data.erpVendorID,
      Email: data.email,
      localOrForeign: data.localOrForeign,
      Country: data.countryRegionIdPrimary, // Assuming Country is the primary country region
      FirstName: data.firstName,
      LastName: data.lastName,
      Password: data.password,
      vendorReference: data.vendorReference,
      vendorType: data.vendorType,
      mobile: data.mobile,
      vendorName: vendorName,
      VendorID: data.vendorID,
      Mobile: data.mobile,
      OTP: data.otp,
      OTPExpiry: data.otpExpiry ? new Date(data.otpExpiry) : undefined,
      AddressDescriptionPrimary: data.addressDescriptionPrimary,
      AddressDescriptionSecondary: data.addressDescriptionSecondary,
      StreetPrimary: data.streetPrimary,
      StreetSecondary: data.streetSecondary,
      website : data.website,
      CityPrimary: data.cityPrimary,
      CitySecondary: data.citySecondary,
      CountryRegionIdPrimary: data.countryRegionIdPrimary,
      CountryRegionIdSecondary: data.countryRegionIdSecondary,
      Currency: data.currency,
      IndividualCompany: data.individualCompany,
      IsInvestor: data.isInvestor,
      LocalOrForeign: data.localOrForeign,
      IsMoreThanOneOfficeBranch: data.isMoreThanOneOfficeBranch,
      MethodOfPayment: data.methodOfPayment,
      NoOfYears: data.noOfYears,
      NumberofBranches: data.numberofBranches,
      Organizationalstructure: data.organizationalstructure,
      noOfEmployees: data.noOfEmployees,
      PhonePrimary: data.phonePrimary,
      PhoneSecondary: data.phoneSecondary,
      VendorReference: data.vendorReference,
      RegisteredDate: data.registeredDate,
      RegistrationDate: data.registrationDate ? new Date(data.registrationDate) : undefined,
      TermsOfPayment: data.termsOfPayment,
      VendorHold: data.vendorHold,
      VendorName: vendorName,
      Status: data.status || data.Status,
      RejectionReason: data.rejectionReason || data.RejectionReason,
      WorkingCapital: data.workingCapital,
      ZipCodePrimary: data.zipCodePrimary,
      ZipCodeSecondary: data.zipCodeSecondary,
      
      // New fields from API
      natureOfBusiness: data.natureOfBusiness,
      poBox: data.poBox,
      fax: data.fax,
      state: data.state,
      zoneNo: data.zoneNo,
      streetNo: data.streetNo,
      buildingNo: data.buildingNo,
      parentCompanyName: data.parentCompanyName,
      parentCompanyIsDifferent: data.parentCompanyIsDifferent,
      parentCompanyPreviousName: data.parentCompanyPreviousName,
      establishmentCountry: data.establishmentCountry,
      establishmentYear: data.establishmentYear,
      commercialRegNumber: data.commercialRegNumber,
      chamberMembershipNumber: data.chamberMembershipNumber,
      importLicenseNumber: data.importLicenseNumber,
      isoCertification: data.isoCertification,
      companyType: parseCompanyType(data.companyType),
      ownerName: data.ownerName,
      ownerNationality: data.ownerNationality,
      qatid: data.qatid,
      nationality: data.nationality,
      passport: data.passport,
      gender: data.gender,
      dateOfBirth: data.dateOfBirth ? new Date(data.dateOfBirth) : undefined,

      // Mapping contactPerson
      contactPerson: data.contactPerson ? data.contactPerson.map(contact => ({
        FirstName: contact.name ? contact.name.split(' ')[0] : contact.firstName,
        LastName: contact.name && contact.name.split(' ').length > 1 ? contact.name.split(' ').slice(1).join(' ') : contact.lastName,
        Name: contact.name || (contact.firstName && contact.lastName ? `${contact.firstName} ${contact.lastName}` : contact.firstName || contact.lastName || ''),
        Title: contact.title,
        Email: contact.email,
        LandlineNumber: contact.landlineNumber,
        MobileNumber: contact.mobileNumber,
        // Preserve backend metadata so we can respect read-only rules on the portal
        Status: contact.status ?? contact.Status,
        ID: contact.id ?? contact.ID
      })) : [],


      AssociatedCompanies: data.associatedCompanies ? data.associatedCompanies.map(assocomp => ({
        CompanyName: assocomp.companyName,
        ContactPerson:  assocomp.contactPerson,
        ContactNumber:  assocomp.contactNumber,
        EmailAddress:  assocomp.emailAddress,
        companyType: assocomp.companyType
        
      })) : [],
      

      // Accept both camelCase (managementTeam) and PascalCase (ManagementTeam) from API
      ManagementTeam: (() => {
        const source = data.managementTeam || data.ManagementTeam;
        return source && Array.isArray(source) ? source.map((mt: any) => ({
          Name: mt.name || mt.Name || '',
          Title: mt.title || mt.Title || '',
          Nationality: mt.nationality || mt.Nationality || '',
          Email: mt.email || mt.Email || '',
          LandlineNumber: mt.landlineNumber || mt.LandlineNumber || '',
          MobileNumber: mt.mobileNumber || mt.MobileNumber || ''
        })) : [];
      })(),
      
      // Map ManagementTeam to seniorManagement for the form (same source for both casings)
      seniorManagement: (() => {
        const source = data.managementTeam || data.ManagementTeam;
        return source && Array.isArray(source) ? source.map((member: any) => {
          const landRaw = member.landlineNumber || member.LandlineNumber || '';
          const mobRaw = member.mobileNumber || member.MobileNumber || '';
          const land = this.parseStoredPhoneForForm(landRaw);
          const mob = this.parseStoredPhoneForForm(mobRaw);
          return {
            name: member.name || member.Name || '',
            title: member.title || member.Title || '',
            nationality: member.nationality || member.Nationality || '',
            email: member.email || member.Email || '',
            phoneNumber: land.mobileNumber,
            phoneNumberCode: land.mobileCode,
            mobileNumber: mob.mobileNumber,
            mobileNumberCode: mob.mobileCode
          };
        }) : [];
      })(),
      

      // Mapping Attachments
      Attachments: data.attachments ? data.attachments.map(attachment => ({
        ProcessName: attachment.processName,
        AttachmentFor: attachment.attachmentFor,
        AttachmentId: attachment.attachmentId,
        DocumentExpiryDate: attachment.documentExpiryDate ? new Date(attachment.documentExpiryDate) : undefined,
        AdditionalDetails: attachment.additionalDetails,
        ApplicationId: attachment.applicationId,
        Name: attachment.name,
        FilePath: attachment.filePath,
        FileContent: attachment.fileContent,
        RecId: attachment.recId,
        IsIntegrated: attachment.isIntegrated,
        MimeType: attachment.mimeType
      })) : [],
      
      // Mapping Category
      Category: data.category ? data.category.map(cat => ({
        VendorID: cat.vendorID,
        CategoryID: cat.categoryID,
        ID: cat.id,
        CreatedAt: new Date(cat.createdAt),
        CreatedBy: cat.createdBy,
        ModifiedAt: new Date(cat.modifiedAt),
        ModifiedBy: cat.modifiedBy,
      })) : [],
  
      // Mapping SubCategory
      SubCategory: data.subCategory ? data.subCategory.map(sub => ({
        vendorID: sub.vendorID,
        SubCategoryID: sub.subCategoryID,
        ID: sub.id,
        CreatedAt: new Date(sub.createdAt),
        CreatedBy: sub.createdBy,
        ModifiedAt: new Date(sub.modifiedAt),
        ModifiedBy: sub.modifiedBy,
      })) : [],
      
      // Map subsidiaries, partners, authorizedRepresentatives, annualTurnovers
      // Check both camelCase and PascalCase property names
      subsidiaries: parseSubsidiaries(data.subsidiaries || data.Subsidiaries).map((subsidiary: any) => ({
        subsidiaryName: subsidiary.subsidiaryName || subsidiary.SubsidiaryName || '',
        relationshipToParent: subsidiary.relationshipToParent || subsidiary.RelationshipToParent || '',
        otherCompanyType: subsidiary.otherCompanyType || subsidiary.OtherCompanyType || undefined,
        companyType: parseCompanyType(subsidiary.companyType || subsidiary.CompanyType)
      })),
      
      partners: parsePartners(data.partners || data.Partners).map((partner: any) => ({
        name: partner.name || partner.Name || '',
        percentageOfShare: partner.percentageOfShare || partner.PercentageOfShare || '',
        nationality: partner.nationality || partner.Nationality || '',
        idNumber: partner.idNumber ?? partner.IdNumber ?? ''
      })),
      
      authorizedRepresentatives: (() => {
        const rawAuthReps = data.authorizedRepresentatives || data.AuthorizedRepresentatives;
        const parsed = parseAuthorizedRepresentatives(rawAuthReps);
        const mapped = parsed.map((authRep: any) => ({
          company: authRep.company || authRep.Company || '',
          poBox: authRep.poBox || authRep.PoBox || '',
          telNo: authRep.telNo || authRep.TelNo || '',
          faxNo: authRep.faxNo || authRep.FaxNo || '',
          productsRepresented: authRep.productsRepresented || authRep.ProductsRepresented || ''
        }));
        return mapped;
      })(),
      
      annualTurnovers: parseAnnualTurnovers(data.annualTurnovers || data.AnnualTurnovers).map((turnover: any) => ({
        yearNumber: turnover.yearNumber || turnover.YearNumber || turnover.year || turnover.Year || 1,
        value: turnover.value || turnover.Value || turnover.turnoverAmount || turnover.TurnoverAmount || '',
        currency: turnover.currency || turnover.Currency || '',
        year: turnover.year || turnover.Year || null
      })),
      
      // Financial Details fields
      currency: data.currency || data.Currency || undefined,
      authorizedCapital: data.authorizedCapital || data.AuthorizedCapital || undefined,
      creditRating: data.creditRating || data.CreditRating || undefined,
      netProfit: data.netProfit || data.NetProfit || undefined,
      totalAssets: data.totalAssets || data.TotalAssets || undefined,
      currentRatio: data.currentRatio || data.CurrentRatio || undefined,
      latestAnnualTurnover: data.latestAnnualTurnover || data.LatestAnnualTurnover || undefined,
      currentYear: data.currentYear || data.CurrentYear || undefined,
      
      // Business Details fields
      tradingName: data.tradingName,
      typeOfBusinessActivity: data.typeOfBusinessActivity,
      yearsOfExperience: data.yearsOfExperience,
      descriptionOfGoodsServices: data.descriptionOfGoodsServices,
      
      // Business Details fields
      taxIdentificationNumber: data.taxIdentificationNumber,
      vatRegistrationNumber: data.vatRegistrationNumber,
      countryOfTaxResidence: data.countryOfTaxResidence,
      
      // Capability & Experience fields
      coreProductsServices: data.coreProductsServices || data.CoreProductsServices || undefined,
      previousExperience: data.previousExperience || data.PreviousExperience || undefined,
      additionalInformation: data.additionalInformation || data.AdditionalInformation || undefined,
      contractsProjectsDetails: data.contractsProjectsDetails || data.ContractsProjectsDetails || undefined,
      isAuthorizedRepresentative: data.isAuthorizedRepresentative !== undefined ? data.isAuthorizedRepresentative : (data.IsAuthorizedRepresentative !== undefined ? data.IsAuthorizedRepresentative : undefined),
      Categories_Other: data.categories_Other || data.Categories_Other || data.categories_other || data.Categories_other || undefined,
      SubCategories_Other: data.subCategories_Other || data.SubCategories_Other || data.subCategories_other || data.SubCategories_other || undefined,
      
      // Warehousing & Storage fields
      warehousingStorageDetails: data.warehousingStorageDetails || data.WarehousingStorageDetails || undefined,
      transportFreightForwardingDetails: data.transportFreightForwardingDetails || data.TransportFreightForwardingDetails || undefined,
      
      // Other Information field
      otherInformation: data.otherInformation || data.OtherInformation || undefined,
      
      // Categories and SubCategories - extract IDs from arrays (removed, but kept for backward compatibility)
      Categories: [], // Categories removed - will be derived from SubSubCategories
      SubCategories: [], // SubCategories removed - will be derived from SubSubCategories
      
      // SubSubCategories - extract IDs from subSubCategory array (handle both camelCase and PascalCase)
      SubSubCategories: (() => {
        const subSubCategoryArray = data.subSubCategory || data.SubSubCategory || [];
        if (Array.isArray(subSubCategoryArray) && subSubCategoryArray.length > 0) {
          return subSubCategoryArray.map((subSub: any) => 
            subSub.subSubCategoryID || subSub.SubSubCategoryID || subSub.subSubCategoryId || subSub.SubSubCategoryId || ''
          ).filter((id: any) => id);
        }
        return [];
      })(),
      
      BankAccount :  data.bankAccount ? {
        ...data.bankAccount,  // Spread the rest of the properties
        Documents: this.handleDocumentsMapping(data.bankAccount.documents || data.bankAccount.Documents || [])   // Manually map the 'document' property

      } : null

    } as any;
  }

  // Helper function to extract mobile code and number
// Updated extractMobileDetails function
extractMobileDetails(fullMobile: string): { mobileCode: string, mobileNumber: string } {
  const countryCode = this.countryCodes.find(codeObj => fullMobile.startsWith(codeObj.code));

  if (countryCode) {
    const mobileNumber = fullMobile.replace(countryCode.code, ''); // Remove the country code from the full number
    return {
      mobileCode: countryCode.code,  // The country code (e.g., +974)
      mobileNumber: mobileNumber.trim()  // The remaining mobile number
    };
  }

  return {
    mobileCode: '',
    mobileNumber: fullMobile // Return the full number if no matching country code is found
  };
}

  /** API/storage format: dial code + single space + digits-only local part (e.g. "+974 12345678"). */
  private formatDialCodeAndLocalForApi(dialCode: string | null | undefined, localPart: string | null | undefined): string | undefined {
    const code = dialCode != null ? String(dialCode).trim() : '';
    const local = localPart != null ? String(localPart).replace(/\D/g, '') : '';
    if (!local) return undefined;
    if (!code) return local;
    return `${code} ${local}`;
  }

  /** Parse stored phone: split on first whitespace into code + number; otherwise use extractMobileDetails (legacy without space). */
  private parseStoredPhoneForForm(full: string | null | undefined): { mobileCode: string; mobileNumber: string } {
    const s = (full ?? '').trim().replace(/[\u00A0\u202F\u2007\uFEFF]/g, ' ');
    if (!s) return { mobileCode: this.defaultCountryCode, mobileNumber: '' };
    const ws = s.search(/\s/);
    if (ws > 0) {
      const code = s.slice(0, ws).trim();
      const rest = s.slice(ws + 1).trim();
      return {
        mobileCode: code || this.defaultCountryCode,
        mobileNumber: rest.replace(/\D/g, '')
      };
    }
    const legacy = this.extractMobileDetails(s);
    return {
      mobileCode: legacy.mobileCode || this.defaultCountryCode,
      mobileNumber: String(legacy.mobileNumber || '').replace(/\D/g, '')
    };
  }

  /**
   * Rebuild "dial + local" string for parsing when vendor model has either a combined API field
   * or separate code + digits (mapToVendorModel stores split fields without landlineNumber).
   */
  private buildPhoneRawForParse(
    combined: string | null | undefined,
    dialCode: string | null | undefined,
    localDigits: string | null | undefined
  ): string {
    const c = String(combined ?? '').trim();
    if (c.includes(' ') || /^\+/.test(c)) {
      return c;
    }
    const formatted = this.formatDialCodeAndLocalForApi(dialCode, localDigits);
    if (formatted) return formatted;
    return c || String(localDigits ?? '').trim();
  }

  handleDocumentsMapping(data: any[]): DocumentModel[] {
    return data.map(doc => {
      return {
        ProcessName: doc.processName,
        AttachmentFor: doc.attachmentFor,
        AttachmentId: doc.attachmentId,
        ExpiryDate: doc.expiryDate,
        DocumentExpiryDate: doc.documentExpiryDate ? new Date(doc.documentExpiryDate) : null,
        AdditionalDetails: doc.additionalDetails,
        ApplicationId: doc.applicationId,
        Name: doc.name,
        FilePath: doc.filePath,
        FileContent: doc.fileContent,
        RecId: doc.recId,
        IsIntegrated: doc.isIntegrated,
        MimeType: doc.mimeType
      } as DocumentModel;
    });
  }

  

  async GetProfile(){
    let apiService = this.createApiService();
    // var payload = null;
    // var keyValuePair = {id: this.serviceId};
    this._loaderService.showLoader();
    let req$= apiService.get(AppConstants.CONTROLLERS.VENDOR, AppConstants.ACTIONS.GetVendorDetails, true, environment.APIs_PREFIX );
    await lastValueFrom(req$).then((data:any) => {
      this.vendor = this.mapToVendorModel(data.data);

      // After vendor data is loaded, re-initialize forms to populate with data
      if (this.vendor && this.vendor.VendorID) {
        this.initializeForm();
      }
    },
    (err: HttpErrorResponse) => {
    }).finally(() => {
      this._loaderService.hideLoader();
    });
  }

  public formatDate(dateString: string): string | null {
    if (!dateString) return null;

    // API may return "dd/MM/yyyy hh:mm:ss am/pm"; JS Date parses slashes as MM/dd,
    // so parse the day/month/year parts manually for this format
    const dmyMatch = String(dateString).match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    const date = dmyMatch
      ? new Date(Number(dmyMatch[3]), Number(dmyMatch[2]) - 1, Number(dmyMatch[1]))
      : new Date(dateString);

    if (isNaN(date.getTime())) return null; // Invalid date - avoid "NaN-aN-aN"
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);  // Add leading zero
    const day = ('0' + date.getDate()).slice(-2);  // Add leading zero

    return `${year}-${month}-${day}`;  // Return in "YYYY-MM-DD" format
  }

  public getCountryName(countryRegionId: string): string {
    if (!countryRegionId || !this.Countries) return '';
    const country = this.Countries.find(c => c.countryRegionId === countryRegionId);
    return country?.countryName || '';
  }

  private setupQatarAddressValidators(addressForm: FormGroup): void {
    if (!addressForm) return;

    this.applyQatarAddressValidators(addressForm);
    addressForm.get('country')?.valueChanges.subscribe(() => {
      this.applyQatarAddressValidators(addressForm);
    });
  }

  private applyQatarAddressValidators(addressForm: FormGroup): void {
    const isQatar = this.isQatarCountry(addressForm.get('country')?.value);
    ['zoneNo', 'streetNo', 'buildingNo'].forEach(controlName => {
      const control = addressForm.get(controlName);
      if (!control) return;

      if (isQatar) {
        control.setValidators(Validators.required);
      } else {
        control.clearValidators();
      }

      control.updateValueAndValidity({ emitEvent: false });
    });
  }

  private setupLocalForeignValidators(form: FormGroup): void {
    if (!form) return;

    const localForeignControl = form.get('localOrForeign');
    const nationalIdControl = form.get('nationalId');
    const passportControl = form.get('passportNo');

    if (!localForeignControl || !nationalIdControl || !passportControl) return;

    // Apply initial validators based on current value
    this.applyLocalForeignValidators(form);

    // Listen for changes and update validators
    localForeignControl.valueChanges.subscribe(() => {
      this.applyLocalForeignValidators(form);
    });
  }

  private applyLocalForeignValidators(form: FormGroup): void {
    const localForeignValue = form.get('localOrForeign')?.value;
    const nationalIdControl = form.get('nationalId');
    const passportControl = form.get('passportNo');

    if (!nationalIdControl || !passportControl) return;

    const isLocal = localForeignValue?.toLowerCase() === 'local';

    if (isLocal) {
      // If Local: National ID required, Passport optional
      nationalIdControl.setValidators(Validators.required);
      passportControl.clearValidators();
    } else {
      // If Foreign: Passport required, National ID optional
      passportControl.setValidators(Validators.required);
      nationalIdControl.clearValidators();
    }

    nationalIdControl.updateValueAndValidity({ emitEvent: false });
    passportControl.updateValueAndValidity({ emitEvent: false });
  }

  public isQatarCountry(countryValue: any): boolean {
    const value = (countryValue ?? '').toString().trim().toUpperCase();
    if (value === 'QA' || value === 'QAT' || value === 'QATAR') {
      return true;
    }

    const country = this.Countries?.find(c =>
      (c.countryRegionId ?? '').toString().trim().toUpperCase() === value ||
      (c.countryName ?? '').toString().trim().toUpperCase() === value
    );

    return (country?.countryRegionId ?? '').toString().trim().toUpperCase() === 'QA' ||
      (country?.countryName ?? '').toString().trim().toUpperCase() === 'QATAR';
  }


  
  private async initializeForm() {
    // GeneralFormTab
      if(this.isViewMode == false) {

        const isDisabled = [VendorStatus.Rejected, VendorStatus.Submitted]
          .map(s => s.toString().toLocaleLowerCase())
          .includes((this.vendor?.Status || "").toString().toLocaleLowerCase());
        
          this.isViewMode =  isDisabled;
      }

      if (this.isAbleTBankApplication) {
      this.bankAccountForm = new FormGroup({
        ExpiryDate: new FormControl( this.formatDate(this.vendor.BankAccount?.expiryDate!) || ''),
        ActiveDate: new FormControl( this.formatDate(this.vendor.BankAccount?.activeDate!)  || ''),
        bankName: new FormControl(this.vendor.BankAccount?.name || '', Validators.required),
        accountNumber: new FormControl(this.vendor.BankAccount?.accountNumber || '',   [Validators.required, Validators.minLength(5)]),
        iban: new FormControl(this.vendor.BankAccount?.bankIBAN || '', [Validators.required, Validators.minLength(14), Validators.maxLength(34), Validators.pattern(/^[A-Z0-9]+$/)]),  // IBAN must be exactly 34 alphanumeric characters
        swiftCode: new FormControl(this.vendor.BankAccount?.swift || '', Validators.required),  // 'swift' instead of 'swiftCode'
        branchName: new FormControl(this.vendor.BankAccount?.branch || '', Validators.required),
        benficeryName: new FormControl(this.vendor.BankAccount?.beneficiaryName || '', Validators.required),  // 'beneficiaryName'
       // sortCode: new FormControl(this.vendor.BankAccount?.sortCode || '', Validators.required),
        bankCountry: new FormControl(this.vendor.BankAccount?.bankCountry || '', Validators.required),

        email: new FormControl(this.vendor.BankAccount?.email || '', [Validators.required, Validators.email]),  // Added email validator
        address: new FormControl(this.vendor.BankAccount?.address || '', Validators.required),
        currency: new FormControl(this.vendor.BankAccount?.currencyCode || '', Validators.required),  // 'currencyCode'
        Document: new FormControl(this.vendor.BankAccount?.Document || '', Validators.required),  // Ensure it's a valid value (e.g., base64 or file object)
        bankCertificate: new FormControl(this.vendor.BankAccount?.bankCertificate || '', Validators.required),
        otherBankName: new FormControl(this.vendor.BankAccount?.otherBankName || ''),    
      });
      
      // Check if bankName is 'other' and show otherBankName field accordingly
      if (this.vendor.BankAccount?.name === 'other') {
        this.onBankChange('other');
      }
    }
    
    this.confirmCheckboxControl = new FormControl(false, Validators.required);

    // In view mode, always check the disclaimer checkbox and disable it
    if (this.isViewMode) {
      this.confirmCheckboxControl.setValue(true, { emitEvent: false });  // Always check in view mode
      this.confirmCheckboxControl?.disable({ emitEvent: false });  // Disable the checkbox control
    }
      
    const mainOfficeTel = this.parseStoredPhoneForForm(this.vendor?.PhonePrimary || '');

    const companyTypeForForm = this.normalizeCompanyTypeForForm((this.vendor as any)?.companyType);
    const vendorCompanyType = companyTypeForForm.selected;
    this.selectedCompanyType = vendorCompanyType;

    // Get vendor name - check multiple sources
    const vendorName = this.vendor?.vendorName || (this.vendor as any)?.name || (this.vendor as any)?.VendorName || '';

    this.GeneralFormTab = this._formBuilder.group({
      // Company Name (required)
      companyName: [vendorName, Validators.required],
      
      // Nature of Business
      natureOfBusiness: [(this.vendor as any)?.natureOfBusiness || '', Validators.required],

      // Primary Contacts (FormArray) - multiple contacts like Subsidiaries
      primaryContacts: (() => {
        const contactPersons = (this.vendor as any)?.contactPerson || (this.vendor as any)?.ContactPerson;
        const hasContacts = contactPersons && Array.isArray(contactPersons) && contactPersons.length > 0;
        return this._formBuilder.array(
          hasContacts
            ? contactPersons.map((c: any) => this.createPrimaryContactFormGroup(c))
            : [this.createPrimaryContactFormGroup({})]
        );
      })(),

      // Main Office / Headquarters: Correspondence Address
      mainOffice: this._formBuilder.group({
        poBox: [(this.vendor as any)?.poBox || ''],
        telephone: [mainOfficeTel.mobileNumber || ''],
        telephoneCode: [mainOfficeTel.mobileCode || this.defaultCountryCode],
        street: [this.vendor?.StreetPrimary || '', Validators.required],
        zoneNo: [(this.vendor as any)?.zoneNo || ''],
        streetNo: [(this.vendor as any)?.streetNo || ''],
        buildingNo: [(this.vendor as any)?.buildingNo || ''],
        fax: [(this.vendor as any)?.fax || ''],
        city: [this.vendor?.CityPrimary || '', Validators.required],
        email: [this.vendor?.Email || ''],
        state: [(this.vendor as any)?.state || ''],
        website: [this.vendor?.website || ''],
        country: [this.vendor?.CountryRegionIdPrimary || '', Validators.required],
        zipCode: [this.vendor?.ZipCodePrimary || ''],
      }),

      // Parent Company Information
      parentCompany: this._formBuilder.group({
        name: [(this.vendor as any)?.parentCompanyName || ''],
        isDifferent: [(this.vendor as any)?.parentCompanyIsDifferent || false],
        previousName: [(this.vendor as any)?.parentCompanyPreviousName || ''],
      }),

      // Establishment and Employees
      establishment: this._formBuilder.group({
        country: [(this.vendor as any)?.establishmentCountry || '', Validators.required],
        year: [(this.vendor as any)?.establishmentYear || ''],
        employees: [this.vendor?.noOfEmployees || ''],
      }),

      // Subsidiaries (FormArray) - Initialize based on existing data
      // Check both camelCase and PascalCase property names
      subsidiaries: (() => {
        const vendorSubsidiaries = (this.vendor as any)?.subsidiaries || (this.vendor as any)?.Subsidiaries;
        const hasSubsidiariesData = vendorSubsidiaries && Array.isArray(vendorSubsidiaries) && vendorSubsidiaries.length > 0;
        this.hasSubsidiaries = hasSubsidiariesData;
        return this._formBuilder.array(
          hasSubsidiariesData
            ? vendorSubsidiaries.map((subsidiary: any) => this.createSubsidiaryFormGroup(subsidiary, true))
            : [this.createSubsidiaryFormGroup({}, false)]
        );
      })(),

      // Company Nature Selection (Single-select)
      companyType: [vendorCompanyType || '', Validators.required],
      otherCompanyType: [companyTypeForForm.other],

      // Additional Information
      additionalInfo: this._formBuilder.group({
        commercialReg: [(this.vendor as any)?.commercialRegNumber || '', Validators.required],
        chamberMembership: [(this.vendor as any)?.chamberMembershipNumber || ''],
        importLicense: [(this.vendor as any)?.importLicenseNumber || ''],
      }),

      // Keep old fields for backward compatibility (readonly/display only)
      vendorName: [vendorName, Validators.required],
      // Root email is not shown on Supplier Information; primary contact email is the one required and displayed
      email: [this.vendor?.Email || '', [Validators.email]],

       
    });
  
    this.setupQatarAddressValidators(this.GeneralFormTab.get('mainOffice') as FormGroup);

    // Sync selectedCompanyType with form control to ensure they're always in sync
    this.GeneralFormTab.get('companyType')?.setValue(vendorCompanyType, { emitEvent: false });
    
    // Apply validator to the main otherCompanyType field if "Other" is selected
    if (this.selectedCompanyType === 'Other') {
      const otherCompanyTypeControl = this.GeneralFormTab.get('otherCompanyType');
      otherCompanyTypeControl?.setValidators(Validators.required);
      otherCompanyTypeControl?.updateValueAndValidity();
    }

    // personalInformationForm - Only for Individual account type
    if (this.vendor?.vendorType === VendorType.Individual) {
      const personalMobile = this.parseStoredPhoneForForm(this.vendor?.PhonePrimary || this.user?.MobilePhone || '');
      const personalEmail = this.vendor?.Email || (this.user as any)?.email || '';
      const personalFullName = this.vendor?.vendorName || (this.vendor as any)?.name || (this.vendor as any)?.VendorName || '';
      
      this.personalInformationForm = this._formBuilder.group({
        fullName: [{ value: personalFullName, disabled: this.isViewMode }],
        nationalId: [{ value: (this.vendor as any)?.qatid || '', disabled: this.isViewMode }, Validators.required],
        passportNo: [{ value: (this.vendor as any)?.passport || '', disabled: this.isViewMode }],
        localOrForeign: [{ value: (this.vendor as any)?.LocalOrForeign || '', disabled: this.isViewMode }],
        nationality: [{ value: (this.vendor as any)?.nationality || (this.vendor as any)?.CountryRegionIdPrimary || '', disabled: this.isViewMode }, Validators.required],
        dateOfBirth: [{ value: this.formatDate((this.vendor as any)?.dateOfBirth) || '', disabled: this.isViewMode }, Validators.required],
        gender: [{ value: (this.vendor as any)?.gender || '', disabled: this.isViewMode }],
        residentialAddress: [{ value: (this.vendor as any)?.residentialAddress || (this.vendor as any)?.StreetPrimary || '', disabled: this.isViewMode }],
        city: [{ value: (this.vendor as any)?.city || (this.vendor as any)?.CityPrimary || '', disabled: this.isViewMode }, Validators.required],
        country: [{ value: (this.vendor as any)?.CountryRegionIdPrimary || (this.vendor as any)?.countryRegionIdPrimary || (this.vendor as any)?.country || '', disabled: this.isViewMode }, Validators.required],
        zoneNo: [{ value: (this.vendor as any)?.zoneNo || '', disabled: this.isViewMode }],
        streetNo: [{ value: (this.vendor as any)?.streetNo || '', disabled: this.isViewMode }],
        buildingNo: [{ value: (this.vendor as any)?.buildingNo || '', disabled: this.isViewMode }],
        mobileNumber: [{ value: personalMobile.mobileNumber || '', disabled: this.isViewMode }],
        mobileNumberCode: [{ value: personalMobile.mobileCode || this.defaultCountryCode, disabled: this.isViewMode }],
        emailAddress: [{ value: personalEmail, disabled: this.isViewMode }, [Validators.email]]
      });

      this.setupQatarAddressValidators(this.personalInformationForm);
      this.setupLocalForeignValidators(this.personalInformationForm);

      // businessInformationForm - Only for Individual account type
      this.businessInformationForm = this._formBuilder.group({
        tradingName: [{ value: (this.vendor as any)?.tradingName || '', disabled: this.isViewMode }],
        typeOfBusinessActivity: [{ value: (this.vendor as any)?.typeOfBusinessActivity || '', disabled: this.isViewMode }],
        yearsOfExperience: [{ value: (this.vendor as any)?.yearsOfExperience || '', disabled: this.isViewMode }, Validators.required],
        descriptionOfGoodsServices: [{ value: (this.vendor as any)?.descriptionOfGoodsServices || (this.vendor as any)?.description || '', disabled: this.isViewMode }]
      });

      // taxLegalForm - Only for Individual account type
      this.taxLegalForm = this._formBuilder.group({
        taxIdentificationNumber: [{ value: (this.vendor as any)?.taxIdentificationNumber || (this.vendor as any)?.taxId || '', disabled: this.isViewMode }],
        vatRegistrationNumber: [{ value: (this.vendor as any)?.vatRegistrationNumber || (this.vendor as any)?.vatNumber || '', disabled: this.isViewMode }],
        countryOfTaxResidence: [{ value: (this.vendor as any)?.countryOfTaxResidence || (this.vendor as any)?.taxResidenceCountry || '', disabled: this.isViewMode }]
      });

      // attachmentsForm - Only for Individual account type (ATTACHMENTS step)
      this.attachmentsForm = this._formBuilder.group({
        copyOfIdPassport: [''],
        bankAccountConfirmation: [''],
        portfolioCv: [''],
        proofOfAddress: [''],
        licensesCertificates: ['']
      });
    }
  
    // companyOwnershipForm
    // Check both camelCase and PascalCase property names
    const vendorPartners = (this.vendor as any)?.partners || (this.vendor as any)?.Partners;
    // Check seniorManagement first, then fall back to ManagementTeam (which needs to be mapped)
    let vendorSeniorManagement = (this.vendor as any)?.seniorManagement || (this.vendor as any)?.SeniorManagement;
    
    // If seniorManagement is not available, try to map from ManagementTeam
    if ((!vendorSeniorManagement || !Array.isArray(vendorSeniorManagement) || vendorSeniorManagement.length === 0) && 
        (this.vendor as any)?.ManagementTeam && Array.isArray((this.vendor as any).ManagementTeam)) {
      vendorSeniorManagement = (this.vendor as any).ManagementTeam.map((member: any) => ({
        name: member.Name || member.name || '',
        title: member.Title || member.title || '',
        nationality: member.Nationality || member.nationality || '',
        email: member.Email || member.email || '',
        landlineNumber: member.LandlineNumber || member.landlineNumber || '',
        mobileNumber: member.MobileNumber || member.mobileNumber || ''
      }));
    }
    
    // Find countryRegionId for ownerNationality (handle backward compatibility)
    const ownerNationalityValue = this.findCountryRegionId((this.vendor as any)?.ownerNationality);
    
    this.companyOwnershipForm = this._formBuilder.group({
      ownerName: [(this.vendor as any)?.ownerName || '', Validators.required],
      ownerNationality: [ownerNationalityValue, Validators.required],
      partners: this._formBuilder.array(
        vendorPartners && Array.isArray(vendorPartners) && vendorPartners.length > 0
          ? vendorPartners.map((partner: any) => this.createPartnerFormGroup(partner)) 
          : []
      ),
      seniorManagement: this._formBuilder.array(
        vendorSeniorManagement && Array.isArray(vendorSeniorManagement) && vendorSeniorManagement.length > 0
          ? vendorSeniorManagement.map((member: any) => this.createSeniorManagementFormGroup(member)) 
          : []
      ),
    });

    if (this.partners.length === 0)
      this.addPartner();
    
    if (this.seniorManagement.length === 0)
      this.addSeniorManagement();

    if (this.contacts && this.contacts.length === 0)  
      this.addPersistentContact();

    // financialDetailsForm - Initialize if not already initialized
    if (!this.financialDetailsForm) {
      // Get annualTurnovers from vendor data if available - check both camelCase and PascalCase
      const vendorAnnualTurnovers = (this.vendor as any)?.annualTurnovers || (this.vendor as any)?.AnnualTurnovers;
      let annualTurnoversArray: FormGroup[] = [];
      
      if (vendorAnnualTurnovers && Array.isArray(vendorAnnualTurnovers) && vendorAnnualTurnovers.length > 0) {
        // Use vendor data
        annualTurnoversArray = vendorAnnualTurnovers.map((turnover: any) =>
          this._formBuilder.group({
            yearNumber: [turnover.yearNumber || turnover.YearNumber || turnover.year || turnover.Year || 1],
            value: [turnover.value || turnover.Value || turnover.turnoverAmount || turnover.TurnoverAmount || '', [Validators.required, this.validNumberValidator(), this.positiveNumberValidator(), this.maxCharacterLengthValidator(16)]]
          })
        );
      } else {
        // Initialize YR 1-3 as default
        for (let i = 1; i <= 3; i++) {
          annualTurnoversArray.push(this._formBuilder.group({
            yearNumber: [i],
            value: ['', [Validators.required, this.validNumberValidator(), this.positiveNumberValidator(), this.maxCharacterLengthValidator(16)]]
          }));
        }
      }
      
      // Determine default currency based on localOrForeign
      let defaultCurrency = (this.vendor as any)?.currency || '';
      if (!defaultCurrency && this.Currencies && this.Currencies.length > 0) {
        const localOrForeign = this.vendor?.localOrForeign?.toLowerCase() || '';
        if (localOrForeign === 'local') {
          // Find QAR currency
          const qarCurrency = this.Currencies.find(c => 
            c.currencyId?.toUpperCase() === 'QAR' || 
            c.description?.toUpperCase().includes('QAR') ||
            c.description?.toUpperCase().includes('QATAR')
          );
          if (qarCurrency) {
            defaultCurrency = qarCurrency.currencyId;
          }
        } else if (localOrForeign === 'foreign') {
          // Find USD currency
          const usdCurrency = this.Currencies.find(c => 
            c.currencyId?.toUpperCase() === 'USD' || 
            c.description?.toUpperCase().includes('USD') ||
            c.description?.toUpperCase().includes('US DOLLAR')
          );
          if (usdCurrency) {
            defaultCurrency = usdCurrency.currencyId;
          }
        }
      }
      
      this.financialDetailsForm = this._formBuilder.group({
        currency: [defaultCurrency, Validators.required],
        authorizedCapital: [(this.vendor as any)?.authorizedCapital || '', [Validators.required, this.validNumberValidator(), this.positiveNumberValidator()]],
        creditRating: [(this.vendor as any)?.creditRating || ''], // Not mandatory (if applicable)
        netProfit: [(this.vendor as any)?.netProfit || '', [Validators.required, this.validNumberValidator(), this.nonZeroNumberValidator()]],
        totalAssets: [(this.vendor as any)?.totalAssets || '', [Validators.required, this.validNumberValidator(), this.positiveNumberValidator()]],
        currentRatio: [(this.vendor as any)?.currentRatio || '', [Validators.required]],
        latestAnnualTurnover: [(this.vendor as any)?.latestAnnualTurnover || '', [Validators.required, this.validNumberValidator(), this.positiveNumberValidator()]],
        currentYear: [(this.vendor as any)?.currentYear || 2025, Validators.required],
        annualTurnovers: this._formBuilder.array(annualTurnoversArray)
      });
    } else {
      // If form exists, populate with vendor data if available
      const annualTurnoversArray = this.financialDetailsForm.get('annualTurnovers') as FormArray;
      const vendorAnnualTurnovers = (this.vendor as any)?.annualTurnovers || (this.vendor as any)?.AnnualTurnovers;
      
      if (vendorAnnualTurnovers && Array.isArray(vendorAnnualTurnovers) && vendorAnnualTurnovers.length > 0) {
        annualTurnoversArray.clear();
        vendorAnnualTurnovers.forEach((turnover: any) => {
          annualTurnoversArray.push(this._formBuilder.group({
            yearNumber: [turnover.yearNumber || turnover.YearNumber || turnover.year || turnover.Year || 1],
            value: [turnover.value || turnover.Value || turnover.turnoverAmount || turnover.TurnoverAmount || '', [Validators.required, this.validNumberValidator(), this.positiveNumberValidator(), this.maxCharacterLengthValidator(16)]]
          }));
        });
      } else if (annualTurnoversArray && annualTurnoversArray.length === 0) {
        // Initialize YR 1-3 if empty
        for (let i = 1; i <= 3; i++) {
          annualTurnoversArray.push(this._formBuilder.group({
            yearNumber: [i],
            value: ['', [Validators.required, this.validNumberValidator(), this.positiveNumberValidator(), this.maxCharacterLengthValidator(16)]]
          }));
        }
      }
      
      // Update other financial fields - only patch if vendor data exists, otherwise keep existing values
      const financialData: any = {};
      if ((this.vendor as any)?.currency !== undefined && (this.vendor as any)?.currency !== null) {
        financialData.currency = (this.vendor as any).currency;
      } else {
        // Set default currency if not already set
        const currentCurrency = this.financialDetailsForm.get('currency')?.value;
        if (!currentCurrency && this.Currencies && this.Currencies.length > 0) {
          const localOrForeign = this.vendor?.localOrForeign?.toLowerCase() || '';
          if (localOrForeign === 'local') {
            // Find QAR currency
            const qarCurrency = this.Currencies.find(c => 
              c.currencyId?.toUpperCase() === 'QAR' || 
              c.description?.toUpperCase().includes('QAR') ||
              c.description?.toUpperCase().includes('QATAR')
            );
            if (qarCurrency) {
              financialData.currency = qarCurrency.currencyId;
            }
          } else if (localOrForeign === 'foreign') {
            // Find USD currency
            const usdCurrency = this.Currencies.find(c => 
              c.currencyId?.toUpperCase() === 'USD' || 
              c.description?.toUpperCase().includes('USD') ||
              c.description?.toUpperCase().includes('US DOLLAR')
            );
            if (usdCurrency) {
              financialData.currency = usdCurrency.currencyId;
            }
          }
        }
      }
      if ((this.vendor as any)?.authorizedCapital !== undefined && (this.vendor as any)?.authorizedCapital !== null) {
        financialData.authorizedCapital = (this.vendor as any).authorizedCapital;
      }
      if ((this.vendor as any)?.creditRating !== undefined && (this.vendor as any)?.creditRating !== null) {
        financialData.creditRating = (this.vendor as any).creditRating;
      }
      if ((this.vendor as any)?.netProfit !== undefined && (this.vendor as any)?.netProfit !== null) {
        financialData.netProfit = (this.vendor as any).netProfit;
      }
      if ((this.vendor as any)?.totalAssets !== undefined && (this.vendor as any)?.totalAssets !== null) {
        financialData.totalAssets = (this.vendor as any).totalAssets;
      }
      if ((this.vendor as any)?.currentRatio !== undefined && (this.vendor as any)?.currentRatio !== null) {
        financialData.currentRatio = (this.vendor as any).currentRatio;
      }
      if ((this.vendor as any)?.latestAnnualTurnover !== undefined && (this.vendor as any)?.latestAnnualTurnover !== null) {
        financialData.latestAnnualTurnover = (this.vendor as any).latestAnnualTurnover;
      }
      if ((this.vendor as any)?.currentYear !== undefined && (this.vendor as any)?.currentYear !== null) {
        financialData.currentYear = (this.vendor as any).currentYear;
      }
      
      // Update validators for all fields except creditRating
      this.financialDetailsForm.get('currency')?.setValidators(Validators.required);
      this.financialDetailsForm.get('authorizedCapital')?.setValidators([Validators.required, this.validNumberValidator(), this.positiveNumberValidator()]);
      this.financialDetailsForm.get('netProfit')?.setValidators([Validators.required, this.validNumberValidator(), this.nonZeroNumberValidator()]);
      this.financialDetailsForm.get('totalAssets')?.setValidators([Validators.required, this.validNumberValidator(), this.positiveNumberValidator()]);
      this.financialDetailsForm.get('currentRatio')?.setValidators([Validators.required]);
      this.financialDetailsForm.get('latestAnnualTurnover')?.setValidators([Validators.required, this.validNumberValidator(), this.positiveNumberValidator()]);
      this.financialDetailsForm.get('currentYear')?.setValidators(Validators.required);
      // creditRating remains optional (no validators)
      
      // Only patch if we have data to patch
      if (Object.keys(financialData).length > 0) {
        this.financialDetailsForm.patchValue(financialData);
      }
      
      // Update validity after setting validators
      this.financialDetailsForm.get('currency')?.updateValueAndValidity();
      this.financialDetailsForm.get('authorizedCapital')?.updateValueAndValidity();
      this.financialDetailsForm.get('netProfit')?.updateValueAndValidity();
      this.financialDetailsForm.get('totalAssets')?.updateValueAndValidity();
      this.financialDetailsForm.get('currentRatio')?.updateValueAndValidity();
      this.financialDetailsForm.get('latestAnnualTurnover')?.updateValueAndValidity();
      this.financialDetailsForm.get('currentYear')?.updateValueAndValidity();
    }

    // capabilityExperienceForm - Initialize if not already initialized
    if (!this.capabilityExperienceForm) {

      // Get authorizedRepresentatives from vendor data if available - check both camelCase and PascalCase
      const vendorAuthReps = (this.vendor as any)?.authorizedRepresentatives || (this.vendor as any)?.AuthorizedRepresentatives;
      const authRepsArray = vendorAuthReps && Array.isArray(vendorAuthReps) && vendorAuthReps.length > 0
        ? vendorAuthReps.map((authRep: any, index: number) => {
            const authRepFormGroup = this._formBuilder.group({
              company: [authRep.company || authRep.Company || '', Validators.required],
              poBox: [authRep.poBox || authRep.PoBox || '', Validators.required],
              telNo: [authRep.telNo || authRep.TelNo || '', Validators.required],
              faxNo: [authRep.faxNo || authRep.FaxNo || ''],
              productsRepresented: [authRep.productsRepresented || authRep.ProductsRepresented || '', Validators.required],
              productsRepresentedFile: [authRep.productsRepresentedFile || authRep.ProductsRepresentedFile || '', Validators.required]
            });
            
            // Disable if in view mode
            if (this.isViewMode) {
              authRepFormGroup.disable({ emitEvent: false });
            }
            
            return authRepFormGroup;
          })
        : [];

      // Get SubSubCategories from vendor data if available
      const vendorSubSubCategories = (this.vendor as any)?.SubSubCategories || [];

      this.capabilityExperienceForm = this._formBuilder.group({
        coreProductsServices: [(this.vendor as any)?.coreProductsServices || ''],
        previousExperience: [(this.vendor as any)?.previousExperience || ''],
        SubSubCategories: [vendorSubSubCategories],
        additionalInformation: [(this.vendor as any)?.additionalInformation || ''],
        contractsProjectsDetails: [(this.vendor as any)?.contractsProjectsDetails || '', Validators.required],
        isAuthorizedRepresentative: [(() => {
          // Check if vendor has isAuthorizedRepresentative set
          if ((this.vendor as any)?.isAuthorizedRepresentative !== undefined) {
            return (this.vendor as any).isAuthorizedRepresentative;
          }
          // Check if we have authorized representatives in the data
          if (authRepsArray.length > 0) {
            return true;
          }
          // Check if we have authorized rep attachments
          const hasAuthRepAttachments = this.vendor.Attachments?.some(att => 
            att.AttachmentFor && att.AttachmentFor.startsWith('authorizedRepFile_')
          );
          if (hasAuthRepAttachments) {
            return true;
          }
          return null;
        })()],
        authorizedRepresentatives: this._formBuilder.array(authRepsArray)
      });

      // Load and select tree items from SubSubCategories
      this.loadTreeSelectionsFromSubSubCategories(vendorSubSubCategories);

      // Add listener to automatically add one representative when "Yes" is selected for the first time
      this.capabilityExperienceForm.get('isAuthorizedRepresentative')?.valueChanges.subscribe(value => {
        if (value === true && this.authorizedRepresentatives.length === 0) {
          this.addAuthorizedRepresentative();
        } else if (value === false) {
          // Clear all authorized representatives when "No" is selected
          while (this.authorizedRepresentatives.length > 0) {
            this.authorizedRepresentatives.removeAt(0);
          }
        }
      });
      
      // Categories and SubCategories fields removed - using tree structure only
      
    } else {
      // If form exists, populate with vendor data
      const vendorCategories = (this.vendor as any)?.Categories || [];
      const vendorSubCategories = (this.vendor as any)?.SubCategories || [];
      
      // Get authorizedRepresentatives from vendor data if available - check both camelCase and PascalCase
      const vendorAuthReps = (this.vendor as any)?.authorizedRepresentatives || (this.vendor as any)?.AuthorizedRepresentatives;
      // Clear and repopulate authorizedRepresentatives FormArray
      const authRepsFormArray = this.capabilityExperienceForm.get('authorizedRepresentatives') as FormArray;
      if (authRepsFormArray) {
        authRepsFormArray.clear();
        if (vendorAuthReps && Array.isArray(vendorAuthReps) && vendorAuthReps.length > 0) {
          vendorAuthReps.forEach((authRep: any, index: number) => {
            const authRepFormGroup = this._formBuilder.group({
              company: [authRep.company || authRep.Company || '', Validators.required],
              poBox: [authRep.poBox || authRep.PoBox || '', Validators.required],
              telNo: [authRep.telNo || authRep.TelNo || '', Validators.required],
              faxNo: [authRep.faxNo || authRep.FaxNo || ''],
              productsRepresented: [authRep.productsRepresented || authRep.ProductsRepresented || '', Validators.required],
              productsRepresentedFile: [authRep.productsRepresentedFile || authRep.ProductsRepresentedFile || '', Validators.required]
            });
            
            // Disable if in view mode
            if (this.isViewMode) {
              authRepFormGroup.disable({ emitEvent: false });
            }
            
            authRepsFormArray.push(authRepFormGroup);
          });
        }
      }
      
      // Get SubSubCategories from vendor data if available
      const vendorSubSubCategoriesElse = (this.vendor as any)?.SubSubCategories || [];

      this.capabilityExperienceForm.patchValue({
        coreProductsServices: (this.vendor as any)?.coreProductsServices || '',
        previousExperience: (this.vendor as any)?.previousExperience || '',
        SubSubCategories: vendorSubSubCategoriesElse,
        additionalInformation: (this.vendor as any)?.additionalInformation || '',
        contractsProjectsDetails: (this.vendor as any)?.contractsProjectsDetails || '',
        isAuthorizedRepresentative: (this.vendor as any)?.isAuthorizedRepresentative !== undefined 
          ? (this.vendor as any).isAuthorizedRepresentative 
          : (vendorAuthReps && Array.isArray(vendorAuthReps) && vendorAuthReps.length > 0 ? true : null),
      });
      
      // Load and select tree items from SubSubCategories
      this.loadTreeSelectionsFromSubSubCategories(vendorSubSubCategoriesElse);
    }

    // OtherDocuments form - Initialize if not already initialized
    if (!this.OtherDocuments) {
      this.OtherDocuments = this._formBuilder.group({
        healthSafetyPolicy: [null],
        healthSafetyPolicyFile: [''],
        antiBriberyPolicy: [null],
        antiBriberyPolicyFile: [''],
        modernSlaveryCompliance: [null],
        modernSlaveryComplianceFile: [''],
        environmentalPolicy: [null],
        environmentalPolicyFile: [''],
        gdprCompliance: [null],
        gdprComplianceFile: [''],
        conflictsOfInterest: [null],
        conflictsOfInterestFile: ['']
      });
    }

    // Warehousing & Storage Form - Populate with vendor data if available
    if (this.warehousingStorageForm) {
      this.warehousingStorageForm.patchValue({
        warehousingStorageDetails: (this.vendor as any)?.warehousingStorageDetails || '',
        transportFreightForwardingDetails: (this.vendor as any)?.transportFreightForwardingDetails || ''
      });
      
      // Disable if in view mode
      if (this.isViewMode) {
        this.warehousingStorageForm.disable({ emitEvent: false });
      }
    }

    // Other Information Form - Populate with vendor data if available
    if (this.otherInformationForm) {
      this.otherInformationForm.patchValue({
        otherInformation: (this.vendor as any)?.otherInformation || ''
      });
      
      // Disable if in view mode
      if (this.isViewMode) {
        this.otherInformationForm.disable({ emitEvent: false });
      }
    }


    // Disable all forms if in view mode or when user is secondary contact (view-only)
    if (this.isViewMode || this.isAbleToSubmitVendorFormApplication() || this.user?.ContactType === 'Secondary') {
      this.isViewMode = true;
      // Ensure disclaimer checkbox is checked in view mode
      if (this.confirmCheckboxControl) {
        this.confirmCheckboxControl.setValue(true, { emitEvent: false });
      }
      setTimeout(() => this.disableAllForms(), 0);
    } else {
      this.isViewMode = false;
      // Attach email/mobile uniqueness validation to contacts loaded from GetVendorDetails (so changing email triggers ValidateContactEmail)
      this.setupContactFieldValidation();
    }
  }

  private disableAllForms(): void {
    const forms = [
      this.GeneralFormTab,
      this.businessCategoryForm,
      this.companyOwnershipForm,
      this.financialDetailsForm,
      this.capabilityExperienceForm,
      this.OtherDocuments,
      this.bankAccountForm
    ];
    
    forms.forEach(form => {
      if (form && !form.disabled) {
        form.disable({ emitEvent: false });
      }
    });
    
    // Explicitly disable Tel No. and Mobile No. controls for all primary contact mobile-input components
    const primaryContactsArray = this.GeneralFormTab?.get('primaryContacts') as FormArray;
    if (primaryContactsArray) {
      primaryContactsArray.controls.forEach((ctrl) => {
        const group = ctrl as FormGroup;
        ['telNo', 'telNoCode', 'mobNo', 'mobNoCode'].forEach((key) => {
          const control = group.get(key);
          if (control && !control.disabled) {
            control.disable({ emitEvent: false });
          }
        });
      });
    }
    
    if (this.confirmCheckboxControl && !this.confirmCheckboxControl.disabled) {
      this.confirmCheckboxControl.disable({ emitEvent: false });
    }

    if (!this.isViewMode) {
      this.setupContactFieldValidation();
    }
  }

  /** Subscribes to primary contact email/mobile valueChanges and runs uniqueness API; sets contactEmailExists/contactMobileExists errors. */
  private setupContactFieldValidation(): void {
    const arr = this.GeneralFormTab?.get('primaryContacts') as FormArray;
    if (!arr) return;
    arr.controls.forEach((ctrl, index) => this.setupContactFieldValidationForContact(ctrl as FormGroup));
  }

  private setupContactFieldValidationForContact(contactForm: FormGroup): void {
    const emailControl = contactForm.get('email');
    const mobNoControl = contactForm.get('mobNo');
    const contactIdControl = contactForm.get('contactId');
    const getExcludeId = (): number | undefined => {
      const v = contactIdControl?.value;
      return v != null && v !== '' ? Number(v) : undefined;
    };
    if (emailControl) {
      emailControl.valueChanges.pipe(
        debounceTime(400),
        filter(() => !emailControl.disabled),
        switchMap((email: string) => {
          const trimmed = (email || '').trim();
          if (!trimmed || emailControl.hasError('email')) return of({ isAvailable: true });
          return this.vendorService.checkContactEmailAvailability(trimmed, getExcludeId()).catch(() => ({ isAvailable: true }));
        })
      ).subscribe((result) => {
        if (result.isAvailable) {
          const err = { ...emailControl.errors };
          delete (err as any).contactEmailExists;
          emailControl.setErrors(Object.keys(err).length ? err : null);
        } else {
          const msg = 'message' in result ? result.message : 'A contact with this email already exists.';
          emailControl.setErrors({ ...emailControl.errors, contactEmailExists: msg || 'A contact with this email already exists.' });
        }
      });
    }
    if (mobNoControl) {
      const mobNoCodeControl = contactForm.get('mobNoCode');
      mobNoControl.valueChanges.pipe(
        debounceTime(400),
        filter(() => !mobNoControl.disabled),
        switchMap((mobNo: string) => {
          const trimmed = (mobNo || '').trim().replace(/\D/g, '');
          if (!trimmed) return of({ isAvailable: true });
          const countryCode = (mobNoCodeControl?.value ?? this.defaultCountryCode ?? '+974').toString().trim();
          return this.vendorService.checkContactMobileAvailability(countryCode, trimmed, getExcludeId()).catch(() => ({ isAvailable: true }));
        })
      ).subscribe((result) => {
        if (result.isAvailable) {
          const err = { ...mobNoControl.errors };
          delete (err as any).contactMobileExists;
          mobNoControl.setErrors(Object.keys(err).length ? err : null);
        } else {
          const msg = 'message' in result ? result.message : 'A contact with this mobile number already exists.';
          mobNoControl.setErrors({ ...mobNoControl.errors, contactMobileExists: msg || 'A contact with this mobile number already exists.' });
        }
      });
    }
  }

  public isAbleToSubmitVendorFormApplication() {
    return this.vendor.Status?.toString().toLocaleLowerCase() == VendorStatus.Submitted.toString().toLocaleLowerCase(); /// set to true for now
  }

 


  private createContactFormGroup(contact: any): FormGroup {
     const mobileDetails = this.parseStoredPhoneForForm(contact.MobileNumber || '');
     const LandDetails = this.parseStoredPhoneForForm(contact.LandlineNumber || '');

    return this._formBuilder.group({
      firstName: [contact.FirstName || '', Validators.required],
      lastName: [contact.LastName || '', Validators.required],
      title: [contact.Title || ''],
      email: [contact.Email || '', [Validators.required, Validators.email]],
      landlindeNumber: [LandDetails.mobileNumber || ''], 
      landlindeNumberCode: [LandDetails.mobileCode || this.defaultCountryCode], 
      mobileNumber: [mobileDetails.mobileNumber || '', Validators.required],
      mobileNumberCode: [mobileDetails.mobileCode || this.defaultCountryCode, Validators.required],
    });
  }


  private createPrimaryContactFormGroup(contact: any): FormGroup {
    const c = contact as any;
    const hasExistingData = c?.Name || c?.FirstName || c?.LastName || c?.Email || c?.MobileNumber;
    const name = c?.Name || (c?.FirstName && c?.LastName ? `${c.FirstName} ${c.LastName}` : '') || '';
    const telDetails = this.parseStoredPhoneForForm(c?.LandlineNumber || '');
    const mobDetails = this.parseStoredPhoneForForm(c?.MobileNumber || (hasExistingData ? this.user?.MobilePhone : null) || '');
    const email = c?.Email || (hasExistingData ? this.vendor?.Email : null) || '';
    const contactId = c?.id ?? c?.ID ?? null;
    const status = c?.Status ?? c?.status ?? null;
    const isApprovedContact = status === 3; // 3 = Approved (ContactPersonStatus.Approved)
    return this._formBuilder.group({
      name: [name, Validators.required],
      title: [c?.Title || ''],
      telNo: [telDetails.mobileNumber || ''],
      telNoCode: [telDetails.mobileCode || this.defaultCountryCode],
      mobNo: [{ value: mobDetails.mobileNumber || '', disabled: isApprovedContact }, Validators.required],
      mobNoCode: [{ value: mobDetails.mobileCode || this.defaultCountryCode, disabled: isApprovedContact }],
      email: [{ value: email, disabled: isApprovedContact }, [Validators.required, Validators.email]],
      contactId: [contactId],
    });
  }

  public addPrimaryContact() {
    this.primaryContacts.push(this.createPrimaryContactFormGroup({}));
    this.setupContactFieldValidationForContact(this.primaryContacts.at(this.primaryContacts.length - 1) as FormGroup);
  }

  public deletePrimaryContact(index: number) {
    if (this.primaryContacts.controls.length > 1) {
      this.primaryContacts.removeAt(index);
    }
  }

  private createSubsidiaryFormGroup(subsidiary: any, addValidators: boolean = true): FormGroup {
    // Helper function to parse companyType (might be JSON string or array)
    const parseCompanyType = (companyType: any): string[] => {
      if (!companyType) return [];
      if (Array.isArray(companyType)) return companyType;
      if (typeof companyType === 'string') {
        try {
          const parsed = JSON.parse(companyType);
          return Array.isArray(parsed) ? parsed : [];
        } catch {
          return [companyType];
        }
      }
      return [];
    };

    return this._formBuilder.group({
      subsidiaryName: [subsidiary.subsidiaryName || subsidiary.SubsidiaryName || '', addValidators ? Validators.required : null],
      relationshipToParent: [subsidiary.relationshipToParent || subsidiary.RelationshipToParent || '', addValidators ? Validators.required : null],
      otherCompanyType: [subsidiary.otherCompanyType || subsidiary.OtherCompanyType || ''],
      companyType: [parseCompanyType(subsidiary.companyType || subsidiary.CompanyType)],
    });
  }
  


  /**
   * Helper method to find countryRegionId from nationality value
   * Handles backward compatibility where nationality might be stored as country name
   */
  private findCountryRegionId(nationality: any): string {
    if (!nationality) return '';
    
    // If it's already a countryRegionId (2-3 character code), return it
    if (typeof nationality === 'string' && nationality.length <= 3) {
      const country = this.Countries.find(c => c.countryRegionId?.toUpperCase() === nationality.toUpperCase());
      if (country) return country.countryRegionId;
    }
    
    // Try to find by country name (case-insensitive)
    if (typeof nationality === 'string') {
      const country = this.Countries.find(c => 
        c.countryName?.toLowerCase() === nationality.toLowerCase() ||
        c.countryName?.toLowerCase().includes(nationality.toLowerCase()) ||
        nationality.toLowerCase().includes(c.countryName?.toLowerCase() || '')
      );
      if (country) return country.countryRegionId;
    }
    
    // Return original value if not found (might be a valid countryRegionId)
    return nationality;
  }

  private createPartnerFormGroup(partner: any): FormGroup {
    const nationalityValue = this.findCountryRegionId(partner.nationality || partner.Nationality);
    const idRaw = partner.idNumber ?? partner.IdNumber ?? '';
    return this._formBuilder.group({
      name: [partner.name || partner.Name || '', Validators.required],
      percentageOfShare: [partner.percentageOfShare || partner.PercentageOfShare || '', [Validators.required, Validators.pattern(/^[0-9]+(\.[0-9]+)?$/), this.maxPercentageValidator(100)]],
      nationality: [nationalityValue, Validators.required],
      idNumber: [idRaw, [Validators.required, Validators.maxLength(14), Validators.pattern(/^\d+$/)]],
    });
  }

  private createSeniorManagementFormGroup(member: any): FormGroup {
    const nationalityValue = this.findCountryRegionId(member.nationality || member.Nationality);
    const landRaw = this.buildPhoneRawForParse(
      member.landlineNumber || member.LandlineNumber,
      member.phoneNumberCode || member.PhoneNumberCode,
      member.phoneNumber ?? member.PhoneNumber
    );
    const mobRaw = this.buildPhoneRawForParse(
      member.mobileNumber || member.MobileNumber,
      member.mobileNumberCode || member.MobileNumberCode,
      member.mobileNumber ?? member.MobileNumber
    );
    const land = this.parseStoredPhoneForForm(landRaw);
    const mob = this.parseStoredPhoneForForm(mobRaw);
    return this._formBuilder.group({
      name: [member.name || member.Name || '', Validators.required],
      title: [member.title || member.Title || '', Validators.required],
      nationality: [nationalityValue, Validators.required],
      email: [member.email || member.Email || '', [Validators.required, Validators.email]],
      phoneNumber: [land.mobileNumber || '', Validators.required],
      phoneNumberCode: [land.mobileCode || this.defaultCountryCode],
      mobileNumber: [mob.mobileNumber || ''],
      mobileNumberCode: [mob.mobileCode || this.defaultCountryCode],
    });
  }

  
  
  onBankChange(data: any = null): void {
    var selectedValue =  data || this.bankAccountForm.get('bankName')?.value;
    
    if (selectedValue === 'other') {
      this.showOtherBank = true;
      this.bankAccountForm.get('otherBankName')?.setValidators([Validators.required]);
    } else {
      this.showOtherBank = false;
      
      // Clear the value inside 'otherBankName'
      this.bankAccountForm.get('otherBankName')?.reset();
      
      this.bankAccountForm.get('otherBankName')?.clearValidators();
    }
  
    this.bankAccountForm.get('otherBankName')?.updateValueAndValidity();
  }

  getBankDescription(bankName: string): string {
    if (!bankName) return '';
    const bank = this.Banks.find(b => b.bankId === bankName);
    return bank ? bank.description : bankName;  // Return description or bankName if not found
  }

  onIbanInput(event: any): void {
    const input = event.target as HTMLInputElement;
    // Convert to uppercase and keep only alphanumeric characters
    let value = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    // Limit to 34 characters
    if (value.length > 34) {
      value = value.substring(0, 34);
    }
    // Update the form control value
    this.bankAccountForm.get('iban')?.setValue(value, { emitEvent: false });
    // Update the input field value
    input.value = value;
  }

  onPercentageInput(event: any, index: number): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    // Remove any characters that are not digits or decimal point
    value = value.replace(/[^0-9.]/g, '');
    // Ensure only one decimal point
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }
    // Check if value exceeds 100
    const numValue = parseFloat(value);
    if (value && !isNaN(numValue) && numValue > 100) {
      value = '100';
    }
    // Update the form control value
    const formGroup = this.partners.at(index) as FormGroup;
    formGroup.get('percentageOfShare')?.setValue(value, { emitEvent: false });
    // Update the input field value
    input.value = value;
  }

  private validNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const rawValue = control.value;
      if (rawValue === null || rawValue === undefined || rawValue === '') {
        return null;
      }

      const normalizedValue = String(rawValue).replace(/,/g, '').trim();
      if (normalizedValue === '') {
        return null;
      }

      const numericValue = Number(normalizedValue);
      return Number.isNaN(numericValue) ? { invalidNumber: true } : null;
    };
  }

  private positiveNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const rawValue = control.value;
      if (rawValue === null || rawValue === undefined || rawValue === '') {
        return null;
      }

      const normalizedValue = String(rawValue).replace(/,/g, '').trim();
      const numericParts = normalizedValue
        .split(/[:/]/)
        .map(part => part.trim())
        .filter(part => part !== '')
        .map(part => Number(part));

      if (numericParts.some(value => !Number.isNaN(value) && value <= 0)) {
        return { nonPositiveNumber: true };
      }

      return null;
    };
  }

  private nonZeroNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const rawValue = control.value;
      if (rawValue === null || rawValue === undefined || rawValue === '') {
        return null;
      }

      const normalizedValue = String(rawValue).replace(/,/g, '').trim();
      const numericValue = Number(normalizedValue);

      if (!Number.isNaN(numericValue) && numericValue === 0) {
        return { zeroNumber: true };
      }

      return null;
    };
  }

  private maxCharacterLengthValidator(maxLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value === null || value === undefined || value === '') {
        return null;
      }

      const actualLength = String(value).length;
      return actualLength > maxLength
        ? { maxlength: { requiredLength: maxLength, actualLength } }
        : null;
    };
  }

  private maxPercentageValidator(max: number): ValidatorFn {    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null; // No value means no error
      }
      const value = parseFloat(control.value);
      if (isNaN(value)) {
        return null; // Let pattern validator handle invalid numbers
      }
      return value > max ? { maxPercentage: { max, actual: value } } : null;
    };
  }
  
  private initiliazecontacts() {
    // if(this._mode == Mode.Edit) {

    //   this.vendor.contacts.forEach(mmbr => {
    //     this.contacts.insert(0, this._formBuilder.group({
    //       id: [mmbr.id],
    //       qid: [mmbr.qId, [Validators.required, Validators.minLength(11), Validators.maxLength(11), Validators.pattern(/^\d+$/)]],
    //       idExpiryDate: [mmbr.idExpiryDate, Validators.required],
    //       name: [mmbr.name, Validators.required],
    //       nationality: [mmbr.nationality == null? null : mmbr.nationality.id?? null , Validators.required],
    //       gender: [mmbr.gender.id,Validators.required],
    //       requestNumber: [mmbr.requestNumber],
    //       testDate: [mmbr.testDate],
    //       // lastName: [mmbr.lastName, Validators.required],
    //       copyOfId: [mmbr.copyofId, Validators.required]
    //     }));
    //   });

    // }
  }

  // onSignInAsChange() {
  //   const signInAs = this.VendorApplicationForm.get('signInAs')?.value;
  //   this.isOrganization = signInAs === 'organization';

  //   if (this.isOrganization) {
  //     this.accountInfoForm.get('singlePointOfContact')?.setValidators(Validators.required);
  //     this.accountInfoForm.get('companyName')?.setValidators(Validators.required);
  //     this.accountInfoForm.get('firstName')?.clearValidators();
  //     this.accountInfoForm.get('lastName')?.clearValidators();
  //   } else {
  //     this.accountInfoForm.get('singlePointOfContact')?.clearValidators();
  //     this.accountInfoForm.get('companyName')?.clearValidators();
  //     this.accountInfoForm.get('firstName')?.setValidators(Validators.required);
  //     this.accountInfoForm.get('lastName')?.setValidators(Validators.required);
  //   }

  //   this.accountInfoForm.get('singlePointOfContact')?.updateValueAndValidity();
  //   this.accountInfoForm.get('companyName')?.updateValueAndValidity();
  //   this.accountInfoForm.get('firstName')?.updateValueAndValidity();
  //   this.accountInfoForm.get('lastName')?.updateValueAndValidity();
  // }

  // onRegisteredInQNBNChange() {
  //   const registeredInQNBN = this.accountInfoForm.get('registeredInQNBN')?.value;
  //   this.isRegisteredInQNBN = registeredInQNBN === 'Yes';

  //   if (this.isRegisteredInQNBN) {
  //     this.accountInfoForm.get('referenceNumber')?.setValidators(Validators.required);
  //   } else {
  //     this.accountInfoForm.get('referenceNumber')?.clearValidators();
  //   }

  //   this.accountInfoForm.get('referenceNumber')?.updateValueAndValidity();
  // }


  public isFormValid() {
    return this._VendorApplicationForm.valid && this.accountInfoForm.valid;
  }

  get latestChangeRequestComments(): string {
    return ((this.vendor as any)?.RejectionReason ?? (this.vendor as any)?.rejectionReason ?? '').toString().trim();
  }

  private normalizeVendorStatus(status: any): string {
    return (status ?? '').toString().replace(/\s+/g, '').toLowerCase();
  }

  getVendorStatusDisplay(status: any = this.vendor?.Status ?? (this.vendor as any)?.status): string {
    const normalizedStatus = this.normalizeVendorStatus(status);
    if (normalizedStatus === VendorStatus.ChangeRequested.toLowerCase() || normalizedStatus === 'changerequested') {
      return 'Change Request';
    }

    return (status ?? '').toString();
  }

  getVendorStatusBadgeClass(status: any = this.vendor?.Status ?? (this.vendor as any)?.status): string {
    const normalizedStatus = this.normalizeVendorStatus(status);
    if (normalizedStatus === VendorStatus.ChangeRequested.toLowerCase() || normalizedStatus === 'changerequested') {
      return 'change-request';
    }

    return normalizedStatus;
  }

  get isChangeRequestedVendor(): boolean {
    const status = this.normalizeVendorStatus(this.vendor?.Status ?? (this.vendor as any)?.status);
    return status === VendorStatus.ChangeRequested.toLowerCase() || status === 'changerequested';
  }






public onSubmitForm(data) {
  this.invalidSubmit = false;
  this.handlesubmission(data);
}


  private markFormGroupTouched(formGroup: FormGroup | FormArray) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control) {
        control.markAsTouched();

        if (control instanceof FormGroup || control instanceof FormArray) {
          this.markFormGroupTouched(control);
        }
      }
    });
  }

    //#region API Service
    private createApiService(): ApiService {
      const apiService = new ApiService(this._http);
      apiService['_baseUrl'] = environment.API_URL; // Set the base URL manually
      return apiService;
    }
    //#endregion

    //#region Payloads
    private prepareValidateUserRequestPayload(data: any) {
      return data as VendorModel;
    }
    //#endregion 

    //#region Fire HTTP Requests
    private fireValidateUserRequest(apiService: ApiService, payload: VendorModel) {
      let req$ = apiService.post(AppConstants.CONTROLLERS.VENDOR, AppConstants.ACTIONS.UpdateVendor, true, environment.APIs_PREFIX, payload);
      return lastValueFrom(req$);
    }
  //#endregion

  
  private mapPersonalInformation(): Partial<UpdateVendorRequestDTO> {
    const formValue = this.personalInformationForm.getRawValue();
    const mobileNumber = this.formatDialCodeAndLocalForApi(formValue.mobileNumberCode, formValue.mobileNumber);

    const result: any = {
      vendorName: formValue.fullName,
      Email: formValue.emailAddress,
      PhonePrimary: mobileNumber,
      StreetPrimary: formValue.residentialAddress,
      CityPrimary: formValue.city,
      CountryRegionIdPrimary: formValue.country || undefined,
      zoneNo: formValue.zoneNo || undefined,
      streetNo: formValue.streetNo || undefined,
      buildingNo: formValue.buildingNo || undefined,

      // Personal Information fields for Individual vendors
      nationalId: formValue.nationalId || formValue.nationalIdPassport,
      passport: formValue.passportNo,
      localOrForeign: formValue.localOrForeign,
      nationality: formValue.nationality,
      dateOfBirth: formValue.dateOfBirth,
      gender: formValue.gender,
      mobileNumber: mobileNumber
    };

    return result;
  }

  private mapBusinessInformation(): Partial<UpdateVendorRequestDTO> {
    const formValue = this.businessInformationForm.getRawValue();
    const result: any = {
      tradingName: formValue.tradingName || undefined,
      typeOfBusinessActivity: formValue.typeOfBusinessActivity,
      yearsOfExperience: formValue.yearsOfExperience,
      descriptionOfGoodsServices: formValue.descriptionOfGoodsServices
    };
    return result;
  }

  private mapTaxLegalInformation(): Partial<UpdateVendorRequestDTO> {
    const formValue = this.taxLegalForm.getRawValue();
    const result: any = {
      taxIdentificationNumber: formValue.taxIdentificationNumber || undefined,
      vatRegistrationNumber: formValue.vatRegistrationNumber || undefined,
      countryOfTaxResidence: formValue.countryOfTaxResidence || undefined
    };
    return result;
  }

  private mapGeneralForm(): Partial<UpdateVendorRequestDTO> {
    const primaryContactsArray = this.GeneralFormTab.get('primaryContacts') as FormArray;
    const mainOffice = this.GeneralFormTab.get('mainOffice');
    const parentCompany = this.GeneralFormTab.get('parentCompany');
    const establishment = this.GeneralFormTab.get('establishment');
    const additionalInfo = this.GeneralFormTab.get('additionalInfo');
    const subsidiariesArray = this.GeneralFormTab.get('subsidiaries') as FormArray;

    // Build contactPerson array from current form values so user edits are always sent.
    // Use existing vendor contact only as fallback when form has no value (e.g. optional field).
    const existingContacts = (this.vendor as any)?.contactPerson || (this.vendor as any)?.ContactPerson || [];
    const contactPerson = (primaryContactsArray?.controls || []).map((ctrl, index) => {
      const g = ctrl as FormGroup;
      const existing = Array.isArray(existingContacts) ? existingContacts[index] : null;
      const telNoCode = g?.get('telNoCode')?.value;
      const telNo = g?.get('telNo')?.value;
      const landlineNumber = this.formatDialCodeAndLocalForApi(telNoCode, telNo);
      const title = g?.get('title')?.value || undefined;
      const mobNoCode = g?.get('mobNoCode')?.value;
      const mobNo = g?.get('mobNo')?.value;
      const formMobile = this.formatDialCodeAndLocalForApi(mobNoCode, mobNo);
      return {
        name: g?.get('name')?.value ?? existing?.Name ?? existing?.name ?? '',
        title,
        email: g?.get('email')?.value ?? existing?.Email ?? existing?.email ?? '',
        landlineNumber,
        mobileNumber: formMobile ?? existing?.MobileNumber ?? existing?.mobileNumber
      };
    });

    const firstContactEmail = (primaryContactsArray?.at(0) as FormGroup)?.get('email')?.value
      || (contactPerson[0]?.email);
    // Always send a string so the API body includes `Email` and the backend updates Vendor.Email (GenericRepository skips nulls).
    const mainOfficeEmailTrimmed = String(mainOffice?.get('email')?.value ?? '').trim();
    const firstContactEmailTrimmed = String(firstContactEmail ?? '').trim();
    const vendorEmailPayload = mainOfficeEmailTrimmed || firstContactEmailTrimmed || '';

    // Get company name (single source)
    const companyName = this.GeneralFormTab.get('companyName')?.value || this.GeneralFormTab.get('vendorName')?.value || '';

    return {
      // Company Name (single field, no duplicate)
      vendorName: companyName,
      natureOfBusiness: this.GeneralFormTab.get('natureOfBusiness')?.value || undefined,

      // Primary Contacts (multiple)
      contactPerson,

      // Main Office / Headquarters
      StreetPrimary: mainOffice?.get('street')?.value || undefined,
      CityPrimary: mainOffice?.get('city')?.value || undefined,
      CountryRegionIdPrimary: mainOffice?.get('country')?.value || undefined,
      ZipCodePrimary: mainOffice?.get('zipCode')?.value || undefined,
      website: mainOffice?.get('website')?.value || undefined,
      Email: vendorEmailPayload,
      PhonePrimary: this.formatDialCodeAndLocalForApi(
        mainOffice?.get('telephoneCode')?.value,
        mainOffice?.get('telephone')?.value
      ),
      AddressDescriptionPrimary: `${mainOffice?.get('street')?.value || ''}, ${mainOffice?.get('city')?.value || ''}`,
      poBox: mainOffice?.get('poBox')?.value || undefined,
      fax: mainOffice?.get('fax')?.value || undefined,
      state: mainOffice?.get('state')?.value || undefined,
      zoneNo: mainOffice?.get('zoneNo')?.value || undefined,
      streetNo: mainOffice?.get('streetNo')?.value || undefined,
      buildingNo: mainOffice?.get('buildingNo')?.value || undefined,

      // Parent company
      parentCompanyName: parentCompany?.get('name')?.value || undefined,
      parentCompanyIsDifferent: parentCompany?.get('isDifferent')?.value ?? undefined,
      parentCompanyPreviousName: parentCompany?.get('previousName')?.value || undefined,

      // Establishment
      establishmentCountry: establishment?.get('country')?.value || undefined,
      establishmentYear: establishment?.get('year')?.value ? parseInt(establishment.get('year')?.value, 10) : undefined,
      noOfEmployees: establishment?.get('employees')?.value || undefined,

      // Additional Information
      financeEmail: this.GeneralFormTab.get('financeEmail')?.value || undefined,
      commercialRegNumber: additionalInfo?.get('commercialReg')?.value || undefined,
      chamberMembershipNumber: additionalInfo?.get('chamberMembership')?.value || undefined,
      importLicenseNumber: additionalInfo?.get('importLicense')?.value || undefined,
      isoCertification: additionalInfo?.get('isoCertification')?.value || undefined,
      
      companyType: (() => {
        const companyTypeValue = this.GeneralFormTab.get('companyType')?.value;
        if (companyTypeValue == null || companyTypeValue === '') return undefined;
        if (companyTypeValue === 'Other') {
          return String(this.GeneralFormTab.get('otherCompanyType')?.value || '').trim() || undefined;
        }
        const s = Array.isArray(companyTypeValue) ? String(companyTypeValue[0] ?? '') : String(companyTypeValue);
        return s.trim() || undefined;
      })(),
      
      
      // Subsidiaries - filter out empty subsidiaries (where both name and relationship are empty)
      // Each subsidiary has its own companyType (multi-select array)
      subsidiaries: subsidiariesArray.controls
        .filter(control => {
          const name = control.get('subsidiaryName')?.value;
          const relationship = control.get('relationshipToParent')?.value;
          // Keep if at least one field has a value
          return (name && name.trim()) || (relationship && relationship.trim());
        })
        .map(control => {
          return {
            subsidiaryName: control.get('subsidiaryName')?.value || '',
            relationshipToParent: control.get('relationshipToParent')?.value || ''
          };
        }),

    };
  }

  private mapCompanyOwnership(): Partial<VendorModel> {
    const partnersArray = this.companyOwnershipForm.get('partners') as FormArray;
    const seniorManagementArray = this.companyOwnershipForm.get('seniorManagement') as FormArray;

    return {
      ownerName: this.companyOwnershipForm.get('ownerName')?.value || null,
      ownerNationality: this.companyOwnershipForm.get('ownerNationality')?.value || null,
      partners: partnersArray.controls.map(control => ({
        name: control.get('name')?.value || '',
        percentageOfShare: control.get('percentageOfShare')?.value || '',
        nationality: control.get('nationality')?.value || '',
        idNumber: control.get('idNumber')?.value || ''
      })),
      seniorManagement: seniorManagementArray.controls.map(control => {
        const phoneCode = control.get('phoneNumberCode')?.value;
        const phoneNum = control.get('phoneNumber')?.value;
        const mobCode = control.get('mobileNumberCode')?.value;
        const mobNum = control.get('mobileNumber')?.value;
        return {
          name: control.get('name')?.value || '',
          title: control.get('title')?.value || '',
          nationality: control.get('nationality')?.value || '',
          email: control.get('email')?.value || '',
          landlineNumber: this.formatDialCodeAndLocalForApi(phoneCode, phoneNum),
          mobileNumber: this.formatDialCodeAndLocalForApi(mobCode, mobNum)
        };
      })
    } as any;
  }

  


  private mapBankAccount(): Partial<VendorModel> {
    return {
      BankAccount: {
        name: this.bankAccountForm.get('bankName')?.value || null,
        accountNumber: this.bankAccountForm.get('accountNumber')?.value || null,
        bankIBAN: this.bankAccountForm.get('iban')?.value || null,
        swift: this.bankAccountForm.get('swiftCode')?.value || null,
        branch: this.bankAccountForm.get('branchName')?.value || null,
        beneficiaryName: this.bankAccountForm.get('benficeryName')?.value || null,
        email: this.bankAccountForm.get('email')?.value || null,
        address: this.bankAccountForm.get('address')?.value || null,
        currencyCode: this.bankAccountForm.get('currency')?.value || null,
        activeDate: this.bankAccountForm.get('ActiveDate')?.value || null,
        expiryDate: this.bankAccountForm.get('ExpiryDate')?.value || null,
        //sortCode: this.bankAccountForm.get('sortCode')?.value || null,
        bankCountry: this.bankAccountForm.get('bankCountry')?.value || null,
        bankCertificate: this.bankAccountForm.get('bankCertificate')?.value || null,
        otherBankName: this.bankAccountForm.get('otherBankName')?.value || null,




      }
    };
  }

  
  


  
  private async handlesubmission(backendVendor: any) {
    this._loaderService.showLoader();
    const apiService = this.createApiService();
    
   // const payload = this.prepareValidateUserRequestPayload(data);

   // const backendVendor = this.mapToBackendVendor(payload);

    // Capture existing bank documents first because saveDataToVendor replaces vendor.BankAccount
    // with the mapped form object, which has no Documents array
    const existingBankDocuments = this.vendor.BankAccount?.Documents || [];

    // Update vendor object with the submitted data before sending to API
    this.saveDataToVendor(backendVendor);
    
    const attachmentCopies = [...this.vendor.Attachments!]; // Copy the array of attachments
    const currentStepTitle = this.steps[this.currentTab]?.title;
    
    // Only get OtherDocuments data if OtherDocuments form exists and we're on Compliance & Ethics step
    let otherDocumentsData = null;
    if (this.OtherDocuments && currentStepTitle === 'Compliance & Ethics') {
      otherDocumentsData = this.OtherDocuments.getRawValue();
    }

    if (currentStepTitle === 'Compliance & Ethics' && otherDocumentsData) {
      backendVendor = {};
      backendVendor.Attachments = [];
      attachmentCopies.forEach((attachment) => {
        // Create a shallow copy of the individual attachment object
        const attachmentCopy = { ...attachment };
      
        // Set FileContent to empty in the copied attachment for backendVendor
        attachmentCopy.FileContent = '';
        attachmentCopy.DocumentExpiryDate = otherDocumentsData[attachment.AttachmentFor + 'Date'] 
            ? new Date(otherDocumentsData[attachment.AttachmentFor + 'Date']) 
            : undefined, // Changed from null to undefined
            
        // Push the copied attachment to backendVendor.Attachments
        backendVendor.Attachments?.push(attachmentCopy);
      });


      attachmentCopies.forEach((attachment) => {
        attachment.DocumentExpiryDate = otherDocumentsData[attachment.AttachmentFor + 'Date'] 
            ? new Date(otherDocumentsData[attachment.AttachmentFor + 'Date']) 
            : undefined // Changed from null to undefined
      });
  
 

    }

    // Get Supporting Documents data if supportingDocumentsForm exists and we're on Supporting Documents step
    let supportingDocumentsData = null;
    if (this.supportingDocumentsForm && currentStepTitle === 'Supporting Documents') {
      supportingDocumentsData = this.supportingDocumentsForm.getRawValue();
    }

    if (currentStepTitle === 'Supporting Documents' && supportingDocumentsData) {
      backendVendor = {};
      backendVendor.Attachments = [];
      
      // Get all document names from supportingDocumentsForm (excluding shared and per-file Date fields)
      const supportingDocumentNames = Object.keys(supportingDocumentsData).filter(key => !key.endsWith('Date') && !key.includes('Date__'));
      
      attachmentCopies.forEach((attachment) => {
        // Only process attachments that belong to Supporting Documents
        if (supportingDocumentNames.includes(attachment.AttachmentFor || '')) {
          const expiryControlName = this.isSupportingPerFileExpiryDocument(attachment.AttachmentFor || '')
            ? this.getSupportingPerFileExpiryControlName(attachment.AttachmentFor || '', attachment.Name)
            : attachment.AttachmentFor + 'Date';
          const expiryDateValue = supportingDocumentsData[expiryControlName];

          const documentExpiryDate = expiryDateValue 
              ? new Date(expiryDateValue) 
              : undefined;

          // Create a shallow copy with only FilePath and document expiry date (no FileContent/base64)
          const attachmentCopy: any = {
            FilePath: attachment.FilePath,
            DocumentExpiryDate: documentExpiryDate,
            documentExpiryDate: documentExpiryDate
          };
          
          // Push the copied attachment to backendVendor.Attachments
          backendVendor.Attachments?.push(attachmentCopy);
        }
      });

      // Update expiry dates in attachmentCopies for local tracking
      attachmentCopies.forEach((attachment) => {
        if (supportingDocumentNames.includes(attachment.AttachmentFor || '')) {
          const expiryControlName = this.isSupportingPerFileExpiryDocument(attachment.AttachmentFor || '')
            ? this.getSupportingPerFileExpiryControlName(attachment.AttachmentFor || '', attachment.Name)
            : attachment.AttachmentFor + 'Date';
          const expiryDateValue = supportingDocumentsData[expiryControlName];

          const documentExpiryDate = expiryDateValue 
              ? new Date(expiryDateValue) 
              : undefined;

          attachment.DocumentExpiryDate = documentExpiryDate;
          (attachment as any).documentExpiryDate = documentExpiryDate;
        }
      });
    }

    // Handle Financial Details data
    if (currentStepTitle === 'Financial Details') {
      // Convert currentYear to string if it's a number
      if (backendVendor.currentYear !== undefined && backendVendor.currentYear !== null) {
        backendVendor.currentYear = String(backendVendor.currentYear);
      }
      // Ensure annualTurnovers values are strings
      if (backendVendor.annualTurnovers && Array.isArray(backendVendor.annualTurnovers)) {
        backendVendor.annualTurnovers = backendVendor.annualTurnovers.map((turnover: any) => ({
          ...turnover,
          value: turnover.value !== undefined && turnover.value !== null ? String(turnover.value) : turnover.value
        }));
      }
    }
    
    // Handle Warehousing & Storage data
    if (currentStepTitle === 'Warehousing & Storage') {
      const warehousingStorageData = this.warehousingStorageForm?.getRawValue();
      if (warehousingStorageData) {
        backendVendor.warehousingStorageDetails = warehousingStorageData.warehousingStorageDetails || undefined;
        backendVendor.transportFreightForwardingDetails = warehousingStorageData.transportFreightForwardingDetails || undefined;
      }
    }

    // Handle Other Information data
    if (currentStepTitle === 'Other') {
      const otherInformationData = this.otherInformationForm?.getRawValue();
      if (otherInformationData) {
        backendVendor.otherInformation = otherInformationData.otherInformation || undefined;
      }
    }

    if (currentStepTitle === 'Banking Details') {
      // Get BankAccount from mapped data
      const bankAccountData = this.mapBankAccount();
      if (bankAccountData.BankAccount) {
        backendVendor.BankAccount = bankAccountData.BankAccount;

        const bankDocuments: any[] = [];

        // Keep existing documents on the local vendor model (replaced by saveDataToVendor above)
        if (this.vendor.BankAccount) {
          this.vendor.BankAccount.Documents = existingBankDocuments;
        }

        // Existing bank documents already stored on the vendor: send FilePath reference, no base64 re-send
        existingBankDocuments.forEach((doc) => {
          bankDocuments.push({
            AttachmentFor: doc.AttachmentFor,
            Name: doc.Name,
            FilePath: doc.FilePath,
            MimeType: doc.MimeType,
            FileContent: (doc.FileContent && !String(doc.FileContent).startsWith('http')) ? doc.FileContent : '',
            ProcessName: doc.ProcessName || DocumentProcessTypes.VendorBank.toString(),
            AttachmentId: doc.AttachmentId,
            ApplicationId: this.user?.Id || ''
          });
        });

        // Legacy bank certificates that were uploaded through the old Documents API flow
        attachmentCopies.forEach((attachment) => {
            if (attachment.AttachmentFor === 'bankCertificate'
                && !bankDocuments.some(doc => doc.Name === attachment.Name)) {
                bankDocuments.push({
                  AttachmentFor: attachment.AttachmentFor,
                  Name: attachment.Name,
                  FilePath: attachment.FilePath,
                  MimeType: attachment.MimeType,
                  FileContent: '' // Already uploaded - no base64
                });
            }
        });

        // New bank documents (both 'Document' and 'bankCertificate'): base64 content included
        // so the backend uploads them internally from the BankAccount object
        this.BankTempDocumentsArray.forEach((doc) => {
          bankDocuments.push({
            AttachmentFor: doc.AttachmentFor,
            Name: doc.Name,
            FileContent: doc.FileContent,
            MimeType: doc.MimeType,
            ProcessName: doc.ProcessName,
            AttachmentId: doc.AttachmentId || '0',
            ApplicationId: this.user?.Id || '',
            FilePath: doc.FilePath || ''
          });
        });

        backendVendor.BankAccount.Documents = bankDocuments;
      }
    }



      if (this.isLastTab()) {
        backendVendor.Status = VendorStatus.Submitted;
      }

    // Ensure currentYear is always a string if present (final check before sending)
    if (backendVendor.currentYear !== undefined && backendVendor.currentYear !== null && typeof backendVendor.currentYear !== 'string') {
      backendVendor.currentYear = String(backendVendor.currentYear);
    }

    this.fireValidateUserRequest(apiService, backendVendor)
    .then((response: any) => {
      let result = response as unknown as BaseResponseDTO;
      if(result.isSuccess) {

       if (currentStepTitle === 'Banking Details') {
         // Bank documents were persisted by UpdateVendor (inside BankAccount.Documents)
         this.BankTempDocumentsArray = [];
       }

       // this._userService.handleValidAuthentication(result);
       if (this.isLastTab()) {
        this._router.navigate( 
          [AppConstants.ROUTES.HOME],
          { state: { message: 'Application Submitted' } } 
        );
        this.notificationService.triggerGetNotifications(); // This will trigger the dropdown toggle
       } else {
         // Only increment tab if not last tab (last tab navigates away)
         this.currentTab++;
       }
      } else {
        this.formValidationService.setCustomError(this.confirmCheckboxControl, result.errorMessageEn);
        this.toastService.error(result.errorMessageEn || 'An error occurred. Please try again.');
      }
    })
    .catch((err: HttpErrorResponse) => {
      this.invalidSubmit = true;
      const msg = err?.error?.errorMessageEn || err?.error?.message || 'An error occurred. Please try again.';
      this.toastService.error(msg);
    })
    .finally(() => {
      // Always hide loader in finally block
      this._loaderService.hideLoader();
    });
  }



  getInvalidControls(): void {
    const invalidControls: string[] = [];
    
    Object.keys(this.GeneralFormTab.controls).forEach(key => {
      const control = this.GeneralFormTab.get(key);
      
      if (control && control.invalid) {
        invalidControls.push(key);
      }
    });
  }

  private getAllInvalidControls(formGroup: FormGroup | FormArray, parentPath: string = ''): string[] {
    const invalidControls: string[] = [];
    
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control) {
        const controlPath = parentPath ? `${parentPath}.${key}` : key;
        
        if (control.invalid) {
          if (control instanceof FormGroup || control instanceof FormArray) {
            const nestedErrors = this.getAllInvalidControls(control, controlPath);
            invalidControls.push(...nestedErrors);
          } else {
            const errors = control.errors;
            invalidControls.push(`${controlPath}: ${JSON.stringify(errors)}`);
          }
        } else if (control instanceof FormGroup || control instanceof FormArray) {
          // Recurse into valid nested groups/arrays to avoid missing any invalid leaf
          const nestedErrors = this.getAllInvalidControls(control, controlPath);
          invalidControls.push(...nestedErrors);
        }
      }
    });
    
    return invalidControls;
  }
  
 
  onNext(): void {
    this.isBackAction = false;
    const currentStepTitle = this.steps[this.currentTab]?.title;
  
    if (this.isLastTab()) {
      if (this.isAbleTBankApplication) {
        if (!this.isViewMode) {
          this.onSubmitForm(this.mapBankAccount());
        }
      } else {
        // if (this.OtherDocuments.valid || this.isViewMode) {
          if (!this.isViewMode) {
            const otherDocumentsData = this.OtherDocuments.getRawValue();
            this.onSubmitForm(otherDocumentsData);
          } else {
            this.currentTab++;
          }
        // } else {
        //   this.markFormGroupTouched(this.OtherDocuments);
        // }
      }
    } else if (currentStepTitle === 'PERSONAL INFORMATION') {
      if (!this.isViewMode) {
        // Mark form as touched to show validation errors
        this.markFormGroupTouched(this.personalInformationForm);
        
        // Check if form is valid before submission
        if (this.personalInformationForm.valid) {
          const data = this.mapPersonalInformation();
          this.saveDataToVendor(data);
          this.onSubmitForm(data);
        } else {
          // Form is invalid, show error message
          this.toastService.error('Please fill in all required fields.');
        }
      } else {
        this.currentTab++;
      }
    } else if (currentStepTitle === 'BUSINESS INFORMATION') {
      if (!this.isViewMode) {
        // Mark form as touched to show validation errors
        this.markFormGroupTouched(this.businessInformationForm);
        
        // Check if form is valid before submission
        if (this.businessInformationForm.valid) {
          const data = this.mapBusinessInformation();
          this.saveDataToVendor(data);
          this.onSubmitForm(data);
        } else {
          // Form is invalid, show error message
          this.toastService.error('Please fill in all required fields.');
        }
      } else {
        this.currentTab++;
      }
    } else if (currentStepTitle === 'TAX & LEGAL') {
      // All fields optional for Individual in TAX & LEGAL
      if (!this.isViewMode) {
        const data = this.mapTaxLegalInformation();
        this.saveDataToVendor(data);
        this.onSubmitForm(data);
        // currentTab++ will be handled in handlesubmission after API call succeeds
      } else {
        this.currentTab++;
      }
    } else if (currentStepTitle === 'ATTACHMENTS') {
      // ATTACHMENTS step for Individual - files are handled by upload component
      this.currentTab++;
    } else if (currentStepTitle === 'Supplier Information') {
      if (!this.isViewMode) {
        // Mark form as touched to show validation errors
        this.markFormGroupTouched(this.GeneralFormTab);
        
        // Check if form is valid before submission
        if (this.GeneralFormTab.valid && this.isTabOneValid()) {
          const data = this.mapGeneralForm();
          this.saveDataToVendor(data);
          this.onSubmitForm(data);
        } else {
          // Debug: log which controls are breaking validation
          const invalidList = this.getAllInvalidControls(this.GeneralFormTab);
          console.warn('[Supplier Information] Validation failed. Invalid controls:', invalidList);
          this.toastService.error('Please fill in all required fields.');
        }
      } else {
        this.currentTab++;
      }
    } else if (currentStepTitle === 'Company Ownership') {
      if (!this.isViewMode) {
        // Mark form as touched to show validation errors
        this.markFormGroupTouched(this.companyOwnershipForm);
        
        // Check if form is valid before submission
        if (this.companyOwnershipForm.valid) {
          const data = this.mapCompanyOwnership();
          this.saveDataToVendor(data);
          this.onSubmitForm(data);
        } else {
          this.toastService.error('Please fill in all required fields.');
        }
      } else {
        this.currentTab++;
      }
    } else if (currentStepTitle === 'Financial Details') {
      if (!this.isViewMode) {
        // Mark form as touched to show validation errors
        this.markFormGroupTouched(this.financialDetailsForm);
        
        // Check if form is valid before submission
        if (this.financialDetailsForm.valid) {
          const data = this.financialDetailsForm.getRawValue();
          // Convert currentYear to string if it's a number
          if (data.currentYear !== undefined && data.currentYear !== null) {
            data.currentYear = String(data.currentYear);
          }
          this.onSubmitForm(data);
        } else {
          this.toastService.error('Please fill in all required fields.');
        }
      } else {
        this.currentTab++;
      }
    } else if (currentStepTitle === 'Capability & Experience') {
      if (!this.isViewMode) {
        // Validate Categories and SubCategories
        const areCategoriesAndSubCategoriesValid = this.validateCategoriesAndSubCategories();
        
        // If isAuthorizedRepresentative is false, clear validators from authorizedRepresentatives
        const isAuthorizedRep = this.capabilityExperienceForm.get('isAuthorizedRepresentative')?.value;
        if (isAuthorizedRep === false) {
          // Clear all authorized representatives and their validators
          while (this.authorizedRepresentatives.length > 0) {
            this.authorizedRepresentatives.removeAt(0);
          }
        }
        
        // Mark form as touched to show validation errors
        this.markFormGroupTouched(this.capabilityExperienceForm);
        
        // Check if form is valid and categories/subcategories are selected
        if (this.capabilityExperienceForm.valid && areCategoriesAndSubCategoriesValid) {
          // Build final SubSubCategories array: include both actual SubSubCategory IDs and SubCategory IDs (that have no children)
          const finalSubSubCategories: string[] = [...this.selectedSubSubCategories];
          
          // Add SubCategory IDs that have no children (they are treated as leaf nodes)
          for (const category of this.categoryTree) {
            const categoryId = this.getCategoryId(category);
            const hasSubCategories = category.subCategories && category.subCategories.length > 0;

            // If a selected Category has no children, treat it as a leaf node.
            if (this.selectedProductCategories.includes(categoryId) && !hasSubCategories) {
              if (!finalSubSubCategories.includes(categoryId)) {
                finalSubSubCategories.push(categoryId);
              }
            }

            for (const subCategory of category.subCategories || []) {
              const subCategoryId = this.getSubCategoryId(subCategory);
              const hasSubSubCategories = subCategory.subSubCategories && subCategory.subSubCategories.length > 0;
              
              // If SubCategory is selected and has no children, add its ID to SubSubCategories
              if (this.selectedWorksCategories.includes(subCategoryId) && !hasSubSubCategories) {
                if (!finalSubSubCategories.includes(subCategoryId)) {
                  finalSubSubCategories.push(subCategoryId);
                }
              }
            }
          }
          
          // Ensure SubSubCategories is synced with form value
          this.capabilityExperienceForm.get('SubSubCategories')?.setValue(finalSubSubCategories);
          
          const data = this.capabilityExperienceForm.getRawValue();
          // Add Categories and SubCategories from selected arrays (not form fields)
          data.Categories = this.selectedProductCategories;
          data.SubCategories = this.selectedWorksCategories;
          // Ensure SubSubCategories includes both actual SubSubCategory IDs and SubCategory IDs (no children)
          data.SubSubCategories = finalSubSubCategories;
          this.onSubmitForm(data);
        } else {
          // Form is invalid, show error message
          if (!areCategoriesAndSubCategoriesValid) {
            this.toastService.error(
              this.subCategoriesValidationError ||
              this.categoriesValidationError ||
              'Please select at least one category and one subcategory.'
            );
          } else {
            this.toastService.error('Please fill in all required fields.');
          }
        }
      } else {
        this.currentTab++;
      }
    } else if (currentStepTitle === 'Compliance & Ethics') {
      if (!this.isViewMode) {
        // Mark form as touched to show validation errors
        this.markFormGroupTouched(this.OtherDocuments);
        
        // Check if form is valid before submission
        if (this.OtherDocuments.valid) {
          const otherDocumentsData = this.OtherDocuments.getRawValue();
          this.onSubmitForm(otherDocumentsData);
        } else {
          this.toastService.error('Please fill in all required fields.');
        }
      } else {
        this.currentTab++;
      }
    } else if (currentStepTitle === 'Supporting Documents') {
      if (!this.isViewMode && this.supportingDocumentsForm) {
        // Mark form as touched to show validation errors
        this.markFormGroupTouched(this.supportingDocumentsForm);
        
        // Check if form is valid before submission
        if (this.supportingDocumentsForm.valid) {
          const supportingDocumentsData = this.supportingDocumentsForm.getRawValue();
          this.onSubmitForm(supportingDocumentsData);
        } else {
          // Form is invalid, show error message
          this.toastService.error('Please fill in all required fields and ensure expiry dates are not in the past.');
        }
      } else {
        this.currentTab++;
      }
    } else if (currentStepTitle === 'Warehousing & Storage') {
      if (!this.isViewMode && this.warehousingStorageForm) {
        // Mark form as touched to show validation errors
        this.markFormGroupTouched(this.warehousingStorageForm);
        
        // Check if form is valid before submission
        if (this.warehousingStorageForm.valid) {
          const warehousingStorageData = this.warehousingStorageForm.getRawValue();
          this.onSubmitForm(warehousingStorageData);
        } else {
          this.toastService.error('Please fill in all required fields.');
        }
      } else {
        this.currentTab++;
      }
    } else if (currentStepTitle === 'Banking Details') {
      // Handle banking details
      if (!this.isViewMode && this.bankAccountForm) {
        // Mark form as touched to show validation errors
        this.markFormGroupTouched(this.bankAccountForm);
        
        // Check if form is valid before submission
        if (this.bankAccountForm.valid) {
          this.onSubmitForm(this.mapBankAccount());
        } else {
          const invalidList = this.getAllInvalidControls(this.bankAccountForm);
          const fieldNames = invalidList.map(s => s.split(':')[0].trim());
          console.warn('[Banking Details] Validation failed. Controls triggering the validation:', invalidList);
          this.toastService.error(`Please fill in all required fields. Invalid or missing: ${fieldNames.join(', ')}`);
        }
      } else {
        this.currentTab++;
      }
    } else if (currentStepTitle === 'Other') {
      if (!this.isViewMode && this.otherInformationForm) {
        // Mark form as touched to show validation errors
        this.markFormGroupTouched(this.otherInformationForm);
        
        // Check if form is valid before submission
        if (this.otherInformationForm.valid && this.confirmCheckboxControl.valid) {
          const otherInformationData = this.otherInformationForm.getRawValue();
          this.onSubmitForm(otherInformationData);
        } else {
          this.toastService.error('Please fill in all required fields and confirm the accuracy of information.');
        }
      } else {
        this.currentTab++;
      }
    }
  }
  

  

  onBack() {
    this.isBackAction = true;
    this.currentTab--;
    setTimeout(() => this.reloadFormDataFromVendor(), 0);
  }

  private saveDataToVendor(data: any): void {
    Object.assign(this.vendor, data);
    const v = this.vendor as any;
    ['subsidiaries', 'partners', 'seniorManagement', 'companyType'].forEach(key => {
      if (data[key]) v[key] = data[key];
    });
  }

  private reloadFormDataFromVendor(): void {
    const step = this.steps[this.currentTab]?.title;
    const v = this.vendor as any;

    if (step === 'Supplier Information' && this.GeneralFormTab) {
      const arr = this.GeneralFormTab.get('subsidiaries') as FormArray;
      arr.clear();
      const hasSubsidiariesData = v?.subsidiaries && Array.isArray(v.subsidiaries) && v.subsidiaries.length > 0;
      this.hasSubsidiaries = hasSubsidiariesData;
      (v?.subsidiaries?.length ? v.subsidiaries : [{}]).forEach((s: any) => arr.push(this.createSubsidiaryFormGroup(s, hasSubsidiariesData)));
      // For single selection, take first value if array, otherwise use string value
      let companyTypeValue = '';
      if (v?.companyType) {
        if (Array.isArray(v.companyType)) {
          companyTypeValue = v.companyType[0] || '';
        } else {
          companyTypeValue = String(v.companyType);
        }
      }
      this.selectedCompanyType = companyTypeValue;
      this.GeneralFormTab.get('companyType')?.setValue(companyTypeValue);
    } else if (step === 'Company Ownership' && this.companyOwnershipForm) {
      const partners = this.companyOwnershipForm.get('partners') as FormArray;
      const management = this.companyOwnershipForm.get('seniorManagement') as FormArray;
      partners.clear();
      management.clear();
      v?.partners?.forEach((p: any) => partners.push(this.createPartnerFormGroup(p)));
      // Use seniorManagement first; fall back to ManagementTeam (API often returns PascalCase)
      const managementSource = v?.seniorManagement && Array.isArray(v.seniorManagement) && v.seniorManagement.length > 0
        ? v.seniorManagement.map((m: any) => ({
            name: m.name || m.Name,
            title: m.title || m.Title,
            nationality: m.nationality || m.Nationality,
            email: m.email || m.Email,
            landlineNumber: m.landlineNumber || m.LandlineNumber || '',
            mobileNumber: m.mobileNumber || m.MobileNumber || ''
          }))
        : (v?.ManagementTeam && Array.isArray(v.ManagementTeam)
            ? v.ManagementTeam.map((m: any) => ({
                name: m.name || m.Name,
                title: m.title || m.Title,
                nationality: m.nationality || m.Nationality,
                email: m.email || m.Email,
                landlineNumber: m.landlineNumber || m.LandlineNumber || '',
                mobileNumber: m.mobileNumber || m.MobileNumber || ''
              }))
            : []);
      managementSource.forEach((m: any) => management.push(this.createSeniorManagementFormGroup(m)));
      const ownerNationalityValue = this.findCountryRegionId(v?.ownerNationality);
      this.companyOwnershipForm.patchValue({ ownerName: v?.ownerName || '', ownerNationality: ownerNationalityValue });
    }
  }

  onSave(): void {
    // Collect all form data and save to backend
    if (this.isViewMode) {
      return; // Don't save in view mode
    }

    this._loaderService.showLoader();
    const apiService = this.createApiService();
    
    // Collect all form data from all tabs
    const allVendorData = this.collectAllFormData();
    
    // Merge with existing vendor data
    const mergedVendorData = { ...this.vendor, ...allVendorData };
    
    // Ensure VendorID is set
    if (!mergedVendorData.VendorID && this._userService.user?.Id) {
      mergedVendorData.VendorID = this._userService.user.Id;
    }

    // Update vendor object with the collected data
    this.saveDataToVendor(mergedVendorData);

    // Prepare the payload for the API - convert to UpdateVendorRequestDTO structure
    const data = allVendorData as any;
    const vendorStatus = this.vendor?.Status?.toString?.();
    const isApprovedOrRejected = vendorStatus === VendorStatus.Approved || vendorStatus === VendorStatus.Rejected;
    // When vendor is Approved or Rejected, do not send email/mobile for contacts so backend does not update them (avoids duplicate check errors)
    const contactPersonPayload = data.contactPerson != null
      ? (Array.isArray(data.contactPerson)
          ? data.contactPerson.map((c: any) => isApprovedOrRejected
              ? { ...c, email: undefined, mobileNumber: undefined, mobile: undefined }
              : c)
          : isApprovedOrRejected
            ? { ...data.contactPerson, email: undefined, mobileNumber: undefined, mobile: undefined }
            : data.contactPerson)
      : undefined;
    const payload: Partial<UpdateVendorRequestDTO> = {
      // Basic fields
      vendorName: data.vendorName || data.VendorName || undefined,
      natureOfBusiness: data.natureOfBusiness || undefined,
      
      // Contact Person
      contactPerson: contactPersonPayload,
      
      // Address fields
      StreetPrimary: data.StreetPrimary || undefined,
      CityPrimary: data.CityPrimary || undefined,
      CountryRegionIdPrimary: data.CountryRegionIdPrimary || undefined,
      ZipCodePrimary: data.ZipCodePrimary || undefined,
      website: data.website || undefined,
      Email: data.Email || undefined,
      PhonePrimary: data.PhonePrimary || undefined,
      AddressDescriptionPrimary: data.AddressDescriptionPrimary || undefined,
      poBox: data.poBox || undefined,
      fax: data.fax || undefined,
      state: data.state || undefined,
      
      // Parent Company
      parentCompanyName: data.parentCompanyName || undefined,
      parentCompanyIsDifferent: data.parentCompanyIsDifferent !== undefined ? data.parentCompanyIsDifferent : undefined,
      parentCompanyPreviousName: data.parentCompanyPreviousName || undefined,
      
      // Establishment
      establishmentCountry: data.establishmentCountry || undefined,
      establishmentYear: data.establishmentYear !== undefined ? data.establishmentYear : undefined,
      noOfEmployees: data.noOfEmployees || undefined,
      
      // Additional Information
      financeEmail: data.financeEmail || undefined,
      commercialRegNumber: data.commercialRegNumber || undefined,
      chamberMembershipNumber: data.chamberMembershipNumber || undefined,
      importLicenseNumber: data.importLicenseNumber || undefined,
      isoCertification: data.isoCertification || undefined,
      
      
      // Subsidiaries
      subsidiaries: data.subsidiaries || undefined,
      
      // Company Ownership
      ownerName: data.ownerName || undefined,
      ownerNationality: data.ownerNationality || undefined,
      partners: data.partners || undefined,
      seniorManagement: data.seniorManagement || undefined,
      
      // Financial Details
      currency: data.currency || undefined,
      authorizedCapital: data.authorizedCapital || undefined,
      creditRating: data.creditRating || undefined,
      netProfit: data.netProfit || undefined,
      totalAssets: data.totalAssets || undefined,
      currentRatio: data.currentRatio || undefined,
      latestAnnualTurnover: data.latestAnnualTurnover || undefined,
      currentYear: data.currentYear || undefined,
      // Ensure annualTurnovers values are strings
      annualTurnovers: data.annualTurnovers ? data.annualTurnovers.map((turnover: any) => ({
        yearNumber: turnover.yearNumber,
        value: turnover.value !== null && turnover.value !== undefined ? String(turnover.value) : undefined
      })) : undefined,
      
      // Capability & Experience
      coreProductsServices: data.coreProductsServices || undefined,
      previousExperience: data.previousExperience || undefined,
      additionalInformation: data.additionalInformation || undefined,
      contractsProjectsDetails: data.contractsProjectsDetails || undefined,
      isAuthorizedRepresentative: data.isAuthorizedRepresentative !== undefined ? data.isAuthorizedRepresentative : undefined,
      authorizedRepresentatives: data.authorizedRepresentatives || undefined,
      Categories: data.Categories || undefined,
      Categories_Other: data.Categories_Other || undefined,
      SubCategories: data.SubCategories || undefined,
      SubCategories_Other: data.SubCategories_Other || undefined,
      SubSubCategories: data.SubSubCategories || undefined,
      
      // Warehousing & Storage
      warehousingStorageDetails: data.warehousingStorageDetails || undefined,
      transportFreightForwardingDetails: data.transportFreightForwardingDetails || undefined,
      
      // Other Information
      otherInformation: data.otherInformation || undefined,
      
      // Bank Account (without FileContent in Documents)
      BankAccount: data.BankAccount ? {
        name: data.BankAccount.name,
        accountNumber: data.BankAccount.accountNumber,
        bankIBAN: data.BankAccount.bankIBAN,
        swift: data.BankAccount.swift,
        branch: data.BankAccount.branch,
        beneficiaryName: data.BankAccount.beneficiaryName,
        email: data.BankAccount.email,
        address: data.BankAccount.address,
        currencyCode: data.BankAccount.currencyCode,
        activeDate: data.BankAccount.activeDate,
        expiryDate: data.BankAccount.expiryDate,
        bankCountry: data.BankAccount.bankCountry,
        otherBankName: data.BankAccount.otherBankName,
        // Documents without FileContent (only FilePath and metadata)
        Documents: data.BankAccount.Documents ? data.BankAccount.Documents.map((doc: any) => ({
          AttachmentFor: doc.AttachmentFor,
          Name: doc.Name,
          FilePath: doc.FilePath,
          MimeType: doc.MimeType,
          FileContent: '' // Explicitly set to empty, don't send base64
        })) : undefined
      } : undefined,
      
      // Attachments - handle separately
      Attachments: undefined
    };
    
    // Handle attachments - copy existing attachments and clear FileContent for update
    const attachmentCopies = this.vendor.Attachments ? [...this.vendor.Attachments] : [];
    const currentStepTitle = this.steps[this.currentTab]?.title;
    
    // Handle Compliance & Ethics documents expiry dates
    if (currentStepTitle === 'Compliance & Ethics' && this.OtherDocuments) {
      const otherDocumentsData = this.OtherDocuments.getRawValue();
      payload.Attachments = [];
      attachmentCopies.forEach((attachment) => {
        const attachmentCopy = { ...attachment };
        attachmentCopy.FileContent = ''; // Don't send file content on update
        attachmentCopy.DocumentExpiryDate = otherDocumentsData[attachment.AttachmentFor + 'Date'] 
          ? new Date(otherDocumentsData[attachment.AttachmentFor + 'Date']) 
          : undefined;
        payload.Attachments?.push(attachmentCopy);
      });
    } else if (currentStepTitle === 'Supporting Documents' && this.supportingDocumentsForm) {
      const supportingDocumentsData = this.supportingDocumentsForm.getRawValue();
      const supportingDocumentNames = Object.keys(supportingDocumentsData).filter(key => !key.endsWith('Date') && !key.includes('Date__'));

      payload.Attachments = attachmentCopies.map(attachment => {
        const attachmentCopy: any = {
          ...attachment,
          FileContent: '' // Don't send file content on update
        };

        if (supportingDocumentNames.includes(attachment.AttachmentFor || '')) {
          const expiryControlName = this.isSupportingPerFileExpiryDocument(attachment.AttachmentFor || '')
            ? this.getSupportingPerFileExpiryControlName(attachment.AttachmentFor || '', attachment.Name)
            : attachment.AttachmentFor + 'Date';
          const expiryDateValue = supportingDocumentsData[expiryControlName];
          const documentExpiryDate = expiryDateValue
            ? new Date(expiryDateValue)
            : undefined;

          attachmentCopy.DocumentExpiryDate = documentExpiryDate;
          attachmentCopy.documentExpiryDate = documentExpiryDate;
        }

        return attachmentCopy;
      });
    } else {
      // For other tabs, just copy attachments without file content
      payload.Attachments = attachmentCopies.map(attachment => ({
        ...attachment,
        FileContent: '' // Don't send file content on update
      }));
    }

    // Handle Banking Details - BankAccount is now included in the payload above

    // Set Status to Submitted when on the last tab (submitting the application)
    if (this.isLastTab()) {
      (payload as any).Status = VendorStatus.Submitted;
    }

    
    // Call UpdateVendor API
    this.fireValidateUserRequest(apiService, payload as any)
      .then((response: any) => {
        let result = response as unknown as BaseResponseDTO;
        if (result.isSuccess) {
          this.toastService.success('Vendor data saved successfully');
        } else {
          this.toastService.error(result.errorMessageEn || 'Failed to save vendor data');
        }
      })
      .catch((err: HttpErrorResponse) => {
        this.toastService.error('An error occurred while saving. Please try again.');
      })
      .finally(() => {
        this._loaderService.hideLoader();
      });
  }

  /**
   * Collects all form data from all tabs and merges them into a single vendor object
   */
  private collectAllFormData(): Partial<VendorModel> {
    const allData: any = {};

    // Collect data from Supplier Information tab
    if (this.GeneralFormTab) {
      const generalData = this.mapGeneralForm();
      Object.assign(allData, generalData);
    }

    // Collect data from Company Ownership tab
    if (this.companyOwnershipForm) {
      const ownershipData = this.mapCompanyOwnership();
      Object.assign(allData, ownershipData);
    }

    // Collect data from Financial Details tab
    if (this.financialDetailsForm) {
      const financialData = this.financialDetailsForm.getRawValue();
      // Map financial details to vendor model structure
      if (financialData.annualTurnovers) {
        // Convert annualTurnovers value to string if it's a number
        allData.annualTurnovers = financialData.annualTurnovers.map((turnover: any) => ({
          yearNumber: turnover.yearNumber,
          value: turnover.value !== null && turnover.value !== undefined ? String(turnover.value) : undefined
        }));
      }
      // Add other financial fields as needed
      Object.keys(financialData).forEach(key => {
        if (key !== 'annualTurnovers' && financialData[key] !== null && financialData[key] !== undefined) {
          allData[key] = financialData[key];
        }
      });
    }

    // Collect data from Capability & Experience tab
    if (this.capabilityExperienceForm) {
      const capabilityData = this.capabilityExperienceForm.getRawValue();
      if (capabilityData.authorizedRepresentatives) {
        allData.authorizedRepresentatives = capabilityData.authorizedRepresentatives;
      }
      // Categories and SubCategories are already using the correct names
      // Add other capability fields as needed
      Object.keys(capabilityData).forEach(key => {
        if (key !== 'authorizedRepresentatives' && capabilityData[key] !== null && capabilityData[key] !== undefined) {
          allData[key] = capabilityData[key];
        }
      });
    }

    // Collect data from Banking Details tab
    if (this.bankAccountForm) {
      const bankData = this.mapBankAccount();
      Object.assign(allData, bankData);
    }

    // Collect data from Compliance & Ethics tab
    if (this.OtherDocuments) {
      const otherDocumentsData = this.OtherDocuments.getRawValue();
      // Merge other documents data
      Object.keys(otherDocumentsData).forEach(key => {
        if (otherDocumentsData[key] !== null && otherDocumentsData[key] !== undefined) {
          allData[key] = otherDocumentsData[key];
        }
      });
    }

    // Collect data from Supporting Documents tab
    if (this.supportingDocumentsForm) {
      const supportingDocsData = this.supportingDocumentsForm.getRawValue();
      Object.keys(supportingDocsData).forEach(key => {
        if (supportingDocsData[key] !== null && supportingDocsData[key] !== undefined) {
          allData[key] = supportingDocsData[key];
        }
      });
    }

    // Collect data from Warehousing & Storage tab
    if (this.warehousingStorageForm) {
      const warehousingData = this.warehousingStorageForm.getRawValue();
      Object.keys(warehousingData).forEach(key => {
        if (warehousingData[key] !== null && warehousingData[key] !== undefined) {
          allData[key] = warehousingData[key];
        }
      });
    }

    // Collect data from Other Information tab
    if (this.otherInformationForm) {
      const otherInfoData = this.otherInformationForm.getRawValue();
      Object.keys(otherInfoData).forEach(key => {
        if (otherInfoData[key] !== null && otherInfoData[key] !== undefined) {
          allData[key] = otherInfoData[key];
        }
      });
    }

    return allData;
  }


  

  public addContact() {
    this.contacts.push(this._formBuilder.group({
      //id: [GUID.newGuid()],
      // qid: [null, [Validators.required, Validators.minLength(11), Validators.maxLength(11), Validators.pattern(/^\d+$/)]],
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],

      title: [null, Validators.required],
      email: [null, Validators.required],

      landlindeNumber: [null, Validators.required],
      mobileNumber: [null, Validators.required],
    }));

    // if (this._registrationForm.get('medicalCommissionRequestNumber')){
    //     this.contacts.controls.forEach((element,index)=>{
    //     // (this.contacts.controls[index] as FormGroup).get('requestNumber')?.reset();
    //     // (this.contacts.controls[index] as FormGroup).get('testDate')?.reset();
    //     (element as FormGroup).get('requestNumber')?.addValidators(Validators.required);
    //     (element as FormGroup).get('requestNumber')?.updateValueAndValidity();
    //     (element as FormGroup).get('testDate')?.addValidators(Validators.required);
    //     (element as FormGroup).get('testDate')?.updateValueAndValidity();
    //   });
    // }

  }

  onSubsidiariesToggle(value: boolean): void {
    this.hasSubsidiaries = value;
    const subsidiariesArray = this.GeneralFormTab.get('subsidiaries') as FormArray;
    
    if (value) {
      // If Yes, ensure at least one subsidiary exists
      if (!subsidiariesArray || subsidiariesArray.length === 0) {
        subsidiariesArray.push(this.createSubsidiaryFormGroup({}, true));
      } else {
        // Add validators to existing subsidiaries
        subsidiariesArray.controls.forEach((control) => {
          const subsidiary = control as FormGroup;
          subsidiary.get('subsidiaryName')?.setValidators(Validators.required);
          subsidiary.get('subsidiaryName')?.updateValueAndValidity();
          subsidiary.get('relationshipToParent')?.setValidators(Validators.required);
          subsidiary.get('relationshipToParent')?.updateValueAndValidity();
        });
      }
    } else {
      // If No, remove validators from all subsidiaries (but keep the data)
      if (subsidiariesArray) {
        subsidiariesArray.controls.forEach((control) => {
          const subsidiary = control as FormGroup;
          subsidiary.get('subsidiaryName')?.clearValidators();
          subsidiary.get('subsidiaryName')?.updateValueAndValidity();
          subsidiary.get('relationshipToParent')?.clearValidators();
          subsidiary.get('relationshipToParent')?.updateValueAndValidity();
        });
      }
    }
  }

  public addSubsidiary() {
    // Only add validators if hasSubsidiaries is true
    const addValidators = this.hasSubsidiaries;
    const newSubsidiary = this.createSubsidiaryFormGroup({}, addValidators);
    this.subsidiaries.push(newSubsidiary);
  }

  public deleteSubsidiary(index: number) {
    this.subsidiaries.removeAt(index);
  }


  public addPartner() {
    const partnerFormGroup = this._formBuilder.group({
      name: [null, Validators.required],
      percentageOfShare: [null, [Validators.required, Validators.pattern(/^[0-9]+(\.[0-9]+)?$/), this.maxPercentageValidator(100)]],
      nationality: [null, Validators.required],
    });
    this.partners.push(partnerFormGroup);
  }

  public deletePartner(index: number) {
    this.partners.removeAt(index);
  }

  public addSeniorManagement() {
    const managementFormGroup = this._formBuilder.group({
      name: [null, Validators.required],
      title: [null, Validators.required],
      nationality: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      phoneNumber: [null, Validators.required],
      phoneNumberCode: [this.defaultCountryCode],
      mobileNumber: [null],
      mobileNumberCode: [this.defaultCountryCode],
    });
    this.seniorManagement.push(managementFormGroup);
  }

  public deleteSeniorManagement(index: number) {
    this.seniorManagement.removeAt(index);
  }

  public addAnnualTurnover() {
    // Calculate the next year number (YR 5, YR 6, etc.)
    // Find the maximum year number and add 1
    let maxYearNumber = 0;
    this.annualTurnovers.controls.forEach(control => {
      const yearNumber = control.get('yearNumber')?.value || 0;
      if (yearNumber > maxYearNumber) {
        maxYearNumber = yearNumber;
      }
    });
    const nextYearNumber = maxYearNumber + 1;
    
    const annualTurnoverFormGroup = this._formBuilder.group({
      yearNumber: [nextYearNumber],
      value: ['', [Validators.required, this.validNumberValidator(), this.positiveNumberValidator(), this.maxCharacterLengthValidator(16)]]
    });
    this.annualTurnovers.push(annualTurnoverFormGroup);
  }

  public limitAnnualTurnoverLength(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    if (input.value.length <= 16) {
      return;
    }

    const truncatedValue = input.value.slice(0, 16);
    input.value = truncatedValue;
    this.annualTurnovers.at(index).get('value')?.setValue(truncatedValue);
  }

  public deleteAnnualTurnover(index: number) {    this.annualTurnovers.removeAt(index);
  }

  // Capability & Experience category toggle functions
  
  // Build tree structure from Categories, SubCategories, and SubSubCategories
  buildCategoryTree(): void {
    // Guard: Don't rebuild if Categories is empty or undefined
    if (!this.Categories || this.Categories.length === 0) {
      return; // Preserve existing tree structure
    }

    // Guard: Ensure SubCategories and SubSubCategories are initialized
    if (!this.SubCategories) {
      this.SubCategories = [];
    }
    if (!this.SubSubCategories) {
      this.SubSubCategories = [];
    }

    this.categoryTree = this.Categories.map((category: any) => {
      const categoryId = category.categoryId || category.categoryID || category.CategoryID || '';
      const subCategories = this.SubCategories.filter((sub: any) => {
        const subCategoryId = sub.categoryId || sub.categoryID || sub.CategoryID || '';
        return subCategoryId === categoryId;
      });
      
      return {
        ...category,
        categoryId: categoryId,
        description: category.description || category.Description || category.name || category.Name || '',
        subCategories: subCategories.map((sub: any) => {
          const subId = sub.subCategoryId || sub.subCategoryID || sub.SubCategoryID || '';
          // Find SubSubCategories for this SubCategory
          const subSubCategories = this.SubSubCategories.filter((subSub: any) => {
            const subSubParentId = subSub.subCategoryId || subSub.subCategoryID || subSub.SubCategoryID || '';
            return subSubParentId === subId;
          });
          
          return {
            ...sub,
            subCategoryId: subId,
            description: sub.description || sub.Description || sub.name || sub.Name || '',
            subSubCategories: subSubCategories.map((subSub: any) => ({
              ...subSub,
              subSubCategoryId: subSub.subSubCategoryId || subSub.subSubCategoryID || subSub.SubSubCategoryID || '',
              description: subSub.description || subSub.Description || subSub.name || subSub.Name || ''
            })),
            expanded: this.expandedSubCategories.has(subId)
          };
        }),
        expanded: this.expandedCategories.has(categoryId)
      };
    });
  }
  
  // Toggle expand/collapse for a category
  toggleCategoryExpand(categoryId: string): void {
    if (this.expandedCategories.has(categoryId)) {
      this.expandedCategories.delete(categoryId);
    } else {
      this.expandedCategories.add(categoryId);
    }
    // Update tree with new expanded state
    const category = this.categoryTree.find(cat => 
      (cat.categoryId || cat.categoryID || cat.CategoryID) === categoryId
    );
    if (category) {
      category.expanded = this.expandedCategories.has(categoryId);
    }
  }
  
  // Check if category is expanded
  isCategoryExpanded(categoryId: string): boolean {
    return this.expandedCategories.has(categoryId);
  }
  
  // Toggle expand/collapse for a subcategory
  toggleSubCategoryExpand(subCategoryId: string): void {
    if (this.expandedSubCategories.has(subCategoryId)) {
      this.expandedSubCategories.delete(subCategoryId);
    } else {
      this.expandedSubCategories.add(subCategoryId);
    }
    // Update tree with new expanded state - only rebuild if we have data
    if (this.Categories && this.Categories.length > 0) {
      this.buildCategoryTree();
    } else {
      // If Categories is empty, just update the expanded state in existing tree
      const categoryInTree = this.categoryTree.find(cat => 
        cat.subCategories?.some((sub: any) => this.getSubCategoryId(sub) === subCategoryId)
      );
      const subCategoryInTree = categoryInTree?.subCategories?.find((sub: any) => 
        this.getSubCategoryId(sub) === subCategoryId
      );
      if (subCategoryInTree) {
        subCategoryInTree.expanded = this.expandedSubCategories.has(subCategoryId);
      }
    }
  }
  
  // Check if a subcategory is expanded
  isSubCategoryExpanded(subCategoryId: string): boolean {
    return this.expandedSubCategories.has(subCategoryId);
  }
  
  // Get filtered SubCategories based on selected Categories
  getFilteredSubCategories(): any[] {
    if (!this.selectedProductCategories || this.selectedProductCategories.length === 0) {
      return [];
    }
    
    if (!this.SubCategories || this.SubCategories.length === 0) {
      return [];
    }
    
    // Filter SubCategories that belong to any of the selected Categories
    return this.SubCategories.filter((subCategory: any) => {
      const categoryId = subCategory.categoryId || subCategory.categoryID || subCategory.CategoryID || '';
      return this.selectedProductCategories.includes(categoryId);
    });
  }

  toggleProductCategorySelection(category: string | any): void {
    if (this.isViewMode) return;
    
    const categoryId = this.getCategoryId(category);
    const categoryInTree = this.categoryTree.find(cat => this.getCategoryId(cat) === categoryId);
    const hasSubCategories = categoryInTree?.subCategories && categoryInTree.subCategories.length > 0;
    const wasSelected = this.selectedProductCategories.includes(categoryId);
    this.selectedProductCategories = this.toggleSelection(this.selectedProductCategories, categoryId);
    this.availableSubCategories = this.getFilteredSubCategories();
    
    if (this.selectedProductCategories.includes(categoryId)) {
      if (hasSubCategories && !this.expandedCategories.has(categoryId)) {
        this.toggleCategoryExpand(categoryId);
      }
    }
    
    if (wasSelected && !this.selectedProductCategories.includes(categoryId)) {
      this.removeCategoryChildren(categoryId);
    }
    
    this.clearUnavailableSelections();

    // A Category without SubCategories is a leaf node, so persist its ID in SubSubCategories.
    if (this.selectedProductCategories.includes(categoryId) && !hasSubCategories) {
      if (!this.selectedSubSubCategories.includes(categoryId)) {
        this.selectedSubSubCategories = [...this.selectedSubSubCategories, categoryId];
      }
    } else if (!this.selectedProductCategories.includes(categoryId)) {
      this.selectedSubSubCategories = this.selectedSubSubCategories.filter(id => id !== categoryId);
    }
    this.capabilityExperienceForm.get('SubSubCategories')?.setValue(this.selectedSubSubCategories);

    this.updateCategoryOtherValidator();
    
    // Clear validation error when category is selected
    if (this.selectedProductCategories.length > 0) {
      this.categoriesValidationError = '';
    }
  }

  toggleWorksCategorySelection(category: string | any): void {
    if (this.isViewMode) return;
    
    const subCategoryId = this.getSubCategoryId(category);
    const wasSelected = this.selectedWorksCategories.includes(subCategoryId);
    const parentCategoryId = this.findParentCategoryId(category);
    
    // Find the SubCategory in the tree to check if it has children
    const categoryInTree = this.categoryTree.find(cat => 
      cat.subCategories?.some((sub: any) => this.getSubCategoryId(sub) === subCategoryId)
    );
    const subCategoryInTree = categoryInTree?.subCategories?.find((sub: any) => 
      this.getSubCategoryId(sub) === subCategoryId
    );
    
    const hasSubSubCategories = subCategoryInTree?.subSubCategories && subCategoryInTree.subSubCategories.length > 0;
    
    if (parentCategoryId) this.autoSelectParentCategory(parentCategoryId);
    
    this.selectedWorksCategories = this.toggleSelection(this.selectedWorksCategories, subCategoryId);
    
    if (this.selectedWorksCategories.includes(subCategoryId)) {
      // If SubCategory has no children, treat it as a leaf and add to SubSubCategories
      if (!hasSubSubCategories) {
        // Add SubCategory ID to SubSubCategories (treating it as a leaf)
        if (!this.selectedSubSubCategories.includes(subCategoryId)) {
          this.selectedSubSubCategories.push(subCategoryId);
          this.capabilityExperienceForm.get('SubSubCategories')?.setValue(this.selectedSubSubCategories);
        }
      } else {
        // If it has children, expand it and require at least one child to be selected
        if (!this.expandedSubCategories.has(subCategoryId)) {
          this.toggleSubCategoryExpand(subCategoryId);
        }
      }
    }
    
    if (wasSelected && !this.selectedWorksCategories.includes(subCategoryId)) {
      // Remove SubCategory ID from SubSubCategories if it was there (no children case)
      if (!hasSubSubCategories) {
        this.selectedSubSubCategories = this.selectedSubSubCategories.filter(id => id !== subCategoryId);
        this.capabilityExperienceForm.get('SubSubCategories')?.setValue(this.selectedSubSubCategories);
      }
      this.removeSubCategoryChildren(subCategoryId);
    }
    
    if (wasSelected && parentCategoryId) this.autoDeselectParentCategory(parentCategoryId);
    
    // Clear validation error when subcategory is selected
    if (this.selectedWorksCategories.length > 0) {
      this.subCategoriesValidationError = '';
    }
  }

  isProductCategorySelected(category: string | any): boolean {
    return this.selectedProductCategories.includes(this.getCategoryId(category));
  }

  isWorksCategorySelected(category: string | any): boolean {
    return this.selectedWorksCategories.includes(this.getSubCategoryId(category));
  }

  // Helper: Extract subSubCategory ID from various formats
  private getSubSubCategoryId(subSubCategory: string | any): string {
    if (typeof subSubCategory === 'string') return subSubCategory;
    return subSubCategory?.subSubCategoryId || subSubCategory?.subSubCategoryID || subSubCategory?.SubSubCategoryID || subSubCategory?.id || subSubCategory;
  }

  // Toggle SubSubCategory selection
  toggleSubSubCategorySelection(subSubCategory: string | any): void {
    if (this.isViewMode) return;
    
    const subSubCategoryId = this.getSubSubCategoryId(subSubCategory);
    const wasSelected = this.selectedSubSubCategories.includes(subSubCategoryId);
    
    // Find parent SubCategory
    let parentSubCategoryId: string | null = null;
    if (typeof subSubCategory === 'object' && subSubCategory?.subCategoryId) {
      parentSubCategoryId = this.getSubCategoryId(subSubCategory);
    } else {
      const subSub = this.SubSubCategories.find(s => this.getSubSubCategoryId(s) === subSubCategoryId);
      if (subSub) {
        parentSubCategoryId = subSub.subCategoryId || subSub.subCategoryID || subSub.SubCategoryID || null;
      }
    }
    
    // Auto-select parent SubCategory and Category if needed
    if (parentSubCategoryId && !this.selectedWorksCategories.includes(parentSubCategoryId)) {
      // Find the SubCategory in tree to check if it has children
      const categoryInTree = this.categoryTree.find(cat => 
        cat.subCategories?.some((sub: any) => this.getSubCategoryId(sub) === parentSubCategoryId)
      );
      const subCategoryInTree = categoryInTree?.subCategories?.find((sub: any) => 
        this.getSubCategoryId(sub) === parentSubCategoryId
      );
      
      // Only auto-select parent if it has children (SubSubCategories)
      // If it has no children, it should be selected directly via toggleWorksCategorySelection
      if (subCategoryInTree?.subSubCategories && subCategoryInTree.subSubCategories.length > 0) {
        this.toggleWorksCategorySelection({ subCategoryId: parentSubCategoryId, categoryId: this.findParentCategoryId({ subCategoryId: parentSubCategoryId }) });
      }
    }
    
    // Toggle subSubCategory selection
    this.selectedSubSubCategories = this.toggleSelection(this.selectedSubSubCategories, subSubCategoryId);
    
    // Remove parent SubCategory ID from SubSubCategories if it was there (no children case)
    // This ensures we don't have both the parent SubCategory ID and its children IDs
    if (parentSubCategoryId && this.selectedSubSubCategories.includes(parentSubCategoryId)) {
      this.selectedSubSubCategories = this.selectedSubSubCategories.filter(id => id !== parentSubCategoryId);
    }
    
    this.capabilityExperienceForm.get('SubSubCategories')?.setValue(this.selectedSubSubCategories);
    
    // Auto-deselect parent SubCategory if all subSubCategories removed
    if (wasSelected && parentSubCategoryId) {
      const subSubCategoriesForParent = this.SubSubCategories.filter(s => 
        (s.subCategoryId || s.subCategoryID || s.SubCategoryID) === parentSubCategoryId
      );
      const hasSelected = this.selectedSubSubCategories.some(id => 
        subSubCategoriesForParent.some(s => this.getSubSubCategoryId(s) === id)
      );
      
      if (!hasSelected && this.selectedWorksCategories.includes(parentSubCategoryId)) {
        this.selectedWorksCategories = this.selectedWorksCategories.filter(id => id !== parentSubCategoryId);
        
        // Check if parent category should be deselected
        const parentCategoryId = this.findParentCategoryId({ subCategoryId: parentSubCategoryId });
        if (parentCategoryId) {
          this.autoDeselectParentCategory(parentCategoryId);
        }
      }
    }
  }

  // Check if SubSubCategory is selected
  isSubSubCategorySelected(subSubCategory: string | any): boolean {
    return this.selectedSubSubCategories.includes(this.getSubSubCategoryId(subSubCategory));
  }

  // Validate Categories and SubCategories
  validateCategoriesAndSubCategories(): boolean {
    // Clear previous errors
    this.categoriesValidationError = '';
    this.subCategoriesValidationError = '';

    // Validate Categories
    if (!this.selectedProductCategories || this.selectedProductCategories.length === 0) {
      this.categoriesValidationError = 'Please select at least one category.';
    }

    // A selected Category without children is already a valid leaf selection.
    const hasSelectedLeafCategory = this.categoryTree.some(category =>
      this.selectedProductCategories.includes(this.getCategoryId(category)) &&
      (!category.subCategories || category.subCategories.length === 0)
    );

    // Validate SubCategories when no selected Category is itself a leaf.
    if ((!this.selectedWorksCategories || this.selectedWorksCategories.length === 0) && !hasSelectedLeafCategory) {
      this.subCategoriesValidationError = 'Please select at least one subcategory.';
      return false;
    }

    // Validate that if a Category has SubCategories, at least one SubCategory is selected
    // And if a SubCategory has SubSubCategories, at least one SubSubCategory is selected
    for (const category of this.categoryTree) {
      const categoryId = this.getCategoryId(category);
      if (this.selectedProductCategories.includes(categoryId)) {
        const hasSubCategories = category.subCategories && category.subCategories.length > 0;
        if (hasSubCategories) {
          // Check if at least one SubCategory of this Category is selected
          const hasSelectedSubCategory = category.subCategories.some((sub: any) => 
            this.selectedWorksCategories.includes(this.getSubCategoryId(sub))
          );
          if (!hasSelectedSubCategory) {
            this.subCategoriesValidationError = `Please select at least one subcategory under "${category.description}".`;
            return false;
          }
        }
      }
    }

    // Validate that if a SubCategory has SubSubCategories, at least one SubSubCategory is selected
    for (const category of this.categoryTree) {
      for (const subCategory of category.subCategories || []) {
        const subCategoryId = this.getSubCategoryId(subCategory);
        if (this.selectedWorksCategories.includes(subCategoryId)) {
          const hasSubSubCategories = subCategory.subSubCategories && subCategory.subSubCategories.length > 0;
          if (hasSubSubCategories) {
            // Check if at least one SubSubCategory of this SubCategory is selected
            const hasSelectedSubSubCategory = subCategory.subSubCategories.some((subSub: any) => 
              this.selectedSubSubCategories.includes(this.getSubSubCategoryId(subSub))
            );
            if (!hasSelectedSubSubCategory) {
              this.subCategoriesValidationError = `Please select at least one item under "${subCategory.description}".`;
              return false;
            }
          }
        }
      }
    }
    return !this.categoriesValidationError && !this.subCategoriesValidationError;
  }

  // Check if Categories and SubCategories are valid
  isCategoriesAndSubCategoriesValid(): boolean {
    return this.validateCategoriesAndSubCategories();
  }

  // Check if "Other" category is selected
  hasOtherCategorySelected(): boolean {
    if (this.selectedProductCategories.includes('Other')) {
      return true;
    }
    if (this.Categories && this.Categories.length > 0) {
      return this.Categories.some((c: any) => {
        const desc = (c.description || c.Description || '').toLowerCase();
        return desc === 'other' && this.isProductCategorySelected(c);
      });
    }
    return false;
  }

  // Check if "Other" subcategory is selected
  hasOtherSubCategorySelected(): boolean {
    if (this.selectedWorksCategories.includes('Other')) {
      return true;
    }
    if (this.availableSubCategories && this.availableSubCategories.length > 0) {
      return this.availableSubCategories.some((s: any) => {
        const desc = (s.description || s.Description || '').toLowerCase();
        return desc === 'other' && this.isWorksCategorySelected(s);
      });
    }
    return false;
  }

  // Check if "Other" exists in Categories from API
  hasOtherInCategories(): boolean {
    if (!this.Categories || this.Categories.length === 0) {
      return false;
    }
    return this.Categories.some((c: any) => {
      const desc = (c.description || c.Description || '').toLowerCase();
      return desc === 'other';
    });
  }

  // Check if "Other" exists in availableSubCategories
  hasOtherInSubCategories(): boolean {
    if (!this.availableSubCategories || this.availableSubCategories.length === 0) {
      return false;
    }
    return this.availableSubCategories.some((s: any) => {
      const desc = (s.description || s.Description || '').toLowerCase();
      return desc === 'other';
    });
  }

  getCategoryFieldName(category: string, type: 'product' | 'works'): string {
    return `${type}Category_${category.replace(/\s+/g, '_')}`;
  }

  getCategoryFieldId(category: string, type: 'product' | 'works'): string {
    return `${type}Category_${category.replace(/\s+/g, '_')}`;
  }

  public addAuthorizedRepresentative() {
    const representativeFormGroup = this._formBuilder.group({
      company: ['', Validators.required],
      poBox: ['', Validators.required],
      telNo: ['', Validators.required],
      faxNo: [''],
      productsRepresented: ['', Validators.required],
      productsRepresentedFile: ['', Validators.required]
    });
    this.authorizedRepresentatives.push(representativeFormGroup);
  }

  getAuthorizedRepresentativeFileControl(index: number): FormControl {
    const representative = this.authorizedRepresentatives.at(index) as FormGroup;
    return representative?.get('productsRepresentedFile') as FormControl || new FormControl('');
  }

  public deleteAuthorizedRepresentative(index: number) {
    this.authorizedRepresentatives.removeAt(index);
  }

  RemoveFilesFromBackend(Index : any) {

    const attachmentToRemove = this.vendor.Attachments![Index];
    attachmentToRemove.FileContent = '';
    const apiService = this.createApiService();
  
    this._loaderService.showLoader();
  
    return new Promise((resolve, reject) => {
        this.fireDeletePostDocuments(apiService, attachmentToRemove)
       .then((result: any) => {
         let response: BaseResponseDTO = result;
  
         if (response?.isSuccess){
          this.vendor.Attachments?.splice(Index, 1); // Remove the attachment from the vendor.Attachments array
          this.toastService.success('Attachments were successfully removed'); 
         }
         resolve(response);
  
       }).catch((err: HttpErrorResponse) => {
           this._loaderService.hideLoader();
           this.toastService.error('Something went wrong'); 
       }).finally(() =>{
           this._loaderService.hideLoader();
       });
  
    });
  
   }



// Helper function to upload the TempDocumentsArray to the backend using firePostDocuments
uploadFileToBackend(): Promise<any> {
  const apiService = this.createApiService(); // Ensure service is created
  return new Promise((resolve, reject) => {
    // Use the TempDocumentsArray for the payload
    this.firePostDocuments(apiService, this.TempDocumentsArray)
      .then((response: any) => {
        // Check if the response is successful and contains data
        if (response?.isSuccess && Array.isArray(response?.data) && response?.data.length > 0) {
          resolve(response.data); // Resolve with the array of documents from the response
        } else {
          // If not successful or no data, reject with a meaningful message
          const errorMessage = response?.errorMessageEn || 'File upload failed: No valid response from server.';
          this.handleBackendFailure();

          reject(new Error(errorMessage));
        }
      })
      .catch((error: any) => {
        // Handle and log any other errors during the process
        reject(new Error('File upload failed due to an unexpected error.'));
      });
  });
}

  

handleBackendFailure() {
  // Remove files on backend failure from both the file upload component and vendor.Attachments
  this.TempDocumentsArray.forEach(attachment => {
    // Find the corresponding file upload component
    const fileUploadComponent = this.findFileUploadComponent(attachment.AttachmentFor!);
    if (fileUploadComponent) {
      // Find the file in the uploadedFiles array of the file upload component
      const fileToRemove = fileUploadComponent.uploadedFiles.find(file => file.name === attachment.Name);
      if (fileToRemove) {
        fileUploadComponent.removeFile(fileToRemove);  // Call removeFile method to remove from UI
      }
    }

    // Remove the file from vendor.Attachments array
    const attachmentIndex = this.vendor.Attachments?.findIndex(att => att.Name === attachment.Name);
    if (attachmentIndex !== undefined && attachmentIndex > -1) {
      this.vendor.Attachments?.splice(attachmentIndex, 1); // Remove the attachment from vendor.Attachments array
    }
  });

  // Clear the TempDocumentsArray since we are handling failure
  this.TempDocumentsArray = [];
}



    
  public onSubmitUpdateRequest() : Promise<BaseResponseDTO> {


    const apiService = this.createApiService();

    let GeneralFormInputsValues = this.GeneralFormTab.getRawValue();
    GeneralFormInputsValues.vendorID = this._userService.user?.Id;
    GeneralFormInputsValues.contactPerson = this.contacts.getRawValue();




    this._loaderService.showLoader();

    return new Promise((resolve, reject) => {
        this.firePutDynamicServiceRequest(apiService, GeneralFormInputsValues)
       .then((result: any) => {
         let response: BaseResponseDTO = result;

         if (response?.isSuccess){
           this._dialogService.showDialog('Vendor Applicaiton','You have successfully submiited the application',IconType.Success); 
         }
         resolve(response);

       }).catch((err: HttpErrorResponse) => {
           this._loaderService.hideLoader();
           this._dialogService.showDialog('Vendor Applicaiton','Something went wrong',IconType.Error); 
       }).finally(() =>{
           this._loaderService.hideLoader();
       });

    });

  }

  private firePutDynamicServiceRequest(apiService: ApiService, payload: any) {
    let req$ = apiService.put(AppConstants.CONTROLLERS.VENDOR, AppConstants.ACTIONS.UPDATEVENDOR, true, environment.APIs_PREFIX, payload);
    return lastValueFrom(req$);
  }


  private firePostDocuments(apiService: ApiService, payload: any ) {
    let req$ = apiService.post(AppConstants.CONTROLLERS.Documents, AppConstants.ACTIONS.UploadDocumnets, true, environment.APIs_PREFIX, payload);
    return lastValueFrom(req$);
  }


  private fireDeletePostDocuments(apiService: ApiService, payload: any ) {
    let req$ = apiService.post(AppConstants.CONTROLLERS.Documents, AppConstants.ACTIONS.RemoveDocument, true, environment.APIs_PREFIX, payload);
    return lastValueFrom(req$);
  }

  /**
   * Get field label with currency suffix based on selected currency
   * @param baseLabel The base label text (e.g., "Authorized Capital")
   * @returns Label with currency suffix or default text
   */
  getFinancialFieldLabel(baseLabel: string): string {
    if (!this.financialDetailsForm) {
      return `${baseLabel} (QAR/ USD)`;
    }
    
    const currencyId = this.financialDetailsForm.get('currency')?.value;
    
    if (!currencyId) {
      return `${baseLabel} (QAR/ USD)`;
    }
    
    // Find currency from Currencies array
    const currency = this.Currencies.find(c => c.currencyId === currencyId);
    
    if (currency && currency.currencyId) {
      return `${baseLabel} (${currency.currencyId})`;
    } else {
      return `${baseLabel} (QAR/ USD)`;
    }
  }

  /**
   * Calculate the year for a given year number based on Current Year
   * This method is called from template and will automatically update when currentYear changes
   * @param yearNumber The year number (1, 2, 3, etc.)
   * @returns The calculated year in parentheses or empty string if Current Year is not set
   */
  getYearForTurnover(yearNumber: number): string {
    if (!this.financialDetailsForm || !yearNumber) {
      return '';
    }
    
    const currentYearControl = this.financialDetailsForm.get('currentYear');
    if (!currentYearControl) {
      return '';
    }
    
    const currentYear = currentYearControl.value;
    
    // Validate current year
    if (!currentYear || isNaN(Number(currentYear)) || Number(currentYear) <= 0) {
      return '';
    }
    
    const calculatedYear = Number(currentYear) - yearNumber;
    
    // Only show year if it's a positive number
    return calculatedYear > 0 ? `(${calculatedYear})` : '';
  }

  /**
   * Increment current year by 1 (max 2025)
   */
  incrementYear(): void {
    if (!this.financialDetailsForm || this.isViewMode) return;
    const control = this.financialDetailsForm.get('currentYear');
    if (!control) return;
    const year = Number(control.value) || 2025;
    if (year >= 2025) return;
    control.setValue(Math.min(year + 1, 2025));
  }

  /**
   * Decrement current year by 1
   */
  decrementYear(): void {
    if (!this.financialDetailsForm || this.isViewMode) return;
    const control = this.financialDetailsForm.get('currentYear');
    if (!control) return;
    const year = Number(control.value) || 2025;
    control.setValue(Math.max(year - 1, 1900));
  }

  /**
   * Start long press - execute once immediately, then repeat after 300ms if still pressed
   */
  startLongPress(action: 'increment' | 'decrement'): void {
    this.stopLongPress();
    // Execute once immediately for single click
    action === 'increment' ? this.incrementYear() : this.decrementYear();
    // Then start repeating after 300ms if still pressed
    this.yearInterval = setTimeout(() => {
      this.yearInterval = setInterval(() => action === 'increment' ? this.incrementYear() : this.decrementYear(), 100);
    }, 300);
  }

  /**
   * Stop long press
   */
  stopLongPress(): void {
    if (this.yearInterval) {
      clearTimeout(this.yearInterval);
      clearInterval(this.yearInterval);
      this.yearInterval = null;
    }
  }

  isMaxYear(): boolean {
    return (this.financialDetailsForm?.get('currentYear')?.value || 2025) >= 2025;
  }

  /**
   * Prevent typing in Current Year field
   * @param event Keyboard event
   */
  preventTyping(event: KeyboardEvent): void {
    // Allow: backspace, delete, tab, escape, enter, arrow keys
    const allowedKeys = [
      'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
      'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight',
      'Home', 'End'
    ];
    
    // Allow Ctrl/Cmd + A, C, V, X, Z
    if (event.ctrlKey || event.metaKey) {
      if (['a', 'c', 'v', 'x', 'z'].includes(event.key.toLowerCase())) {
        return;
      }
    }
    
    // Block all other keys (numbers, letters, etc.)
    if (!allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  /**
   * Load tree selections from SubSubCategories array
   * This method derives parent Categories and SubCategories from selected SubSubCategories
   * @param subSubCategoryIds Array of SubSubCategory IDs from vendor data
   */
  private loadTreeSelectionsFromSubSubCategories(subSubCategoryIds: string[]): void {
    if (!subSubCategoryIds || subSubCategoryIds.length === 0) {
      // No SubSubCategories to load
      this.selectedSubSubCategories = [];
      this.selectedWorksCategories = [];
      this.selectedProductCategories = [];
      this.availableSubCategories = [];
      return;
    }

    // Set selected SubSubCategories
    this.selectedSubSubCategories = [...subSubCategoryIds];
    
    // Update form control
    this.capabilityExperienceForm.get('SubSubCategories')?.setValue(this.selectedSubSubCategories);

    // Find parent SubCategories for each selected SubSubCategory
    // Note: Some IDs might be SubCategory IDs (with no children) rather than actual SubSubCategory IDs
    const selectedSubCategoryIds = new Set<string>();
    const selectedCategoryIds = new Set<string>();

    subSubCategoryIds.forEach((id: string) => {
      // A Category with no SubCategories is stored directly as a leaf ID.
      const leafCategory = this.categoryTree.find(category =>
        this.getCategoryId(category) === id &&
        (!category.subCategories || category.subCategories.length === 0)
      );
      if (leafCategory) {
        selectedCategoryIds.add(id);
        return;
      }

      // First, check if this ID is actually a SubCategory ID (with no children)
      let isSubCategoryId = false;
      for (const category of this.categoryTree) {
        for (const subCategory of category.subCategories || []) {
          const subCategoryId = this.getSubCategoryId(subCategory);
          const hasSubSubCategories = subCategory.subSubCategories && subCategory.subSubCategories.length > 0;
          
          if (subCategoryId === id && !hasSubSubCategories) {
            // This is a SubCategory ID with no children
            isSubCategoryId = true;
            selectedSubCategoryIds.add(subCategoryId);
            const categoryId = this.getCategoryId(category);
            if (categoryId) {
              selectedCategoryIds.add(categoryId);
            }
            break;
          }
        }
        if (isSubCategoryId) break;
      }
      
      // If not a SubCategory ID, treat it as a SubSubCategory ID
      if (!isSubCategoryId) {
        // Find the SubSubCategory in our data
        const subSubCategory = this.SubSubCategories.find((subSub: any) => {
          const subSubId = this.getSubSubCategoryId(subSub);
          return subSubId === id;
        });

        if (subSubCategory) {
          // Get parent SubCategory ID
          const subCategoryId = subSubCategory.subCategoryId || subSubCategory.subCategoryID || subSubCategory.SubCategoryID || '';
          if (subCategoryId) {
            selectedSubCategoryIds.add(subCategoryId);

            // Find parent Category for this SubCategory
            const subCategory = this.SubCategories.find((sub: any) => {
              const subId = this.getSubCategoryId(sub);
              return subId === subCategoryId;
            });

            if (subCategory) {
              // Get parent Category ID
              const categoryId = subCategory.categoryId || subCategory.categoryID || subCategory.CategoryID || '';
              if (categoryId) {
                selectedCategoryIds.add(categoryId);
              }
            }
          }
        }
      }
    });

    // Set selected arrays
    this.selectedWorksCategories = Array.from(selectedSubCategoryIds);
    this.selectedProductCategories = Array.from(selectedCategoryIds);

    // Update available SubCategories based on selected Categories
    this.availableSubCategories = this.getFilteredSubCategories();

    // Rebuild tree structure
    this.buildCategoryTree();

    // Auto-expand categories and subcategories that have selected items
    selectedCategoryIds.forEach((catId: string) => {
      const categoryInTree = this.categoryTree.find(cat => 
        (cat.categoryId || cat.categoryID || cat.CategoryID) === catId
      );
      if (categoryInTree && categoryInTree.subCategories && categoryInTree.subCategories.length > 0) {
        // Check if any subcategory of this category is selected
        const hasSelectedSubcategory = categoryInTree.subCategories.some((sub: any) => {
          const subId = sub.subCategoryId || sub.subCategoryID || sub.SubCategoryID || '';
          return selectedSubCategoryIds.has(subId);
        });
        if (hasSelectedSubcategory) {
          this.expandedCategories.add(catId);
        }
      }
    });

    // Auto-expand subcategories that have selected subsubcategories
    selectedSubCategoryIds.forEach((subCatId: string) => {
      const categoryInTree = this.categoryTree.find(cat => 
        cat.subCategories?.some((sub: any) => this.getSubCategoryId(sub) === subCatId)
      );
      const subCategoryInTree = categoryInTree?.subCategories?.find((sub: any) => 
        this.getSubCategoryId(sub) === subCatId
      );
      if (subCategoryInTree && subCategoryInTree.subSubCategories && subCategoryInTree.subSubCategories.length > 0) {
        // Check if any subsubcategory of this subcategory is selected
        const hasSelectedSubSubcategory = subCategoryInTree.subSubCategories.some((subSub: any) => {
          const subSubId = this.getSubSubCategoryId(subSub);
          return subSubCategoryIds.includes(subSubId);
        });
        if (hasSelectedSubSubcategory) {
          this.expandedSubCategories.add(subCatId);
        }
      }
    });

    // Rebuild tree with expanded state
    this.buildCategoryTree();

    
    // In view mode, ensure all selected items are expanded so they're visible
    if (this.isViewMode) {
      setTimeout(() => this.expandAllSelectedItemsInViewMode(), 100);
    }
  }

  /**
   * Ensure all selected categories and subcategories are expanded in view mode
   * This makes it easier to see what was selected
   */
  private expandAllSelectedItemsInViewMode(): void {
    if (!this.isViewMode || !this.categoryTree || this.categoryTree.length === 0) return;
    
    // Expand all categories that have selected subcategories
    this.selectedProductCategories.forEach(categoryId => {
      const categoryInTree = this.categoryTree.find(cat => 
        (cat.categoryId || cat.categoryID || cat.CategoryID) === categoryId
      );
      if (categoryInTree && categoryInTree.subCategories && categoryInTree.subCategories.length > 0) {
        // Check if any subcategory of this category is selected
        const hasSelectedSubcategory = categoryInTree.subCategories.some((sub: any) => {
          const subId = sub.subCategoryId || sub.subCategoryID || sub.SubCategoryID || '';
          return this.selectedWorksCategories.includes(subId);
        });
        if (hasSelectedSubcategory) {
          this.expandedCategories.add(categoryId);
        }
      }
    });
    
    // Expand all subcategories that have selected sub-subcategories
    this.selectedWorksCategories.forEach(subCategoryId => {
      const categoryInTree = this.categoryTree.find(cat => 
        cat.subCategories?.some((sub: any) => this.getSubCategoryId(sub) === subCategoryId)
      );
      const subCategoryInTree = categoryInTree?.subCategories?.find((sub: any) => 
        this.getSubCategoryId(sub) === subCategoryId
      );
      if (subCategoryInTree && subCategoryInTree.subSubCategories && subCategoryInTree.subSubCategories.length > 0) {
        // Check if any sub-subcategory of this subcategory is selected
        const hasSelectedSubSubcategory = subCategoryInTree.subSubCategories.some((subSub: any) => {
          const subSubId = this.getSubSubCategoryId(subSub);
          return this.selectedSubSubCategories.includes(subSubId);
        });
        if (hasSelectedSubSubcategory) {
          this.expandedSubCategories.add(subCategoryId);
        }
      }
    });
    
    // Rebuild tree with expanded state
    this.buildCategoryTree();
  }

}


